import type { TranslationDictionary } from '@eliadmin/core/src/i18n/translation-snapshot-types';

export const GENERATED_TRANSLATIONS = Object.freeze({
  "text1": "Suchen",
  "text2": "Ihre Bestellung",
  "text3": "Adresse",
  "text4": "Guten Tag",
  "text5": "für die Bestellung",
  "text6": "wir erwarten die Zahlung mittels Bankübeweisung.",
  "text7": "Bestellung zugestellt",
  "text8": "Ihre Bestellung wurde erfolgreich zugestellt.",
  "text9": "Die Parameter",
  "text10": "Facebook",
  "text11": "Bestellung verschickt",
  "text12": "ist auf dem Weg zu Ihnen.",
  "text13": "Detailstatus Ihrer Sendung können Sie nach dem Klicken auf die Sendungsnummer verfolgen.",
  "text14": "Sendungsverfolgungsnummer:",
  "text15": "vielen Dank für Ihren Einkauf",
  "text16": "Wir registrieren Ihre Bestellung unter der Nummer",
  "text17": "Bestelldetail",
  "text18": "erstellt:",
  "text19": "Code",
  "text20": "Produkt",
  "text21": "Einzelpreis",
  "text22": "Menge",
  "text23": "Gesamtpreis",
  "text24": "Rabatt",
  "text25": "Rabatte",
  "text26": "Gesamtbetrag",
  "text27": "Zahlungsdaten",
  "text28": "IBAN",
  "text29": "Geldinstitut",
  "text30": "Betrag",
  "text31": "Verwendungszweck",
  "text32": "Zustelladresse",
  "text33": "Vorname",
  "text34": "Nachname",
  "text35": "E-Mail",
  "text36": "Telefon",
  "text37": "Handelsname",
  "text38": "Straße, Hausnummer",
  "text39": "Stadt",
  "text40": "PLZ",
  "text41": "Staat",
  "text42": "ID-Nr.",
  "text43": "Steuer-ID-Nr.",
  "text44": "Steuer-ID-Nr.",
  "text45": "Rechnungsadresse",
  "text46": "Bestellung storniert",
  "text47": "wurde storniert.",
  "text48": "Zahlung eingegangen",
  "text49": "wurde bezahlt.",
  "text50": "Der Status der Bestellung kann auch nach dem Einloggen in das Benutzerkonto verfolgt werden.",
  "text51": "bei meinem Konto anmelden",
  "text52": "retournierte Bestellung",
  "text53": "wurde retourniert",
  "text54": "Gelderstattung",
  "text55": "für die Bestellung",
  "text56": "Ihr Geld wurde zurückerstattet.",
  "text57": "Anmerkung",
  "text58": "Transportpreis",
  "text59": "Zahlungspreis",
  "text60": "ähnliche Produkte",
  "text61": "beliebte Produkte",
  "text62": "Bestellung wurde angenommen",
  "text63": "Bestellung",
  "text64": "Mwst.",
  "text65": "Nr.",
  "text66": "ist auf dem Weg zu Ihnen.",
  "text67": "Registrierung erfolgreich.",
  "text68": "Ihre Registrierung wurde erfolgreich.",
  "text69": "Generiertes Passwort:",
  "text70": "Nach der Anmeldung empfehlen wir, Ihr Passwort zu ändern.",
  "text71": "Sie können sich in Ihr Konto einloggen im Teil",
  "text72": "Benutzerkonto",
  "text73": "oder durch Anklicken des Login-Buttons",
  "text74": "In mein Konto einloggen",
  "text75": "MEINE E-MAIL:",
  "text76": "LINK ZU GÜNSTIGEREM PRODUKT:",
  "text77": "LINK ZU IHREM PRODUKT:",
  "text78": "Alles Gute zum Geburtstag.",
  "text79": "LINK ZUM PRODUKT:",
  "text80": "Nachricht:",
  "text81": "Betreff",
  "text82": "Kontaktformular",
  "text83": "als Zeichen des Vertrauens senden wir Ihnen einen Rebattcoupon zu",
  "text84": "in der Höhe von",
  "text85": "Der Gutschein ist gültig ab",
  "text86": "bis",
  "text87": "Newsletter",
  "text88": "Klicken Sie auf die Schaltfläche unten, um Ihr Abonnement für den Newsletter zu bestätigen.",
  "text89": "Abonnement für den Newsletter bestätigen",
  "text90": "Bestätigung von Artikeln",
  "text91": "Wir haben Ihre Rücksendung angenommen. Vielen Dank. Das Geld ist bereits auf dem Weg zu Ihnen. Die Rückerstattungsmethode hängt von der Zahlungsmethode ab, die Sie bei der Bestellung gewählt haben.",
  "text92": "Wenn Ihre Produktinformationen, die Sie von Ihrem Benutzerkonto gemeldet haben, von den zurückgegebenen Produkten abweichen, behalten wir uns das Recht vor, den bereits bezahlten Betrag erneut von Ihrer Kreditkarte abzubuchen.",
  "text93": "Bitte beachten Sie, dass jedes zurückgegebene Paket separat bearbeitet wird. Sollten Sie weitere Produkte in einem anderen Paket verschickt haben, erhalten Sie eine gesonderte Empfangsbestätigung.",
  "text94": "Zurückgegebene Produkte:",
  "text95": "Klicken Sie auf die Schaltfläche unten, um Ihr Passwort zurückzusetzen.",
  "text96": "Passwort zurücksetzen",
  "text97": "Die Zahlung der Bestellung wurde nicht korrekt durchgeführt",
  "text98": "Sie können Ihre Zahlung wiederholen",
  "text99": "Wenn Sie auf diesen Link klicken, gelangen Sie zum Zahlungsgateway.",
  "text100": "Vielen Dank für Ihre Bestellung",
  "text101": "Frage",
  "text102": "Frage zum Produkt:",
  "text103": "Rücksendeanfrage",
  "text104": "Wir haben Ihre Rücksendeanfrage erhalten. Sie können mit der Vorbereitung des Pakets beginnen.",
  "text105": "Wir erstatten Ihnen Ihr Geld umgehend nach Erhalt der Retoure, spätestens jedoch innerhalb von 14 Tagen.",
  "text106": "Haben Sie Ware per Vorkasse bestellt? Wenn Sie die Ware noch nicht bezahlt haben, werden wir den zu zahlenden Betrag so anpassen, dass er die von Ihnen zurückgesendete Ware nicht enthält.",
  "text107": "Sie geben zurück:",
  "text108": "Bestellnummer",
  "text109": "Ihre Reklamation wurde storniert",
  "text110": "Ihre Reklamation wurde nicht bestätigt",
  "text111": "Grund",
  "text112": "Ihre Reklamation is in Bearbeitung",
  "text113": "Ausgestellt von",
  "text114": "Seite 1/1",
  "text115": "Passwortänderung",
  "text116": "Rechnung",
  "text117": "Lieferant",
  "text118": "Betrieb",
  "text119": "Käufer",
  "text120": "Tel.",
  "text121": "Ausstellungsdatum",
  "text122": "Lieferdatum",
  "text123": "Fälligkeit",
  "text124": "Zahlungsart",
  "text125": "Lieferart",
  "text126": "SWIFT",
  "text127": "Zahlungsgebühren",
  "text128": "Artikel / Code",
  "text129": "Grundpreis / Rabatt",
  "text130": "MwSt.-Satz",
  "text131": "Anzahl",
  "text132": "Gesamt mit Mwst.",
  "text133": "Preis incl. Mwst.",
  "text134": "Versandgebühren",
  "text135": "Steuerbescheinigung für die erhaltene Zahlung.",
  "text136": "Gesamt ohne MwSt.",
  "text137": "Mehrwertsteuer insgesamt",
  "text138": "Insgesamt",
  "text139": "Konstantes Symbol",
  "text140": "Zu erstattender Betrag",
  "text141": "Gutschrift",
  "text142": "zur Rechnung",
  "text143": "Lieferschein",
  "text144": "Lieferschein Nr.",
  "text145": "Verkauft von",
  "text146": "Empfangen von",
  "text147": "Datum",
  "text148": "Angaben zur Mehrwertsteuer (EUR)",
  "text149": "Mehrwertsteuersatz",
  "text150": "Produkte",
  "text151": "Rechnung Nr.",
  "text152": "Einzelheiten (EUR)",
  "text153": "Versand",
  "text154": "Bestellungen",
  "text155": "Best.-Nr.",
  "text156": "Kunde",
  "text157": "Adresse",
  "text158": "Zahlung",
  "text159": "Vorschussrechnung Nr.",
  "text160": "Home",
  "text161": "Blog",
  "text162": "Suchbegriff...",
  "text163": "Einkaufswagen",
  "text164": "Preis",
  "text165": "Insgesamt",
  "text166": "Einkaufswagen Update",
  "text167": "Rabatt-Gutscheine",
  "text168": "Bestellung abschicken",
  "text169": "Zusammenfassung der Bestellung",
  "text170": "Produkt Preis",
  "text171": "Einkaufswagen ist leer",
  "text172": "Shop",
  "text173": "Produkte",
  "text174": "Filter",
  "text175": "Hersteller",
  "text176": "Kategorie",
  "text177": "Billigste",
  "text178": "Teuerste",
  "text179": "Neueste",
  "text180": "Älteste",
  "text181": "Meistverkaufte Produkte",
  "text182": "Abonnieren",
  "text183": "Ihre E-Mail Adresse",
  "text184": "Melden Sie sich jetzt für unseren Newsletter an und profitieren Sie von exklusiven Vorteilen!",
  "text185": "Senden",
  "text186": "Kontakt",
  "text187": "Passwort ändern",
  "text188": "Haben Sie Ihr Passwort vergessen?",
  "text189": "Einloggen",
  "text190": "Anmeldung",
  "text191": "Passwort",
  "text192": "Registrieren",
  "text193": "Sie haben noch kein Konto?",
  "text194": "Oops... die Seite, die Sie suchen, existiert nicht.",
  "text195": "Hersteller",
  "text196": "Weitere Produkte anzeigen",
  "text197": "Mein Konto",
  "text198": "Persönliche Angaben",
  "text199": "Angaben zum Unternehmen",
  "text200": "Unternehmen",
  "text201": "Speichern Sie",
  "text202": "Altes Passwort",
  "text203": "Neues Passwort",
  "text204": "Passwort ändern",
  "text205": "Vollständiger Artikel",
  "text206": "Ihre Bestellung wurde angenommen, leider war die Zahlung nicht erfolgreich. Bitte prüfen Sie Ihre E-Mail, um weitere Informationen über den Status Ihrer Bestellung zu erhalten.",
  "text207": "Bestellung bezahlen",
  "text208": "Weiter einkaufen",
  "text209": "Das könnte Sie interessieren",
  "text210": "Kaufen",
  "text211": "Suche",
  "text212": "Gegenstand(e)",
  "text213": "Suche",
  "text214": "Lieferung am nächsten Tag",
  "text215": "Innerhalb der Tschechischen Republik",
  "text216": "Kostenloses Geschenk",
  "text217": "Mit jeder Bestellung",
  "text218": "Liefergarantie",
  "text219": "unbeschädigte Waren",
  "text220": "300 Lieferstellen",
  "text221": "in der Slowakei und in der Tschechischen Republik",
  "text222": "Neueste Produkte",
  "text223": "Top-Produkte",
  "text224": "Top-Artikel",
  "text225": "Preis mit Mehrwertsteuer",
  "text226": "Preis ohne Mehrwertsteuer",
  "text227": "In den Warenkorb legen",
  "text228": "Produkt-Code:",
  "text229": "Teilen",
  "text230": "Kategorie:",
  "text231": "Beschreibung des Produkts",
  "text232": "Zubehör",
  "text233": "Zusätzliche Informationen",
  "text234": "Newsletter, den Sie bereits abonniert haben",
  "text235": "Weiter einkaufen",
  "text236": "Sie haben sich erfolgreich für unseren Newsletter angemeldet",
  "text237": "Verfügbarkeit:",
  "text238": "Vorrätig",
  "text239": "Zur Bestellung verfügbar",
  "text240": "Über uns",
  "text241": "Filter",
  "text242": "Produkte",
  "text243": "Sortieren nach:",
  "text244": "Filter zurücksetzen",
  "text245": "Status der Bestellung",
  "text246": "Zurück",
  "text247": "Größe:",
  "text248": "Stück",
  "text249": "EUR",
  "text250": "Avatar ändern",
  "text251": "Sie haben sich erfolgreich angemeldet",
  "text252": "Männlich",
  "text253": "Frau",
  "text254": "Andere",
  "text255": "Geschlecht",
  "text256": "Hallo",
  "text257": "Meine Bestellungen",
  "text258": "Abmelden",
  "text259": "Ihre E-Mail eingeben",
  "text260": "Ständige Anmeldung",
  "text261": "Registrierung",
  "text262": "Ein neues Konto registrieren",
  "text263": "Passwort wiederholen",
  "text264": "Ich stimme zu mit",
  "text265": "Bedingungen und Konditionen",
  "text266": "Ich habe bereits ein Konto und möchte mich anmelden",
  "text267": "Informationen über Cookies",
  "text268": "Wenn Sie auf die Schaltfläche \"Ich stimme allem zu\" klicken, werden technische, analytische und Marketing-Cookies gespeichert, um Ihnen eine bequeme Nutzung der Website zu ermöglichen, die Funktionalität unserer Website zu messen und Werbung gezielt an Sie zu richten. Sie können Ihre Einstellungen ganz einfach anpassen, indem Sie auf Cookie-Einstellungen klicken.",
  "text269": "Ich bin mit allem einverstanden",
  "text270": "Cookie-Einstellungen",
  "text271": "Einstellungen speichern",
  "text272": "Schließen",
  "text273": "Cookies",
  "text274": "Beschreibung",
  "text275": "Wir verwenden Cookies",
  "text276": "Wir verwenden Cookies, um Daten über unsere Besucher zu analysieren, unsere Website zu verbessern, personalisierte Inhalte anzuzeigen und Ihnen ein optimales Web-Erlebnis zu bieten. Durch die Nutzung dieser Website erklären Sie sich mit dieser Verwendung einverstanden.",
  "text277": "Technische Cookies",
  "text278": "Diese Cookies sind für das Funktionieren der Website erforderlich und können nicht deaktiviert werden. Sie werden in der Regel als Reaktion auf eine Aktion gesetzt, die Sie auf der Website durchführen, wie z. B. die Einstellung der Sicherheit, das Einloggen und das Ausfüllen von Formularen. Sie können Ihren Browser so einstellen, dass er Cookies blockiert oder Benachrichtigungen über sie sendet. Denken Sie daran, dass einige Websites ohne diese Dateien nicht funktionieren. Diese Cookies speichern keine Informationen, die sich einer bestimmten Person zuordnen lassen. Diese Cookies können von uns oder von Drittanbietern gesetzt werden, deren Dienste wir auf der Website nutzen. In diesen Cookies werden keine Informationen gespeichert, die einer bestimmten Person zugeordnet werden können.",
  "text279": "Ihre Cookie-Einstellungen in diesem Dialog",
  "text280": "Analytische Cookies",
  "text281": "Diese Cookies werden verwendet, um das Funktionieren der Website zu verbessern. Sie ermöglichen es uns, die Anzahl der Besucher zu erkennen und zu verfolgen und zu beobachten, wie die Besucher die Website nutzen. Sie helfen uns, die Funktionsweise der Website zu verbessern, z. B. indem sie es den Nutzern erleichtern, das zu finden, was sie suchen. Diese Cookies sammeln keine Informationen, die Sie identifizieren könnten. Wir verwenden diese Tools, um die Funktionalität unserer Website zu analysieren und regelmäßig zu verbessern. Wir können die von uns gesammelten Statistiken verwenden, um die Nutzererfahrung zu verbessern und Ihren Besuch auf der Website für Sie als Nutzer interessanter zu gestalten.",
  "text282": "Google Analytics - speichert und zählt die Anzahl der Seitenaufrufe und das Verhalten auf der Website",
  "text283": "Google Tag Manager - zur Verknüpfung von Konversionen",
  "text284": "Incomaker - speichert und zählt Seitenaufrufe und Konversionen",
  "text285": "Marketing-Cookies",
  "text286": "Sie werden verwendet, um die Präferenzen eines Nutzers auf der Website zu verfolgen, um Werbung gezielt zu platzieren, d. h. Marketing- und Werbebotschaften (auch auf Websites Dritter) anzuzeigen, die für den Website-Besucher von Interesse sein könnten, und zwar entsprechend diesen Präferenzen. Marketing-Cookies verwenden Tools von externen Unternehmen. Diese Marketing-Cookies werden nur mit Ihrer Zustimmung verwendet.",
  "text287": "Facebook Pixel - Anzeigenschaltung und Übermittlung von Informationen an Facebook",
  "text288": "Hochladen",
  "text289": "Umtausch von Waren",
  "text290": "Erstattungen",
  "text291": "Details zum Kunden",
  "text292": "Rechnungsnummer",
  "text293": "Bankverbindung",
  "text294": "IBAN",
  "text295": "SWIFT",
  "text296": "Grund für die Erstattung",
  "text297": "Wählen Sie den Artikel aus der Liste aus, den Sie zurückgeben möchten",
  "text298": "E-shop",
  "text299": "Steinladen",
  "text300": "E-shop + Steinladen",
  "text301": "Wir haben Ihren Rücksendeantrag erhalten. Sie können mit der Vorbereitung Ihres Pakets beginnen.",
  "text302": "Wir erstatten Ihnen Ihr Geld sofort nach Erhalt der Rücksendung, spätestens jedoch innerhalb von 14 Tagen.",
  "text303": "Haben Sie Waren per Vorkasse bestellt? Wenn Sie die Ware noch nicht bezahlt haben, werden wir den zu zahlenden Betrag anpassen, um Ihre Rücksendung auszuschließen.",
  "text304": "Rückgabe:",
  "text305": "Bestellnummer:",
  "text306": "Wir haben Ihre Rücksendung angenommen. Wir danken Ihnen vielmals. Das Geld ist auf dem Weg zu Ihnen. Die Art der Rückerstattung hängt von der Zahlungsmethode ab, die Sie bei Ihrer Bestellung gewählt haben.",
  "text307": "Sollten die von Ihnen gemeldeten Produktdaten von den zurückgesandten Produkten abweichen, behalten wir uns das Recht vor, Ihre Kreditkarte erneut mit dem bereits bezahlten Betrag zu belasten.",
  "text308": "Bitte beachten Sie, dass jedes zurückgesandte Paket separat bearbeitet wird. Wenn Sie zusätzliche Produkte in einem anderen Paket verschickt haben, erhalten Sie eine separate Quittung.",
  "text309": "Zurückgegebene Produkte:",
  "text310": "Neu",
  "text311": "Genehmigt",
  "text312": "Abgelehnt",
  "text313": "Storniert",
  "text314": "In Bearbeitung",
  "text315": "Antrag auf Erstattung",
  "text316": "Bestätigung der Positionen",
  "text317": "Ihr Antrag wurde annulliert",
  "text318": "Wir bearbeiten Ihren Anspruch",
  "text319": "Ihr Antrag wurde nicht genehmigt",
  "text320": "Ihre Anfrage wurde noch nicht bearbeitet",
  "text321": "Newsletter",
  "text322": "/Umtausch-und-ruckgabe-von-waren",
  "text323": "Umtausch und Rückgabe von Waren",
  "text324": "Angaben zum Unternehmen",
  "text325": "Domain Ihres Shops",
  "text326": "Eine weitere Domain hinzufügen",
  "text327": "Mehr Domains",
  "text328": "Name des Unternehmens",
  "text329": "Geschäftsadresse hinzufügen",
  "text330": "Geschäftsadresse",
  "text331": "Name des Geschäfts",
  "text332": "Login-Name",
  "text333": "Anhänge",
  "text334": "Auszug aus dem Handelsregister",
  "text335": "Anhang auswählen",
  "text336": "Ich stimme den Bedingungen und Konditionen zu",
  "text337": "Unterkategorien",
  "text338": "Mehr anzeigen",
  "text339": "Verfügbarkeit",
  "text340": "Preis",
  "text341": "Filtern nach",
  "text342": "hr ausgewähltes Produkt wurde in den Warenkorb gelegt.",
  "text343": "Wagen",
  "text344": "Zahlungswert",
  "text345": "Versandpreis",
  "text346": "Versandart auswählen",
  "text347": "Kupon-Nummer",
  "text348": "Zahlungsmethode auswählen",
  "text349": "Kostenlos",
  "text350": "Zusammenfassung der Bestellung",
  "text351": "Preis der Waren",
  "text352": "Die Bestellung wurde versandt",
  "text353": "Ihre Bestellnummer.",
  "text354": "wurde aufgenommen und wird derzeit bearbeitet. Bitte überprüfen Sie Ihre E-Mail",
  "text355": "für weitere Informationen zu Ihrer Bestellung",
  "text356": "Bestätigen Sie das Passwort",
  "text357": "Einloggen",
  "text358": "Haben Sie ein Konto?",
  "text359": "Einzelheiten zur Lieferung",
  "text360": "Kontaktangaben",
  "text361": "Kauf an Unternehmen",
  "text362": "Erstellen Sie ein Konto und genießen Sie die Vorteile eines registrierten Kunden.",
  "text363": "Ich stimme den Bedingungen und Konditionen zu.",
  "text364": "Ich stimme den Datenschutzbestimmungen zu.",
  "text365": "Die Lieferadresse weicht von der Rechnungsadresse ab",
  "text366": "Dropshipping",
  "text367": "Betriebsadresse",
  "text368": "Persönliche Dateneinstellungen",
  "text369": "Lieferadresse ändern",
  "text370": "Weiter zur Kasse",
  "text371": "Abonnieren Sie unseren Newsletter und erhalten Sie aktuelle Informationen über Sonderangebote",
  "text372": "Rückgabe von Artikeln",
  "text373": "Zurückgegebene Waren",
  "text374": "Was würden Sie gerne zurückgeben?",
  "text375": "Sie haben in den letzten 30 Tagen nichts bestellt.",
  "text376": "Bestätigen Sie Produktrückgaben",
  "text377": "Abbrechen",
  "text378": "mein-konto-zuruckgegebene-waren",
  "text379": "mein-konto-rückgabe-1",
  "text380": "mein-konto-rückgabe-2",
  "text381": "mein-konto-rückgabe-3",
  "text382": "Slowakei",
  "text383": "Tschechische Republik",
  "text384": "Ungarn",
  "text385": "Details zur Anmeldung",
  "text386": "Mehr lesen",
  "text387": "In Ihrem Warenkorb",
  "text388": "Um ein vergessenes Passwort wiederherzustellen, geben Sie Ihre E-Mail-Adresse ein",
  "text389": "Geburtsdatum",
  "text390": "Verwenden Sie",
  "text391": "/allgemeine-geschaftsbedingungen",
  "text392": "/schutz-von-persoenlichen-agenturen",
  "text393": "Datum der Bestellung",
  "text394": "Bestellnummer",
  "text395": "Grund auswählen",
  "text396": "Die Ware stimmt nicht mit der Beschreibung überein",
  "text397": "Ich habe das falsche Produkt erhalten",
  "text398": "Der Artikel gefällt mir nicht",
  "text399": "Der Artikel ist zu groß",
  "text400": "Der Artikel ist beschädigt",
  "text401": "Produkt kam spät an",
  "text402": "Das Produkt ist zu klein",
  "text403": "Das Produkt ist zu teuer",
  "text404": "Keine Details",
  "text405": "Rückkehr nach",
  "text406": "Unternehmen(sartikel)",
  "text407": "Artikel, die Sie an das Unternehmen zurückgeben",
  "text408": "Wir haben Ihnen eine Liste der zurückgegebenen Produkte geschickt an",
  "text409": "Ihre Produkte sind bereit für die Rückgabe",
  "text410": "Was nun?",
  "text411": "Bereiten Sie Ihr Paket vor",
  "text412": "Jetzt müssen Sie das Paket nur noch abschicken",
  "text413": "Erhalten Sie Ihr Geld zurück",
  "text414": "Verpacken Sie die gewünschten Produkte, bringen Sie das Rücksendeetikett und die Rücksendeadresse an der Sendung an. Und wussten Sie, dass Sie Waren, die in mehreren Paketen geliefert wurden, zusammen in einem Paket zurücksenden können? Fügen Sie einfach Rücksendeetiketten von jeder Bestellung hinzu",
  "text415": "Bringen Sie das Paket zum nächstgelegenen Logistikzentrum, das Sie im Formular ausgewählt haben",
  "text416": "Wir erstatten Ihnen Ihr Geld sofort nach Erhalt Ihrer Rücksendung, spätestens jedoch 14 Tage danach. Haben Sie Ware per Vorkasse bestellt? Wenn Sie die Ware noch nicht bezahlt haben, werden wir den zu zahlenden Betrag so anpassen, dass er die von Ihnen zurückgesendete Ware nicht enthält",
  "text417": "Anzahl der Produkte",
  "text418": "An Gesellschaft retournieren",
  "text419": "Status",
  "text420": "Erstellt am",
  "text421": "Sie haben keine retournierte Ware.",
  "text422": "Legen Sie Ihre IBAN und SWIFT in den Kontoeinstellungen fest.",
  "text423": "Sie haben keine Bankdaten festgelegt",
  "text424": "Kaufen Sie für weitere",
  "text425": "und Sie erhalten den Versand",
  "text426": "GRATIS",
  "text427": "Herzlichen Glückwunsch, Sie haben den Versand",
  "text428": "Ihre Nachricht wurde erfolgreich versandt!",
  "text429": "Fehler, Ihre Nachricht wurde nicht gesendet!",
  "text430": "",
  "text431": "Email existiert; bitte verwenden Sie eine andere.",
  "text432": "Registration erfolgreich.",
  "text433": "Variantencode",
  "text434": "mein-konto-rückgabe-1",
  "text435": "Verkaufseinheit",
  "text436": "Datenschutzbestimmungen",
  "text437": "Etiketten",
  "text438": "Hausnummer",
  "text439": "Laden",
  "text440": "Wählen Sie einen Abonnementpunkt",
  "text441": "Variante auswählen",
  "text442": "Zu den Favoriten hinzufügen",
  "text443": "ohne MwSt.",
  "text444": "Preis ist ein Richtwert",
  "text445": "Keine Ergebnisse",
  "text446": "Fragen Sie nach einem Produkt",
  "text447": "Bewertungen",
  "text448": "Zusätzliche Dienstleistungen",
  "text449": "Pakete",
  "text450": "Versenden",
  "text451": "Video",
  "text452": "Vollständige Beschreibung",
  "text453": "Leider haben wir nur eine begrenzte Menge dieses Produkts auf Lager",
  "text454": "Sie können keine Artikel mehr in den Warenkorb legen.",
  "text455": "OK",
  "text456": "Zum Warenkorb gehen",
  "text457": "",
  "text458": "Ihr Einkaufswagen wartet auf Sie",
  "text459": "Sie haben Ihre Bestellung bei Ihrem letzten Besuch nicht abgeschlossen. Die von Ihnen ausgewählten Waren warten in Ihrem Warenkorb auf Sie. Verpassen Sie sie nicht und schließen Sie Ihren Einkauf jetzt ab.",
  "text460": "Ihre Bestellung wurde erfolgreich empfangen. Bitte überprüfen Sie Ihren E-Mail-Posteingang.",
  "text461": "Ihre Nachricht wurde erfolgreich versendet!",
  "text462": "E-Mail ist Pflichtaufgabe.",
  "text463": "Die eingegebene E-Mail-Adresse ist ungültig.",
  "text464": "Die E-Mail darf maximal 255 Zeichen lang sein.",
  "text465": "Die eingegebene E-Mail-Adresse ist bereits registriert.",
  "text466": "Passwort ist Pflichtaufgabe.",
  "text467": "Das Passwort muss aus mindestens 6 Zeichen bestehen.",
  "text468": "Die Passwörter stimmen nicht überein.",
  "text469": "Die Zustimmung zu den Allgemeinen Geschäftsbedingungen ist zwingend erforderlich.",
  "text470": "Überprüfen Sie das Captcha-Formular.",
  "text471": "Gehen Sie zur Online-Beratung",
  "text472": "Frage-und-Antwort-Themen anzeigen",
  "text473": "Frage-und-Antwort-Themen ausblenden",
  "text474": "Gehen Sie zum Blog",
  "text475": "Beratungsstelle",
  "text476": "Fragen Sie direkt unseren Apotheker",
  "text477": "Keine Optionen",
  "text478": "Wählen Sie Kategorien aus",
  "text479": "oben bestellen",
  "text480": "Zurück zum Laden",
  "text481": "Preis/Stück inkl. MwSt",
  "text482": "Gesamtpreis",
  "text483": "Preis/Stück ohne Mehrwertsteuer",
  "text484": "",
  "text485": "Hausnummer",
  "text486": "Profil",
  "text487": "Details ändern",
  "text488": "Sicherheit",
  "text489": "Ort ändern",
  "text490": "Weiter laden",
  "text491": "Meine Daten",
  "text492": "Folgen Sie uns",
  "text493": "Verkaufsschlager",
  "text494": "Alle Produkte",
  "text495": "Nicht verfügbar",
  "text496": "Wählen Sie eine Variante",
  "text497": "",
  "text498": "",
  "text499": "",
  "text500": "",
  "text501": "",
  "text502": "Vollständiger Name",
  "text503": "Bestätigen Sie das neue Passwort",
  "text504": "Bitte bestätigen Sie Ihr Einverständnis mit den Bedingungen zum Schutz personenbezogener Daten.",
  "text505": "Die eingegebene E-Mail-Adresse ist bereits für den Erhalt von Nachrichten angemeldet.",
  "text506": "Bitte überprüfen Sie Ihren E-Mail-Posteingang.",
  "text507": "Ausgabestelle",
  "text508": "Frage zu einem Produkt",
  "text509": "Frage zur Verfügbarkeit von Waren",
  "text510": "Sonderangebot",
  "text511": "Breite",
  "text512": "Länge",
  "text513": "Höhe",
  "text514": "Gewicht",
  "text515": "Bewertet am",
  "text516": "Favoriten",
  "text517": "Zurück zur Homepage",
  "text518": "Produkt-Status",
  "text519": "Land",
  "text520": "Liefer- und Rechnungsadresse",
  "text521": "Sie haben bereits ein Konto?",
  "text522": "Zurück zum Warenkorb",
  "text523": "Rabatt-Gutschein",
  "text524": "Zur Bestellung hinzufügen",
  "text525": "Inhalt des Warenkorbs",
  "text526": "Weiter zur Bestellung",
  "text527": "Produkt teilen",
  "text528": "Beschreibung ausblenden",
  "text529": "Vollständige Beschreibung",
  "text530": "Es ist ein Fehler aufgetreten, versuchen Sie es in einer Minute erneut.",
  "text531": "Zu den Favoriten hinzufügen",
  "text532": "Aus Favoriten entfernen",
  "text533": "Detail",
  "text534": "Neue Reservierung",
  "text535": "Reservierung erfolgreich erstellt",
  "text536": "Rabatt für die Zahlung",
  "text537": "Abbestellen",
  "text538": "Wählen Sie eine Laufzeit",
  "text539": "Ort des Abonnements",
  "text540": "Laufzeit",
  "text541": "Rabatt für Kunden",
  "text542": "Gesamte versendete Auftrags-Nr.",
  "text543": "Nr. der Bestellung",
  "text544": "Nicht eingeloggter Benutzer",
  "text545": "Coupon ist gültig",
  "text546": "Coupon existiert nicht, ist abgelaufen oder die Bedingungen für die Anwendung des Coupons sind nicht erfüllt",
  "text547": "Der Coupon ist ungültig",
  "text548": "Coupon wurde hinzugefügt",
  "text549": "Antwort auf",
  "text550": "Diese Frage wurde beantwortet von",
  "text551": "Eine Frage stellen",
  "text552": "Name",
  "text553": "Sie müssen eingeloggt sein, um Ihre eigene Frage im Ratgeberbereich zu stellen",
  "text554": "Wir haben keine passenden Einträge gefunden",
  "text555": "Heute ist sein Namenstag",
  "text556": "Warnung",
  "text557": "Falsche Anmeldeinformationen",
  "text558": "Das ursprüngliche Passwort stimmt nicht überein",
  "text559": "Interesse an der Arbeit",
  "text560": "Neuer Bewerber",
  "text561": "Vielen Dank für Ihre Bestellung, die wir unmittelbar nach Zahlungseingang mit der Bearbeitung beginnen.",
  "text562": "Zahlung erfolgreich.",
  "text563": "Die Zahlung ist fehlgeschlagen.",
  "text564": "Die Captcha-Überprüfung ist fehlgeschlagen.",
  "text565": "Keine Parameter",
  "text566": "Produktfilter",
  "text567": "Ich brauche Rat",
  "text568": "Kontakt und Support",
  "text569": "Schick uns eine Nachricht",
  "text570": "Folgen Sie uns in den sozialen Netzwerken",
  "text571": "Versand und Zahlung",
  "text572": "Treueprogramm",
  "text573": "Bei der Anmeldung zum Newsletter ist ein Fehler aufgetreten",
  "text574": "Abonnieren Sie Neuigkeiten per E-Mail",
  "text575": "Möchten Sie zu den Ersten gehören, die über Aktionen und Rabatte informiert werden? Geben Sie einfach Ihre E-Mail-Adresse ein.",
  "text576": "Vielen Dank, dass Sie sich für den Newsletter angemeldet haben. Eine Anmeldebestätigung wurde an Ihre E-Mail-Adresse gesendet.",
  "text577": "Artikel",
  "text578": "Online-Chat",
  "text579": "Online-Beratung",
  "text580": "Produktberatung",
  "text581": "Häufig gestellte Fragen",
  "text582": "Persönliche Sammlung",
  "text583": "Nachricht",
  "text584": "Aktionen",
  "text585": "Schreiben Sie eine Rezension",
  "text586": "Rezension",
  "text587": "Auswertung",
  "text588": "Weitere Artikel anzeigen",
  "text589": "Themen",
  "text590": "Suchen Sie nach einem Artikel",
  "text591": "Lesen Sie den gesamten Artikel",
  "text592": "Veröffentlicht",
  "text593": "Sie müssen angemeldet sein, um eine Bewertung schreiben zu können.",
  "text594": "Etwas ist schief gelaufen",
  "text595": "Versuchen Sie es erneut",
  "text596": "Antwort ausblenden",
  "text597": "Antwort anzeigen",
  "text598": "Beliebte Artikel",
  "text599": "Kategorien filtern",
  "text600": "Zurück zur Blogseite",
  "text601": "Finden Sie Ihren Traumjob!",
  "text602": "Lieferland",
  "text603": "Im vorherigen Schritt können Sie das Lieferland ändern",
  "text604": "Weniger anzeigen",
  "text605": "",
  "text606": "maximal",
  "text607": "Wir haben für Sie ausgewählt",
  "text608": "Keine Bewertungen",
  "text609": "Ich möchte E-Mails mit Neuigkeiten zu aktuellen Trends, Aktionen und Rabattgutscheinen erhalten. Sie können sich jederzeit kostenlos abmelden.",
  "text610": "Newsletter",
  "text611": "Brauchen Sie Rat?",
  "text612": "Kontaktiere uns",
  "text613": "Ich stimme zu",
  "text614": "Verarbeitung personenbezogener Daten",
  "text615": "Nachricht",
  "text616": "Geschäftsdaten",
  "text617": "Verkehrsdaten",
  "text618": "Unternehmensregister",
  "text619": "Name der Bank",
  "text620": "Wenn Sie noch nicht bei uns eingekauft haben und kein Konto haben,",
  "text621": "erstelle es hier",
  "text622": "Ich habe mein Passwort vergessen",
  "text623": "Haben Sie bereits Ihr Konto?",
  "text624": "Einloggen.",
  "text625": "Mit der Registrierung eines Kontos stimmen Sie unserem zu",
  "text626": "Nutzungsbedingungen.",
  "text627": "Lesen Sie unsere",
  "text628": "Richtlinie zum Schutz personenbezogener Daten.",
  "text629": "Ja, ich möchte gelegentlich E-Mails mit Sonderangeboten erhalten. Ich kann mein Abonnement jederzeit kündigen. (Optional)",
  "text630": "Das Passwort muss mindestens 8 Zeichen enthalten",
  "text631": "Zum Warenkorb hinzugefügt",
  "text632": "Aufräumen",
  "text633": "Alle Blogs",
  "text634": "Ergebnisse anzeigen",
  "text635": "Schreiben Sie eine Frage",
  "text636": "Antwort vom Spezialisten anzeigen",
  "text637": "In dieser Kategorie gibt es noch keine Fragen",
  "text638": "Zurück zur Hauptseite der Beratungsstelle",
  "text639": "hat das Projekt erstellt",
  "text640": "Alle Rechte vorbehalten",
  "text641": "Versand- und Zahlungsart",
  "text642": "Ihre Frage wird angezeigt, nachdem sie von einem Administrator genehmigt wurde",
  "text643": "Danke",
  "text644": "oder schreiben Sie an",
  "text645": "Aktivieren Sie den Rabattcode",
  "text646": "Gutscheincode",
  "text647": "Rabattcode anwenden",
  "text648": "Eine Rezension wurde hinzugefügt",
  "text649": "Das Passwort wurde erfolgreich geändert",
  "text650": "Das Passwort konnte nicht geändert werden",
  "text651": "Beim Zurücksetzen des Passworts ist ein Fehler aufgetreten",
  "text652": "Sie haben eine E-Mail zum Zurücksetzen Ihres Passworts erhalten",
  "text653": "Bei der Registrierung ist ein Fehler aufgetreten",
  "text654": "Sie haben sich erfolgreich registriert",
  "text655": "Beim Anmelden ist ein Fehler aufgetreten",
  "text656": "Sie wurden angemeldet",
  "text657": "Beim Absenden des Kontaktformulars ist ein Fehler aufgetreten",
  "text658": "Das Kontaktformular wurde erfolgreich versendet",
  "text659": "Ihre Frage wurde erfolgreich gesendet",
  "text660": "Beim Senden der Frage ist ein Fehler aufgetreten",
  "text661": "Beim Erstellen der Rezension ist ein Fehler aufgetreten",
  "text662": "Preis / Stk",
  "text663": "Zusammen",
  "text664": "Ein Geschenk",
  "text665": "Folgen Sie uns auf Instagram",
  "text666": "Instagram ansehen",
  "text667": "Die Farbe hat das falsche Format.",
  "text668": "mehr..",
  "text669": "Kaufen",
  "text670": "Alle Produkte anzeigen",
  "text671": "Blogs",
  "text672": "Keine Etiketten",
  "text673": "Keine Blogs",
  "text674": "Keine Kategorien",
  "text675": "Zwischensumme",
  "text676": "Haben Sie bereits bei uns eingekauft?",
  "text677": "Wenn Sie bereits bei uns eingekauft haben, melden Sie sich in Ihrem Konto an, um die Bestelldaten automatisch zu vervollständigen und den Bestellvorgang zu beschleunigen.",
  "text678": "Ich bin ein neuer Kunde",
  "text679": "Abrechnungsdaten",
  "text680": "Beschädigtes Produkt",
  "text681": "Ein unangemessenes Geschenk",
  "text682": "Ich möchte es nicht sagen",
  "text683": "Wählen Sie einen Grund",
  "text684": "Kurier",
  "text685": "Zurückgegebene Produkte:",
  "text686": "Stornieren Sie die Rücksendung",
  "text687": "Bestätigen Sie die Produktrückgabe",
  "text688": "Firmenadresse",
  "text689": "Unternehmensdaten",
  "text690": "ÖFFNUNGSZEITEN",
  "text691": "Verfügbarkeit prüfen",
  "text692": "E-Rezept",
  "text693": "Reservierungs-E-Rezept",
  "text694": "Treuekarte",
  "text695": "Ich möchte eine Karte",
  "text696": "Ich habe eine Karte",
  "text697": "Sozialversicherungsnummer",
  "text698": "Das Telefon ist für die Information über den Status der Reservierung unerlässlich",
  "text699": "Zur Verifizierung des Rezepts benötigen wir Ihre Sozialversicherungsnummer",
  "text700": "Rezeptreservierung einreichen",
  "text701": "Wählen Sie eine Stadt aus",
  "text702": "Treuekartennummer",
  "text703": "Produktname",
  "text704": "Geben Sie den Produktnamen/die Barcodenummer ein",
  "text705": "Suche nach Namen oder Barcode – Nummern unter dem Produkt-Barcode",
  "text706": "Maßgeschneidertes Produkt",
  "text707": "Schreiben Sie eine Widmung...",
  "text708": "Wählen Sie einen Liefertermin",
  "text709": "Weitere Unterkategorien anzeigen",
  "text710": "Unterkategorien ausblenden",
  "text711": "Unterkategorien ausblenden",
  "text712": "Legen Sie in den Kontoeinstellungen sowohl IBAN als auch SWIFT fest",
  "text713": "Wir haben die Retoure erfolgreich registriert",
  "text714": "Zurückgegebene Bestellungen",
  "text715": "Warenrückgabe",
  "text716": "Datum der Rückkehr",
  "text717": "Herunterladen",
  "text718": "Lieferanten",
  "text719": "Produktinformationen",
  "text720": "Produktpreis",
  "text721": "Geh in den Laden",
  "text722": "Änderung des Anspruchsstatus",
  "text723": "Es kann nur ein Format enthalten, bei dem maximal 4 Zahlen vor dem Dezimalpunkt und 8 nach dem Dezimalpunkt stehen.",
  "text724": "Wo wir überall waren",
  "text725": "Weiter zur Hauptseite",
  "text726": "Geben Sie die Bestellnummer und die E-Mail-Adresse ein",
  "text727": "Link",
  "text728": "Standort des Lieferanten",
  "text729": "Die Mindestanzahl an Zeichen beträgt",
  "text730": "Die maximale Zeichenanzahl beträgt",
  "text731": "Dieses Feld darf nicht leer sein",
  "text732": "Die E-Mail-Adresse muss gültig sein",
  "text733": "Die Telefonnummer muss gültig sein",
  "text734": "Dieses Feld ist erforderlich",
  "text735": "Das Datum muss gültig sein",
  "text736": "Die eingegebene Eingabe muss eine Zahl sein",
  "text737": "Die eingegebene Eingabe muss eine Ganzzahl sein",
  "text738": "Die eingegebene Eingabe muss eine Dezimalzahl sein",
  "text739": "Passwörter stimmen nicht überein",
  "text740": "Sie müssen der DSGVO zustimmen",
  "text741": "Sie müssen den Nutzungsbedingungen zustimmen",
  "text742": "Sie müssen mindestens ein Produkt auswählen",
  "text743": "Geben Sie Ihre Vorteilskartendaten oder Ihren Namen ein",
  "text744": "Verwandte Produkte",
  "text745": "Angemeldet als",
  "text746": "Suchen",
  "text747": "Stichwort",
  "text748": "Distanz",
  "text749": "Kategorie",
  "text750": "Pflichtfelder",
  "text751": "Kontaktieren Sie uns jederzeit, wenn Sie einen besonderen Wunsch haben oder wenn Sie Fragen haben.",
  "text752": "Keine Ergebnisse",
  "text753": "Ausgewählte Tage sind nicht verfügbar",
  "text754": "Bearbeiten",
  "text755": "Konto löschen",
  "text756": "Geschäft",
  "text757": "Für den Fall, dass wir Sie bezüglich Ihrer Bestellung kontaktieren müssen.",
  "text758": "Ein Konto erstellen",
  "text759": "In der ausgewählten Entfernung gibt es keine Lieferanten",
  "text760": "Wählen Sie einen Lieferanten aus",
  "text761": "Wählen Sie eine Stadt aus",
  "text762": "Geben Sie Ihre Rechnungsadresse ein, damit Sie dies nicht bei jeder Bestellung erneut tun müssen.",
  "text763": "Sie müssen angemeldet sein, um das Großhandelsformular auszufüllen.",
  "text764": "Großhandel",
  "text765": "Glückwunsch! Sie sind bereits als Großhändler registriert.",
  "text766": "Unternehmenstyp und Domänen",
  "text767": "Kontaktinformationen",
  "text768": "Maximale Dateigröße 2 MB",
  "text769": "Dropshipping",
  "text770": "Lagerbestellung",
  "text771": "Direktversand-Lieferadresse",
  "text772": "Persönliche und Kontaktinformationen",
  "text773": "Lieferadresse der Ware",
  "text774": "Ihr Formular wurde erfolgreich übermittelt. Wir werden uns schnellstmöglich bezüglich der Großhandelsbedingungen mit Ihnen in Verbindung setzen.",
  "text775": "Standorterfassung aktivieren",
  "text776": "Sie müssen einen Liefertermin auswählen",
  "text777": "Es ist notwendig, einen bestimmten Lieferpunkt auszuwählen",
  "text778": "Der Preis des Pakets ist höher als der zulässige Wert.",
  "text779": "Das Paket enthält",
  "text780": "Das Paket hat keinen Höchstpreis",
  "text781": "Geben Sie Ihre Postleitzahl ein",
  "text782": "Geben Sie die Stadt ein",
  "text783": "Berechnen Sie den Preis",
  "text784": "In ein Tierheim schicken",
  "text785": "Marke",
  "text786": "Eine Frage an den Apotheker",
  "text787": "Sie beantwortete die Frage",
  "text788": "Jobangebote",
  "text789": "Online-Beratung",
  "text790": "Frage-und-Antwort-Themen ausblenden",
  "text791": "Frage-und-Antwort-Themen anzeigen",
  "text792": "Finde mehr heraus",
  "text793": "Alle Angebote anzeigen",
  "text794": "Angebotsdetails",
  "text795": "Arbeitsplatz",
  "text796": "Bruttolohn",
  "text797": "Anstellung",
  "text798": "Beginn",
  "text799": "Weitere Referenzen",
  "text800": "Rufen Sie uns an",
  "text801": "Wir sind erreichbar",
  "text802": "über das Unternehmen",
  "text803": "Kontaktinformationen",
  "text804": "Unterlagen zur Bestellung",
  "text805": "Für diese Bestellung sind keine Dokumente verfügbar",
  "text806": "Wählen Sie ein Tierheim",
  "text807": "Siehe Detail",
  "text808": "Ich bin an der Umsetzung interessiert",
  "text809": "von",
  "text810": "Angeboten",
  "text811": "aus",
  "text812": "im Brutto",
  "text813": "Ich interessiere mich für einen Job",
  "text814": "Lebenslauf hochladen",
  "text815": "Interesse senden",
  "text816": "Ratenrechner",
  "text817": "Sehen Sie sich das Angebot an",
  "text818": "Konfigurator",
  "text819": "Alle Erkenntnisse",
  "text820": "Wo Sie uns finden",
  "text821": "Geschäftsabteilung",
  "text822": "Vertriebsmitarbeiter",
  "text823": "Rechtlicher Hinweis",
  "text824": "Siehe technische Parameter",
  "text825": "Bitte wählen Sie einen Lieferort aus",
  "text826": "Varianten",
  "text827": "Er hat einen Namenstag",
  "text828": "Zum Download",
  "text829": "Finden Sie einen Job",
  "text830": "Beliebte Kategorien",
  "text831": "Finden Sie die Art von Arbeit, die zu Ihnen passt! Die Arbeiten beginnen unmittelbar nach dem Kauf und der Bereitstellung der Anforderungen.",
  "text832": "offene Stellen",
  "text833": "Erstellen Sie einen Lebenslauf",
  "text834": "Erstellen Sie Ihr Profil und finden Sie Tausende von Jobs, bauen Sie Ihre Karriere auf und Anstellung!",
  "text835": "Aktuelle Stellenangebote",
  "text836": "Finden Sie die Art von Arbeit, die zu Ihnen passt! Die Arbeiten beginnen unmittelbar nach dem Kauf und der Bereitstellung der Anforderungen.",
  "text837": "Lebenslauf senden",
  "text838": "/ pro Monat",
  "text839": "Es ist notwendig, einen Unterschlupf auszuwählen",
  "text840": "Unterkünfte, die Sie mit uns unterstützen können",
  "text841": "Ich bin über 18 Jahre alt",
  "text842": "Der Inhalt dieser Seite ist nicht für Privatpersonen geeignet",
  "text843": "jünger als 18 Jahre.",
  "text844": "Alles",
  "text845": "Nur neu",
  "text846": "Nur verwendet",
  "text847": "Typ",
  "text848": "Pro Jahr",
  "text849": "Modell",
  "text850": "Meine Lebensläufe",
  "text851": "Vorschau des Lebenslaufs",
  "text852": "Kontolöschung",
  "text853": "Sobald Ihr Konto gelöscht wird, können Ihre Daten nicht wiederhergestellt werden.",
  "text854": "Konto löschen",
  "text855": "Einstellungen",
  "text856": "Ich bin daran interessiert, Stellenangebote per E-Mail zu versenden",
  "text857": "Bevorzugte Sprache",
  "text858": "Zu allen Stellenangeboten",
  "text859": "Biographie",
  "text860": "Schritt",
  "text861": "Grunddaten",
  "text862": "Fotografie",
  "text863": "Berufserfahrung",
  "text864": "Ausbildung",
  "text865": "Wissen",
  "text866": "Sprachen",
  "text867": "Ergänzende Teile",
  "text868": "Endgültige Einstellungen",
  "text869": "Suche nach Stichwort, Firmenname",
  "text870": "Dorf, Bezirk, Region",
  "text871": "Suchen",
  "text872": "Straße und Hausnummer",
  "text873": "Laden Sie Ihr Foto hoch",
  "text874": "Ein Foto ist nicht zwingend erforderlich, aber ein Lebenslauf mit Foto wirkt persönlicher und wird den Personalvermittler interessieren mehr.",
  "text875": "Wussten Sie, dass es durchschnittlich 7 Sekunden dauert, bis ein Personalvermittler einen Lebenslauf zum ersten Mal scannt? Erwähnen Sie daher nur relevante Erfahrungen und beschreiben Sie diese in Stichpunkten oder kurzen Absätzen.",
  "text876": "Positionsbezeichnung, Firma",
  "text877": "Stadt oder Postleitzahl",
  "text878": "Was ist Ihre Ausbildung?",
  "text879": "Informieren Sie Arbeitgeber über Ihre Ausbildung",
  "text880": "Bildung hinzufügen",
  "text881": "Stellenangebot",
  "text882": "Aktive Angebote",
  "text883": "Fokus",
  "text884": "Hochschule",
  "text885": "Gymnasium",
  "text886": "Kurs oder Zertifikat",
  "text887": "Ich interessiere mich für einen Job",
  "text888": "Ihre Fähigkeiten und Kenntnisse",
  "text889": "Geben Sie ein, über welche Fähigkeiten und Kenntnisse Sie verfügen und auf welchem ​​Niveau.",
  "text890": "Beruf",
  "text891": "Die Sprache, die Sie sprechen",
  "text892": "Geben Sie neben dem Namen den akademischen Grad an",
  "text893": "Gehalt",
  "text894": "Art der Beschäftigung",
  "text895": "Antwort auf ein Stellenangebot",
  "text896": "Informationen zum Beruf",
  "text897": "Ich bin SZČO (Selbstständiger)",
  "text898": "Optionale Anhänge",
  "text899": "Lebenslauf, Motivationsschreiben, Bescheide, Zeugnisse, Sonstiges... (max. 10 MB)",
  "text900": "Die Sprache, die Sie sprechen",
  "text901": "Wählen Sie eine Sprache",
  "text902": "Titel",
  "text903": "Region",
  "text904": "Wählen Sie ein Land aus",
  "text905": "Wählen Sie eine Region aus",
  "text906": "Die maximale Dateigröße beträgt 10 MB",
  "text907": "Fügen Sie einen Anhang hinzu",
  "text908": "Anzahl der Anhänge",
  "text909": "Führerschein",
  "text910": "Was für einen Führerschein haben Sie?",
  "text911": "Wie verbringen Sie Ihre Freizeit am liebsten?",
  "text912": "Interessen oder Hobbys",
  "text913": "Beschreiben Sie kurz und prägnant, wie Sie Ihre Freizeit gerne verbringen.",
  "text914": "Sie haben den Inhalt Ihres Lebenslaufs vervollständigt. Geben Sie die folgenden Daten ein, die Ihnen bei der Jobsuche auf pracaslovensko.sk helfen werden",
  "text915": "Arbeitsposition",
  "text916": "In welchem ​​Bereich oder in welcher konkreten Position möchten Sie arbeiten?",
  "text917": "Arbeitsbereich",
  "text918": "Wählen Sie einen Arbeitsbereich aus",
  "text919": "Arbeitsplatz",
  "text920": "An welchem ​​Standort suchen Sie einen Job?",
  "text921": "Art der Beschäftigung",
  "text922": "Geben Sie an, welche Art von Arbeitszeit zu Ihnen passt",
  "text923": "Startdatum",
  "text924": "Geben Sie das Datum des möglichen Starts ein",
  "text925": "Erwartetes Mindestgehalt (brutto)",
  "text926": "Geben Sie Ihre Vorstellung vom Mindestgehalt (brutto) an.",
  "text927": "Bevorzugte Arbeitsschichten",
  "text928": "Geben Sie Ihre Präferenzen für Arbeitsschichten an",
  "text929": "Gesundheitlicher Nachteil",
  "text930": "Sind Sie beruflich behindert?",
  "text931": "Stellenangebote per E-Mail?",
  "text932": "Möchten Sie, dass wir Ihnen passende Stellenangebote per E-Mail zusenden?",
  "text933": "Stadt/Gemeinde",
  "text934": "Sofort",
  "text935": "Nach Vereinbarung",
  "text936": "Betrag ab (EUR)",
  "text937": "Bin ich auch an einem Job interessiert, bei dem ich auch am Wochenende arbeiten würde",
  "text938": "Ich bin auch daran interessiert, nachts zu arbeiten",
  "text939": "Ich habe eine Arbeitsunfähigkeit",
  "text940": "41% - 70%",
  "text941": "Mehr als 70 %",
  "text942": "Weitere Informationen",
  "text943": "Ich bin daran interessiert, Stellenangebote per E-Mail zu versenden",
  "text944": "Persönliche Zusammenfassung",
  "text945": "Schreiben Sie eine kurze Zusammenfassung über sich selbst in 2-3 Sätzen.",
  "text946": "Weitere Informationen",
  "text947": "Möchten Sie noch etwas hinzufügen? Schreiben Sie es hier.",
  "text948": "Hier können Sie Dateien einfügen oder verschieben",
  "text949": "PNG, JPG, GIF",
  "text950": "Datei auswählen",
  "text951": "Einen Job hinzufügen",
  "text952": "Zeitraffer",
  "text953": "Arbeitsbeschreibung",
  "text954": "Beschreiben Sie kurz und prägnant Ihre Tätigkeit.",
  "text955": "Hinzufügen eines Auftrags",
  "text956": "Berufsbezeichnung",
  "text957": "Arbeitgeber",
  "text958": "Stadt/Gemeinde",
  "text959": "Landschaft",
  "text960": "Zeitspanne",
  "text961": "Ich arbeite derzeit hier",
  "text962": "Vom Monat",
  "text963": "Seit",
  "text964": "Innerhalb eines Monats",
  "text965": "Nach dem Jahr",
  "text966": "Arbeitsbeschreibung",
  "text967": "Beschreiben Sie kurz und prägnant Ihre Tätigkeit.",
  "text968": "Hochschule",
  "text969": "Fakultät",
  "text970": "Abteilung",
  "text971": "Sekundarschule",
  "text972": "Name des Kurses",
  "text973": "Beschreibung der Studie",
  "text974": "Beschreiben Sie kurz und prägnant Ihr Studium",
  "text975": "Komplette Anfängerin",
  "text976": "Die Grundlagen",
  "text977": "Zwischenbericht",
  "text978": "Fortgeschrittene",
  "text979": "Experte",
  "text980": "Sprache hinzufügen",
  "text981": "Wissen hinzufügen",
  "text982": "Vollständiger Anfänger (A1)",
  "text983": "Anfänger (A2)",
  "text984": "Mittelstufe (B1)",
  "text985": "Mittelstufe (B2)",
  "text986": "Fortgeschrittene (C1)",
  "text987": "Experte (C2)",
  "text988": "Hinzufügen einer Sprache",
  "text989": "Sprache",
  "text990": "Sprachniveau",
  "text991": "Sie haben keine zusätzliche Ausbildung",
  "text992": "Heute",
  "text993": "Kurs oder Zertifikat",
  "text994": "Diese Website verwendet Cookies",
  "text995": "Wir verwenden Cookies, um Inhalte und Anzeigen zu personalisieren, Funktionen für soziale Medien bereitzustellen und den Datenverkehr zu analysieren. Wir stellen auch Informationen darüber, wie Sie unsere Website nutzen, unseren Partnern für soziale Medien, Werbung und Analysen zur Verfügung. Diese Partner können die relevanten Informationen mit anderen Informationen kombinieren, die Sie ihnen zur Verfügung gestellt haben oder die sie von Ihnen gesammelt haben, als Sie ihre Dienste genutzt haben.",
  "text996": "Alles aktivieren",
  "text997": "Ablehnen",
  "text998": "Anpassen",
  "text999": "Cookies setzen",
  "text1000": "Dienstleistungen",
  "text1001": "Ihre Datenschutzoptionen",
  "text1002": "In diesem Abschnitt können Sie einige Präferenzen bezüglich der Verarbeitung Ihrer personenbezogenen Daten äußern. Sie können die getroffenen Entscheidungen jederzeit überprüfen und ändern, indem Sie dieses Panel über den bereitgestellten Link erneut aufrufen. Wenn Sie Ihre Zustimmung zu den unten beschriebenen spezifischen Verarbeitungsaktivitäten verweigern möchten, schalten Sie die Schalter auf „Aus“ oder verwenden Sie die Schaltfläche „Alle ablehnen“ und bestätigen Sie, dass Sie Ihre Auswahl speichern möchten.",
  "text1003": "Notwendige Cookies helfen bei der Erstellung nutzbarer Websites, indem sie grundlegende Funktionen wie die Seitennavigation und den Zugriff auf geschützte Bereiche von Websites ermöglichen. Ohne diese Cookies können Websites nicht ordnungsgemäß funktionieren.",
  "text1004": "Notwendige Cookies helfen bei der Erstellung nutzbarer Websites, indem sie grundlegende Funktionen wie die Seitennavigation und den Zugriff auf geschützte Bereiche von Websites ermöglichen. Ohne diese Cookies können Websites nicht ordnungsgemäß funktionieren.",
  "text1005": "Statistik und Analyse",
  "text1006": "Statistische Cookies helfen Website-Besitzern zu verstehen, wie sie mit Website-Besuchern interagieren, indem sie Informationen anonym sammeln und melden.",
  "text1007": "Keks-Tabelle",
  "text1008": "Keks",
  "text1009": "Bereich",
  "text1010": "Marketing",
  "text1011": "Marketing-Cookies werden verwendet, um Besucher auf Websites zu verfolgen. Ziel ist es, Anzeigen anzuzeigen, die für einzelne Nutzer relevant und ansprechend sind und somit für Publisher und Drittwerbetreibende wertvoller sind.",
  "text1012": "Ich möchte mehr wissen",
  "text1013": "Um Informationen über die Verarbeitung personenbezogener Daten und Ihre Rechte im Zusammenhang mit dem Schutz personenbezogener Daten zu erhalten, können Sie sich an uns wenden",
  "text1014": "hier.",
  "text1015": "Funktional",
  "text1016": "Funktionalitätscookies helfen bei der Ausführung bestimmter Funktionen, wie z. B. dem Teilen von Website-Inhalten auf Social-Media-Plattformen, dem Sammeln von Feedback und anderen Funktionen von Drittanbietern.",
  "text1017": "Einstellungen speichern",
  "text1018": "Sie haben keine zusätzliche Berufserfahrung",
  "text1019": "Sie haben keine zusätzlichen Kenntnisse",
  "text1020": "Art der Fähigkeiten und Kenntnisse",
  "text1021": "Niveau der Fähigkeiten und Kenntnisse",
  "text1022": "Erweiterung der Kenntnisse und Fähigkeiten",
  "text1023": "Welche Sprachen sprechen Sie?",
  "text1024": "Geben Sie die von Ihnen gesprochenen Sprachen und deren Niveau ein",
  "text1025": "Sie haben keine Sprachen hinzugefügt",
  "text1026": "Zurück zu",
  "text1027": "Weiter",
  "text1028": "Speichern Sie",
  "text1029": "Der Wert muss im Bereich von",
  "text1030": "Hinzufügen von Bildung",
  "text1031": "Ich studiere noch",
  "text1032": "Beschreibung der Studie",
  "text1033": "Titel",
  "text1034": "Technische Informationen",
  "text1035": "Technische Merkmale",
  "text1036": "Haben Sie eine Frage zum Produkt? Schicken Sie sie an uns und wir werden sie gerne beantworten.",
  "text1037": "Name des Produkts",
  "text1038": "Anfrage senden",
  "text1039": "Ich bin mit der Verarbeitung personenbezogener Daten einverstanden",
  "text1040": "Ihre Frage",
  "text1041": "Senden an",
  "text1042": "Ihre Frage wurde erfolgreich gesendet",
  "text1043": "Frage konnte nicht gesendet werden",
  "text1044": "Ihr Name",
  "text1045": "Reza",
  "text1046": "Dieses Produkt ist in mehreren Varianten erhältlich",
  "text1047": "Auf Facebook teilen",
  "text1048": "Minimale Höhe",
  "text1049": "Mindestbreite",
  "text1050": "Maximale Höhe",
  "text1051": "Maximale Breite",
  "text1052": "Farbgestaltung",
  "text1053": "Januar",
  "text1054": "Februar",
  "text1055": "März",
  "text1056": "April",
  "text1057": "Mai",
  "text1058": "Juni",
  "text1059": "Juli",
  "text1060": "August",
  "text1061": "September",
  "text1062": "Oktober",
  "text1063": "November",
  "text1064": "Dezember",
  "text1065": "Länge des Kurses",
  "text1066": "Anzahl von Kapiteln",
  "text1067": "Geben Sie die ursprüngliche Bezeichnung des Ersatzteils ein",
  "text1068": "Art der Zahlung",
  "text1069": "Nutzen Sie Ihr Konto, um Ihre Bestellungen zu verfolgen und Rechnungen zu verwalten",
  "text1070": "Nur neue",
  "text1071": "Nur verwendet",
  "text1072": "Gebrauchte Teile",
  "text1073": "Blogartikel, Hinweise und Tipps",
  "text1074": "Bleiben Sie auf dem Laufenden",
  "text1075": "Mehr über das Projekt",
  "text1076": "Aktion Detail",
  "text1077": "Bis zum Ende der Veranstaltung",
  "text1078": "Bis zum Beginn der Veranstaltung",
  "text1079": "Vorherige Lektion",
  "text1080": "Beendet",
  "text1081": "Krokow",
  "text1082": "Erfolgsquote im Kurs",
  "text1083": "Öffnen Sie die vollständige Diskussion",
  "text1084": "Beteiligen Sie sich an der Diskussion",
  "text1085": "Länge des Kurses",
  "text1086": "Liste der Kapitel",
  "text1087": "Beschreibung des Kurses",
  "text1088": "Häufig gestellte Fragen",
  "text1089": "Diskussion",
  "text1090": "Einen Kurs kaufen",
  "text1091": "Referenzen",
  "text1092": "Als erfüllt markieren",
  "text1093": "Start des Kurses",
  "text1094": "Beenden Sie den Kurs",
  "text1095": "Eine weitere Lektion",
  "text1096": "Herzlichen Glückwunsch",
  "text1097": "Sie haben den Kurs erfolgreich abgeschlossen",
  "text1098": "Ohne",
  "text1099": "Die Lücke",
  "text1100": "Punkt",
  "text1101": "Leitung",
  "text1102": "Unbekannt",
  "text1103": "Das neue Passwort muss sich von dem alten unterscheiden",
  "text1104": "Konto",
  "text1105": "Erstellt am",
  "text1106": "Zwischensumme",
  "text1107": "Das Kundenkonto ist nicht gültig.",
  "text1108": "Bestätigung des Passworts",
  "text1109": "Gekaufte Ausbildung",
  "text1110": "Öffnen Sie",
  "text1111": "Trainer",
  "text1112": "Das könnte Sie interessieren",
  "text1113": "Privatperson",
  "text1114": "Adresse hinzufügen",
  "text1115": "In den Warenkorb legen",
  "text1116": "Zurück zu den Video-Tutorials",
  "text1117": "Preisangebot",
  "text1118": "Anfrage senden",
  "text1119": "Vollständig liefern",
  "text1120": "Externe Auftragsnummer",
  "text1121": "Ausfuhr von Erzeugnissen abgeschlossen",
  "text1122": "mit Mehrwertsteuer",
  "text1123": "Neuer Benutzer",
  "text1124": "Neue Bestellung",
  "text1125": "Neuer Kommentar zur Aufgabe",
  "text1126": "Ändern des Status einer Aufgabe",
  "text1127": "Kostenloser Versand",
  "text1128": "Preisgarantie",
  "text1129": "Kostenlose Beratung",
  "text1130": "Kundenbetreuung",
  "text1131": "Über 2000 Produkte auf Lager",
  "text1132": "Lieferung innerhalb von 4 Tagen",
  "text1133": "Tags",
  "text1134": "Mein Profil",
  "text1135": "Firmenname eingeben",
  "text1136": "Bitte geben Sie die Registrierungsnummer ein",
  "text1137": "Geben Sie Ihre Firmenadresse ein",
  "text1138": "Ort der Durchführung",
  "text1139": "Ich bin interessiert an",
  "text1140": "In der Nähe des Baches",
  "text1141": "Wie viele Menschen werden die Kläranlage nutzen?",
  "text1142": "Habe ich ein abschüssiges Grundstück?",
  "text1143": "",
  "text1144": "Gestalten Sie Ihr Produkt genau nach Ihren Wünschen. Mit unserem Konfigurator können Sie schnell und einfach das perfekte Produkt erstellen.",
  "text1145": "Erstellen Sie Ihre ideale Konfiguration",
  "text1146": "Alle in Unterkategorie anzeigen",
  "text1147": "Fotoführer",
  "text1148": "Den Artikel lesen",
  "text1149": "Meistgelesene Artikel",
  "text1150": "Tags",
  "text1151": "Sie planen ein Projekt?\nWir treffen uns und beraten Sie.",
  "text1152": "Kostenlos",
  "text1153": "Kontakt",
  "text1154": "Abgerufen von",
  "text1155": "Artikel teilen",
  "text1156": "Der Link wurde in die Zwischenablage kopiert",
  "text1157": "Haushalt",
  "text1158": "Treuepunkte konnten nicht verwendet werden",
  "text1159": "Ihre Treuepunkte",
  "text1160": "Jede Loyalität hat einen Wert",
  "text1161": "und Sie erhalten einen Gesamtrabatt",
  "text1162": "bei Ihrem Kauf.",
  "text1163": "Sie haben keine Treuepunkte",
  "text1164": "Treuepunkte einlösen",
  "text1165": "Anzahl der zu beantragenden Punkte",
  "text1166": "Anzahl der eingelösten Treuepunkte",
  "text1167": "Rabatt angewendet",
  "text1168": "Die maximale Anzahl der Punkte, die pro Bestellung eingelöst werden können, beträgt",
  "text1169": "Hauptsitz",
  "text1170": "Mehr über diesen Dienst",
  "text1171": "Kontakt",
  "text1172": "Büro",
  "text1173": "Firmensitz",
  "text1174": "Weiter",
  "text1175": "Durchführungsprozess und Verfahren",
  "text1176": "Universal e-shop Bildschirme Vorschau",
  "text1177": "Die gewählte Zeit kann nicht gebucht werden",
  "text1178": "Ausgewählte Option",
  "text1179": "Zimmer",
  "text1180": "Bereich",
  "text1181": "Zeichnen von Möbelzeichnungen",
  "text1182": "Liste der Einrichtungselemente",
  "text1183": "Vollständiger Name des Kunden",
  "text1184": "Bezeichnung des Beschwerdestatus",
  "text1185": "Name der Person, die die Reservierung bearbeiten wird",
  "text1186": "Gebucht für den Tag",
  "text1187": "Wenn Sie bereits ein Konto bei uns haben, bitte",
  "text1188": "Name der Firma",
  "text1189": "Anschrift des eingetragenen Sitzes des Unternehmens",
  "text1190": "Wählen Sie ein Land",
  "text1191": "Zugewiesene Registerkarten gehören nicht zu diesem Abschnitt",
  "text1192": "Horizontal",
  "text1193": "Vertikal",
  "text1194": "Intern",
  "text1195": "Draußen",
  "text1196": "Arbeit, Beschäftigung und Karrieremöglichkeiten",
  "text1197": "Beliebte Positionen",
  "text1198": "Warenkorb aktualisieren",
  "text1199": "Artikel bearbeiten",
  "text1200": "Vertragsnummer",
  "text1201": "Service nach der Garantie",
  "text1202": "Anmeldeformular",
  "text1203": "Anmeldename (E-Mail)",
  "text1204": "Einloggen",
  "text1205": "Falsches Passwort",
  "text1206": "Geben Sie das Passwort für das virtuelle Produkt ein, das Sie erhalten haben, nachdem Sie Ihre Bestellung bezahlt haben.",
  "text1207": "Das Passwort finden Sie in Ihrer E-Mail Adresse.",
  "text1208": "Der Artikel im Warenkorb wurde geändert.",
  "text1209": "API-Schlüssel ist nicht korrekt",
  "text1210": "Unterzeichnung des Vertrags und Begleichung der Rechnung",
  "text1211": "Kontaktinformationen und Arbeitsbeschreibung",
  "text1212": "Daten und Zugangskontrolle",
  "text1213": "Grafische Gestaltung",
  "text1214": "Unterzeichnung des Abnahmeprotokolls - Entwurf",
  "text1215": "Installation des Systems auf dem Domain - Server",
  "text1216": "Visuelle Umsetzung und Anbindung an das System",
  "text1217": "Abnahmeprotokoll - Entwurfsumsetzung und Anbindung an das System",
  "text1218": "Inhalt des Projekts",
  "text1219": "Migration zur Produktion",
  "text1220": "Abschließende Projektbestätigung",
  "text1221": "Der Bauvertrag wurde noch nicht unterzeichnet.",
  "text1222": "Die Rechnung wurde noch nicht bezahlt.",
  "text1223": "Der Vertrag ist erfolgreich unterzeichnet worden.",
  "text1224": "Die Rechnung ist beglichen worden.",
  "text1225": "Herunterladen",
  "text1226": "Zum Laden",
  "text1227": "Das Dokument herunterladen",
  "text1228": "Meine Rechnungen",
  "text1229": "Dokument",
  "text1230": "In Rechnung gestellter Betrag",
  "text1231": "Gezahlter Betrag",
  "text1232": "Zu zahlende Restbeträge",
  "text1233": "Währung",
  "text1234": "Datum der Ausstellung",
  "text1235": "Genehmigt durch",
  "text1236": "Ausstattung durch den Kunden",
  "text1237": "Art des Dokuments",
  "text1238": "Datum der steuerpflichtigen Lieferung",
  "text1239": "Meine Anfrage",
  "text1240": "Geben Sie Ihre E-Mail-Adresse an, über die wir kommunizieren werden",
  "text1241": "Datum der Annahme",
  "text1242": "Mehr über uns",
  "text1243": "Ich bin interessiert",
  "text1244": "Isolierung",
  "text1245": "Nach Gebrauch",
  "text1246": "Gemäß dem Material",
  "text1247": "Alle Referenzen",
  "text1248": "Ausgewählte Projekte",
  "text1249": "Sind Sie an der Durchführung eines Projekts interessiert oder haben Sie Fragen? Kontaktieren Sie uns",
  "text1250": "Vorname und Nachname",
  "text1251": "Von der Europäischen Union unterstütztes Projekt",
  "text1252": "Datenschutzbestimmungen",
  "text1253": "Produktübersicht",
  "text1254": "Produkt ansehen",
  "text1255": "Technische Daten",
  "text1256": "Beratung",
  "text1257": "Kontonummer",
  "text1258": "Rufnummer",
  "text1259": "In unserer Kommunikation mit dem Kunden bevorzugen wir die Kommunikation über die Projektgruppe in der Anwendung \"Whatsapp\". Geben Sie die Nummer ein, über die wir Sie zur Projektgruppe hinzufügen werden.",
  "text1260": "Whatsapp-Telefonnummer (+421 ... ...)",
  "text1261": "Whatsapp",
  "text1262": "Arbeitsbeschreibung",
  "text1263": "Art der Arbeit (nach Vereinbarung und Vertrag)",
  "text1264": "Eshop",
  "text1265": "Website der Präsentation",
  "text1266": "Webanwendung",
  "text1267": "Mobile Anwendung",
  "text1268": "CRM-System",
  "text1269": "PPC-Kampagnen (Google, Facebook)",
  "text1270": "SEO-Optimierung",
  "text1271": "Art des Musters",
  "text1272": "Gestaltung des E-Shops - Eliadmin universal",
  "text1273": "E-Shop-Design - maßgeschneidertes Design",
  "text1274": "Web-Design / Anwendungsdesign / Systemdesign",
  "text1275": "Bevorzugter Farbcode (im HEX-Format)",
  "text1276": "Sie können es unter diesem Link mischen.",
  "text1277": "Grafische und inhaltliche Dokumente",
  "text1278": "Grafische Dokumente",
  "text1279": "Ich habe (z.B. Gestaltungshandbuch, Logo, Banner...)",
  "text1280": "Ich habe keine",
  "text1281": "Hintergrundinhalte für die Website (Beschreibungen, Kategorienamen, Fotos, usw...)",
  "text1282": "Fügen Sie unterstützende Dateien bei (Gestaltungshandbuch, Logo, Banner, ...)",
  "text1283": "Für Logo-Vektoren verwenden Sie das Vektorformat svg, ai oder pdf.",
  "text1284": "Laden Sie bis zu 10 unterstützte Dateien hoch. Maximale Größe 100 MB/Datei.",
  "text1285": "FINDEN SIE EINE DATEI",
  "text1286": "Domäne und Hosting",
  "text1287": "Ich habe gekauft",
  "text1288": "Domänenname (www.vasadomena.sk)",
  "text1289": "Domänenname",
  "text1290": "Name des Domänenanbieters",
  "text1291": "Name des Anbieters",
  "text1292": "Ihr Anmeldename",
  "text1293": "Ihr Anmeldekennwort",
  "text1294": "Notizen, die für die Installation des Systems erforderlich sind (sie beschleunigen die Arbeit und die tatsächliche Übergabe des Produkts, wenn Sie sie nicht haben, können wir sie organisieren)",
  "text1295": "Buchungsformular",
  "text1296": "Wahl der Dienstleistung",
  "text1297": "Wählen Sie einen Friseur",
  "text1298": "Wählen Sie den Begriff",
  "text1299": "Geben Sie Ihren Kontakt ein",
  "text1300": "Aktuelle freie Termine",
  "text1301": "Unentschlossen",
  "text1302": "Montag",
  "text1303": "Dienstag",
  "text1304": "Mittwoch",
  "text1305": "Donnerstag",
  "text1306": "Freitag",
  "text1307": "Samstag",
  "text1308": "Sonntag",
  "text1309": "Die Woche",
  "text1310": "Keine Termine verfügbar",
  "text1311": "Zusammenfassung",
  "text1312": "Name des Friseurs",
  "text1313": "Dienst",
  "text1314": "Dauer",
  "text1315": "Minuten",
  "text1316": "Reservierung abschicken",
  "text1317": "Die Buchung war erfolgreich",
  "text1318": "Es ist notwendig, das Datum zu wählen",
  "text1319": "Die Reservierung konnte nicht erstellt werden. Bitte überprüfen Sie, ob das Formular korrekt ausgefüllt ist und versuchen Sie erneut, die Reservierung zu erstellen.",
  "text1320": "Es gab einen unerwarteten Fehler.",
  "text1321": "Weitere Informationen",
  "text1322": "Weitere Projekte ansehen",
  "text1323": "Projektdetails",
  "text1324": "Kontaktieren Sie uns bei Interesse\nüber Profis auf ihrem Gebiet!",
  "text1325": "Projekte",
  "text1326": "Projekte ansehen",
  "text1327": "Projektname",
  "text1328": "Jahr der Umsetzung",
  "text1329": "Standort",
  "text1330": "Referenzblatt",
  "text1331": "Unternehmensdaten",
  "text1332": "Bank",
  "text1333": "Zum Anrufen",
  "text1334": "Token einfügen",
  "text1335": "Buchung",
  "text1336": "Zur Kategorie gehen",
  "text1337": "navigieren.",
  "text1338": "Bleiben Sie auf dem Laufenden, indem Sie sich für unseren Newsletter anmelden!",
  "text1339": "Mit der Eingabe Ihrer E-Mail-Adresse bestätigen Sie, dass Sie mit der Verarbeitung Ihrer personenbezogenen Daten einverstanden sind, und Sie abonnieren den Spaceplan-Newsletter.",
  "text1340": "Jetzt buchen",
  "text1341": "Ich habe eine Treuekarte",
  "text1342": "Fehler bei der Erfassung einer Reservierung",
  "text1343": "Ausgewählte Produkte buchen",
  "text1344": "Mehr über unser Unternehmen",
  "text1345": "Unsere Leistungen",
  "text1346": "Vernetzen Sie sich mit uns",
  "text1347": "Sie haben sich erfolgreich vom Newsletter abgemeldet",
  "text1348": "Erstellen Sie eine neue",
  "text1349": "Abbrechen und verwerfen",
  "text1350": "Möchten Sie die Erstellung des Lebenslaufs abbrechen? Alle Daten gehen dann verloren.",
  "text1351": "Lebenslauf abgeben",
  "text1352": "Weiter erstellen",
  "text1353": "Fehler bei der Attributauswahl.",
  "text1354": "Kontaktaufnahme bis spätestens",
  "text1355": "Online-Preisberechnung",
  "text1356": "Wählen Sie die Produkte aus, deren Preise Sie interessieren:",
  "text1357": "Zitat ansehen",
  "text1358": "Ausgewählte Produkte für die Berechnung:",
  "text1359": "Produkt hinzufügen",
  "text1360": "Mehr lesen",
  "text1361": "Ich interessiere mich für das Produkt",
  "text1362": "Sind Sie an diesem Produkt interessiert? Füllen Sie das Formular aus und wir werden Sie so schnell wie möglich mit einem Angebot kontaktieren.",
  "text1363": "Es ist notwendig, das Produkt im vorherigen Schritt auszuwählen",
  "text1364": "Ohne Konfiguration",
  "text1365": "Füllen Sie das beigefügte Formular aus und wir werden uns so schnell wie möglich mit Ihnen in Verbindung setzen. Auch in diesem Schritt ist es für Sie noch ein unverbindliches Angebot",
  "text1366": "Projekt",
  "text1367": "Kontaktaufnahme bis spätestens",
  "text1368": "Senden Sie eine unverbindliche Anfrage für ein individuelles Angebot",
  "text1369": "Das Angebot herunterladen",
  "text1370": "Durchsuchen Sie",
  "text1371": "Dieses Produkt hat keine Einstellungen.",
  "text1372": "Die unverbindliche Anfrage für ein individuelles Angebot wurde erfolgreich versendet",
  "text1373": "Geschäftsführender Direktor",
  "text1374": "Handel und Dienstleistungen",
  "text1375": "Haben Sie eine Frage? Schreiben Sie uns",
  "text1376": "Wenn Sie eine Frage haben und sich mit uns in Verbindung setzen möchten, rufen Sie uns an, schicken Sie uns eine E-Mail, oder füllen Sie das Kontaktformular aus.",
  "text1377": "Das Projekt ansehen",
  "text1378": "Sind Sie an Produkten und Dienstleistungen interessiert?",
  "text1379": "Designer",
  "text1380": "Filter anwenden",
  "text1381": "Sie haben keine Lieblingsprodukte",
  "text1382": "Wunschzettel löschen",
  "text1383": "Wollen Sie Ihre Wunschliste wirklich löschen?",
  "text1384": "Ja, löschen",
  "text1385": "Nein, nicht löschen",
  "text1386": "Ungültige Rufnummer",
  "text1387": "Ungültige Telefonvorwahl",
  "text1388": "Alle Eigenschaften",
  "text1389": "Vertrieb",
  "text1390": "Miete",
  "text1391": "Kaufen",
  "text1392": "Angebot ansehen",
  "text1393": "Künstler",
  "text1394": "Bestellung mit Zahlungsverpflichtung absenden",
  "text1395": "Ich möchte verkaufen",
  "text1396": "Ich möchte kaufen",
  "text1397": "Ich möchte mieten",
  "text1398": "Keine Lieferorte verfügbar",
  "text1399": "Ausrüstung",
  "text1400": "Zurück zu Immobilien",
  "text1401": "Alle Fotos anzeigen",
  "text1402": "Wir sehen, dass Sie Produkte zu Ihren Favoriten hinzugefügt haben, obwohl Sie nicht eingeloggt waren. Möchten Sie Produkte zu Ihren Favoriten hinzufügen?",
  "text1403": "hinzufügen",
  "text1404": "Nicht akzeptieren",
  "text1405": "Der Kunde kann nicht zugeordnet werden.",
  "text1406": "Suche nach einem Produkt",
  "text1407": "Standort",
  "text1408": "Standort der Immobilie",
  "text1409": "Art der Immobilie",
  "text1410": "Wählen Sie",
  "text1411": "Stichwort eingeben",
  "text1412": "Wählen Sie eine Preisspanne",
  "text1413": "Liegenschaften",
  "text1414": "Budgets",
  "text1415": "Hauptsitz der Gesellschaft",
  "text1416": "Ich bin interessiert an",
  "text1417": "Ja",
  "text1418": "Nur neue Gebäude",
  "text1419": "Keine Immobilien",
  "text1420": "Angebotene Immobilien",
  "text1421": "Sortieren nach",
  "text1422": "Ich möchte verkaufen",
  "text1423": "Eigentum",
  "text1424": "Liegenschaften",
  "text1425": "angebotene Immobilien",
  "text1426": "angebotene Immobilien",
  "text1427": "Von",
  "text1428": "Kontakt",
  "text1429": "Wählen Sie die Art des Kontos, das Sie bei uns anlegen möchten",
  "text1430": "Benutzer",
  "text1431": "Studenten",
  "text1432": "Unternehmen",
  "text1433": "Schule",
  "text1434": "Unternehmenswebsite",
  "text1435": "Anschrift des eingetragenen Sitzes des Unternehmens",
  "text1436": "Registrierung des Unternehmens",
  "text1437": "Wenn Sie bereits ein Konto bei uns haben, bitte",
  "text1438": "anmelden.",
  "text1439": "Der Betrieb des Unternehmens unterscheidet sich vom Hauptsitz des Unternehmens",
  "text1440": "Kontaktangaben der verantwortlichen Person",
  "text1441": "Das Passwort muss aus mindestens 8 Zeichen bestehen.",
  "text1442": "zum Zweck der Einrichtung eines Kontos und der Kontaktaufnahme mit Ihnen.",
  "text1443": "Alle Projekte",
  "text1444": "Neu",
  "text1445": "Erfahren Sie mehr über das Produkt",
  "text1446": "Produkt kaufen",
  "text1447": "Anhänge zum Herunterladen",
  "text1448": "Gesamtpreis ohne MwSt.",
  "text1449": "Preis pro Stück ohne MwSt.",
  "text1450": "Preis der Waren ohne MwSt.",
  "text1451": "Gesamtbetrag ohne MwSt.",
  "text1452": "Vorschau der Konfiguration",
  "text1453": "Alle erweitern",
  "text1454": "Konfiguration des Produkts",
  "text1455": "Oberflächenbeschaffenheit",
  "text1456": "Oberflächenbehandlung der Rückseite",
  "text1457": "Türdesign",
  "text1458": "Ränder",
  "text1459": "Griffe",
  "text1460": "Scharniere",
  "text1461": "Ornamente",
  "text1462": "Abmessungen",
  "text1463": "Zusätzliche Daten",
  "text1464": "Geben Sie die Anzahl der Stücke ein",
  "text1465": "Anzahl der Stücke",
  "text1466": "Saubere Konfiguration",
  "text1467": "Konfigurator schließen",
  "text1468": "Konfigurator",
  "text1469": "Vorschau",
  "text1470": "Konfigurieren Sie",
  "text1471": "Ungültige Konfiguration",
  "text1472": "Ich denke, es ist an der Zeit",
  "text1473": "Stellen Sie die Stückzahl ein",
  "text1474": "Um etwas in den Warenkorb zu legen, müssen Sie die Anzahl der Stücke angeben",
  "text1475": "Meine Adressen",
  "text1476": "Registrierung der Benutzer",
  "text1477": "Registrierung von Studenten",
  "text1478": "Anmeldung zur Schule",
  "text1479": "Name der Schule",
  "text1480": "Schulwebsite",
  "text1481": "Adresse der Schule",
  "text1482": "Studienfächer an der Schule",
  "text1483": "E-Mail eines Schulmitarbeiters",
  "text1484": "Offizielle E-Mail der Schule",
  "text1485": "Abteilung hinzufügen",
  "text1486": "Füllen Sie das Feld aus",
  "text1487": "Die API-Konfiguration für Google Analytics ist nicht ausgefüllt.",
  "text1488": "Exportgenerierung gestartet",
  "text1489": "Exportgenerierung abgeschlossen",
  "text1490": "Suchen Sie einen Job? Füllen Sie das Kontaktformular aus",
  "text1491": "Sie haben unter den derzeit verfügbaren Stellenangeboten kein Angebot gefunden? Kein Problem, füllen Sie das Kontaktformular aus, laden Sie Ihren Lebenslauf hoch und wir melden uns bei Ihnen, wenn eine Stelle frei wird.",
  "text1492": "Karriere",
  "text1493": "Beschreiben Sie kurz die Stelle, an der Sie interessiert wären...",
  "text1494": "Wichtige Kontakte",
  "text1495": "Beliebte Angebote",
  "text1496": "Bereich der Tätigkeit",
  "text1497": "Größe des Unternehmens",
  "text1498": "Interessante Fakten über das Unternehmen",
  "text1499": "Beschreibung des Unternehmens",
  "text1500": "Übersicht der Angebote",
  "text1501": "Beschreibung der Schule",
  "text1502": "Überblick über die Studienfächer",
  "text1503": "Datum der Aufnahmeprüfung",
  "text1504": "Tag der offenen Tür",
  "text1505": "Zusammenarbeit / Berufspraxis",
  "text1506": "Es gibt keine Aufzeichnungen.",
  "text1507": "Kurse",
  "text1508": "Profil bearbeiten",
  "text1509": "Frühere Berufserfahrung",
  "text1510": "Ausbildung und Qualifikationen",
  "text1511": "Persönliche Fähigkeiten",
  "text1512": "Andere Fähigkeiten",
  "text1513": "Nationalität",
  "text1514": "Ort der Arbeit",
  "text1515": "Welche Schule besuchen Sie?",
  "text1516": "Nach welcher Art von Arbeit suchen Sie?",
  "text1517": "Nicht ausgefüllt",
  "text1518": "Profil des Unternehmens",
  "text1519": "Alle entfernen",
  "text1520": "Inserate",
  "text1521": "Profil der Schule",
  "text1522": "Gesuchte Unternehmen",
  "text1523": "Profil ansehen",
  "text1524": "Jobangebote in",
  "text1525": "Reinigen Sie den Filter",
  "text1526": "Informationen zum Stellenangebot",
  "text1527": "Gehalt",
  "text1528": "Abteilung",
  "text1529": "Position",
  "text1530": "Anzahl der offenen Stellen",
  "text1531": "Gültigkeit des Stellenangebots",
  "text1532": "Erforderliche Fähigkeiten",
  "text1533": "Andere Informationen",
  "text1534": "Ein Profil erstellen",
  "text1535": "Frühere Berufserfahrung",
  "text1536": "Ausbildung und Qualifikationen",
  "text1537": "Speichern und später fortsetzen",
  "text1538": "Geschlecht auswählen",
  "text1539": "Was ist Ihr Fachgebiet?",
  "text1540": "Grundlegende Unternehmensdaten",
  "text1541": "Logo",
  "text1542": "Interessante Fakten über das Unternehmen",
  "text1543": "Slogan des Unternehmens",
  "text1544": "Beschreiben Sie kurz Ihr Unternehmen und was es tut...",
  "text1545": "Schreiben Sie hier eine interessante Tatsache über Ihr Unternehmen...",
  "text1546": "Schreiben Sie Ihren Firmenslogan...",
  "text1547": "Kontaktinformationen des Unternehmens",
  "text1548": "Bieten Sie Praktika für Studenten an?",
  "text1549": "Würden Sie eine Zusammenarbeit mit Schulen begrüßen?",
  "text1550": "Ja",
  "text1551": "Nein",
  "text1552": "Facebook-Link",
  "text1553": "Instagram-Link",
  "text1554": "Linkedin-Link",
  "text1555": "Bereich der Tätigkeit",
  "text1556": "Größe des Unternehmens",
  "text1557": "Unternehmensgröße auswählen",
  "text1558": "Liste der Referenzen",
  "text1559": "Profil der Schule",
  "text1560": "Grunddaten der Schule",
  "text1561": "Schulprojekte",
  "text1562": "Die Adresse hat ein falsches Format",
  "text1563": "Die Erstellung eines Unternehmensprofils dient als Ihre Visitenkarte.",
  "text1564": "Studienfächer an der Schule",
  "text1565": "Schulen",
  "text1566": "Unternehmen",
  "text1567": "Versuchen Sie eine effektive Kandidatensuche",
  "text1568": "Jobiis Matching wird Ihnen einen geeigneten Kandidaten empfehlen.",
  "text1569": "Angebot hinzufügen",
  "text1570": "Kontaktdaten der Schule",
  "text1571": "Studienfächer an der Schule",
  "text1572": "Kurze Beschreibung der Schule",
  "text1573": "Interessante Fakten über die Schule",
  "text1574": "Beschreiben Sie kurz Ihre Schule...",
  "text1575": "Schalten Sie Ihr Stellenangebot und finden Sie den richtigen Bewerber",
  "text1576": "Nutzen Sie unser Portal, um ein Stellenangebot zu veröffentlichen und in kürzester Zeit den Kandidaten zu finden, der Ihren Anforderungen entspricht.",
  "text1577": "Nehmen Sie Kontakt zu Unternehmen auf und finden Sie einen Partner für eine Ausbildung oder ein Praktikum für Ihre Schüler.",
  "text1578": "Jobiis erleichtert Ihnen den Zugang zu Arbeits- und Praktikumsplätzen für Ihre Schüler.",
  "text1579": "Wären Sie daran interessiert, einen Vortrag mit einem Experten an Ihrer Schule zu organisieren?",
  "text1580": "Wir können Ihnen helfen, einen kostenlosen Vortrag mit einem Experten auf Ihrem Gebiet zu organisieren!",
  "text1581": "Finden Sie Ihre Übereinstimmung.",
  "text1582": "Abteilung hinzufügen",
  "text1583": "Bestellung",
  "text1584": "Logo hochladen",
  "text1585": "Zusammenarbeit der Schulen",
  "text1586": "Projekte, an denen die Schule beteiligt ist",
  "text1587": "Tag der offenen Tür",
  "text1588": "Datum der Aufnahmeprüfung",
  "text1589": "Wählen Sie das Datum",
  "text1590": "Art der Mitgliedschaft auswählen",
  "text1591": "Wenn Sie bei uns in ein anderes Land bestellen möchten, schreiben Sie uns bitte an",
  "text1592": "und wir werden Ihre Bestellung individuell bearbeiten.",
  "text1593": "Ein Projekt hinzufügen",
  "text1594": "Zusammenarbeit hinzufügen",
  "text1595": "Beschreibung des Unternehmens",
  "text1596": "Ihr Tätigkeitsbereich",
  "text1597": "Soziale Netzwerke",
  "text1598": "In welchem Kreis wollen Sie arbeiten?",
  "text1599": "Was ist Ihr Fachgebiet?",
  "text1600": "Welche Art von Arbeit suchen Sie?",
  "text1601": "Erwartetes Gehalt in € (pro Monat)",
  "text1602": "Sofort beginnen",
  "text1603": "Arbeitszeiten",
  "text1604": "Amtsbezeichnung",
  "text1605": "Sie besteht immer noch",
  "text1606": "Mehr hinzufügen",
  "text1607": "Titel Qualifizierung",
  "text1608": "Bildungseinrichtung",
  "text1609": "Ständige Weiterbildung",
  "text1610": "Website der Organisation",
  "text1611": "Löschen",
  "text1612": "Sprachkenntnisse",
  "text1613": "Muttersprache",
  "text1614": "Andere Sprachen",
  "text1615": "Digitale Kompetenzen",
  "text1616": "Welche digitalen Kompetenzen haben Sie?",
  "text1617": "Welche Führerscheinklasse haben Sie?",
  "text1618": "Art der Tätigkeit",
  "text1619": "Stellenbeschreibung",
  "text1620": "Position geeignet für",
  "text1621": "Untere Gehaltsgrenze in €",
  "text1622": "Obere Gehaltsgrenze in €",
  "text1623": "Industrie",
  "text1624": "Leistungen für Arbeitnehmer",
  "text1625": "Arbeitszeiten",
  "text1626": "Erforderliches Mindestalter",
  "text1627": "Abgeschlossene Ausbildung",
  "text1628": "Erforderliche Ausbildung in diesem Bereich",
  "text1629": "Sprachkenntnisse",
  "text1630": "Vorherige Erfahrung erforderlich",
  "text1631": "Erforderliche Qualifikationen",
  "text1632": "Persönlichkeitsvoraussetzungen",
  "text1633": "Informationen für Antragsteller",
  "text1634": "Diplom",
  "text1635": "Wählen Sie die Art der Arbeit",
  "text1636": "Welche Schule studieren Sie?",
  "text1637": "Wählen Sie günstige Arbeitszeiten",
  "text1638": "Eine Fähigkeit hinzufügen",
  "text1639": "Wählen Sie die Abteilungen",
  "text1640": "Wählen Sie die Art der Arbeit",
  "text1641": "Kreative Arbeiten",
  "text1642": "Konferenzen und Seminare",
  "text1643": "Hobbys und Interessen",
  "text1644": "Ehrungen und Auszeichnungen",
  "text1645": "Netzwerke und Mitgliedschaften",
  "text1646": "Projekte",
  "text1647": "Veröffentlichungen",
  "text1648": "Referenzen",
  "text1649": "Ehrenamtliche Tätigkeiten",
  "text1650": "Wählen Sie eine Fertigkeitsart",
  "text1651": "Qualifikationsniveau",
  "text1652": "Name des Werkes",
  "text1653": "Beschreibung der kreativen Arbeit",
  "text1654": "Datei hochladen",
  "text1655": "Name der Konferenz",
  "text1656": "Link zum Seminar/zur Konferenz",
  "text1657": "Beschreibung des Seminars/der Konferenz",
  "text1658": "Name des Hobbys/Interesses",
  "text1659": "Beschreibung der Hobbys/Interessen",
  "text1660": "Name der Auszeichnung/Prämie",
  "text1661": "Beschreibung der Auszeichnung/des Preises",
  "text1662": "Übertragende Einrichtung",
  "text1663": "Datum der Übergabe",
  "text1664": "Name der Mitgliedschaft",
  "text1665": "Beschreibung der Mitgliedschaft",
  "text1666": "Name des Projekts",
  "text1667": "Beschreibung des Projekts",
  "text1668": "Titel der Veröffentlichung",
  "text1669": "Datum der Veröffentlichung",
  "text1670": "Beschreibung der Veröffentlichung",
  "text1671": "Name der Referenz",
  "text1672": "Referenzblatt hochladen",
  "text1673": "Position (Referendum)",
  "text1674": "E-Mail (Volksabstimmungen)",
  "text1675": "Telefonnummer (Referendum)",
  "text1676": "Standort",
  "text1677": "Name der Freiwilligentätigkeit",
  "text1678": "Beschreibung der Freiwilligentätigkeit",
  "text1679": "Link zur Datei/Video",
  "text1680": "Andere",
  "text1681": "Sie haben keine zusätzlichen Fähigkeiten",
  "text1682": "Ihr Profil wurde erfolgreich aktualisiert",
  "text1683": "Profilbild hochladen",
  "text1684": "Eine Anzeige hinzufügen",
  "text1685": "Eine Anzeige erstellen",
  "text1686": "Lohnart",
  "text1687": "Standort",
  "text1688": "Meine Nachrichten",
  "text1689": "Falsches Token, versuchen Sie es erneut",
  "text1690": "Suche nach Angebotsname, Branche, Standort",
  "text1691": "Heute ist es",
  "text1692": "Kontakte",
  "text1693": "Zwischenspiel",
  "text1694": "So wählen Sie eine aktive Sitzung aus",
  "text1695": "Das herunterladbare Dokument und das Zugangspasswort stehen erst nach Bestätigung der Zahlung zur Verfügung.",
  "text1696": " Passwort zurücksetzen",
  "text1697": "Implementierungsdetails anzeigen",
  "text1698": "Implementierung",
  "text1699": "Ort",
  "text1700": "Alle Realisierungsvisualisierungen",
  "text1701": "Zurück zu allen Projekten",
  "text1702": "Produktdetails",
  "text1703": "Keine Benutzer",
  "text1704": "Nach Benutzern suchen",
  "text1705": "An",
  "text1706": "Kontaktformular aus dem Internet",
  "text1707": "Registrierung von Studenten",
  "text1708": "Navigieren Sie zum Shop",
  "text1709": "Wenn Sie über aktuelle Neuigkeiten, Fertigstellungstermine und Optionen informiert werden möchten, abonnieren Sie unseren Newsletter und erhalten Sie die neuesten Informationen direkt in Ihr Postfach.",
  "text1710": "Mo - Sa: 8:00 - 19:00",
  "text1711": "Wir werden Ihnen innerhalb von 24 Stunden antworten. während der Arbeitszeit.",
  "text1712": "Mustershop",
  "text1713": "Ein persönliches Treffen muss vorab vereinbart werden.",
  "text1714": "Füllen Sie das Formular aus und wir werden Ihre Frage so schnell wie möglich beantworten.",
  "text1715": "Mehr anzeigen",
  "text1716": "Sortieren",
  "text1717": "Übung für Studenten",
  "text1718": "Zusammenarbeit mit Schulen",
  "text1719": "Alter",
  "text1720": "Chat löschen",
  "text1721": "Keine Nachrichten",
  "text1722": "Wir bereiten dieses Produkt für Sie vor",
  "text1723": "Firmenadresse",
  "text1724": "Kontaktperson",
  "text1725": "www-Adresse",
  "text1726": "Titel vor Name",
  "text1727": "Eigenschaften des Unternehmens",
  "text1728": "Wählen Sie einen Bereich aus",
  "text1729": "Schließen Sie das Angebot ab",
  "text1730": "Erforderliche Sprachkenntnisse",
  "text1731": "Erforderliche Ausbildung",
  "text1732": "Erforderliche Berufserfahrung",
  "text1733": "Art des Stellenangebots",
  "text1734": "Mein Konto",
  "text1735": "Meine Biografie",
  "text1736": "Meine Stellenangebote",
  "text1737": "Meine Kurse",
  "text1738": "Mein Unternehmen",
  "text1739": "Biografien",
  "text1740": "Lebenslauf und Zeugnisse",
  "text1741": "Foto und Video",
  "text1742": "Fähigkeiten und Wissen",
  "text1743": "Kategorien von Branchen",
  "text1744": "Laden Sie Ihren Lebenslauf zum Herunterladen durch den Arbeitgeber hoch.",
  "text1745": "Zertifikat",
  "text1746": "Laden Sie die Zertifikate hoch, die Ihnen zur Verfügung stehen.",
  "text1747": "Motivationsschreiben",
  "text1748": "Motivationsschreiben hochladen.",
  "text1749": "Ein Foto ist nicht zwingend erforderlich, aber ein Lebenslauf mit Foto wirkt persönlicher und zieht den Personalvermittler mehr an.",
  "text1750": "Laden Sie Ihren Video-Lebenslauf hoch, der Sie Ihrer gewünschten Jobposition einen Schritt näher bringt.",
  "text1751": "Wussten Sie, dass es durchschnittlich 7 Sekunden dauert, bis ein Personalvermittler einen Lebenslauf zum ersten Mal scannt? Erwähnen Sie daher nur relevante Erfahrungen und beschreiben Sie diese in Stichpunkten oder kurzen Absätzen.",
  "text1752": "Teilen Sie Arbeitgebern Ihre Ausbildung mit.",
  "text1753": "Geben Sie ein, über welche Fähigkeiten und Kenntnisse Sie verfügen und auf welchem ​​Niveau.",
  "text1754": "Fügen Sie Ihrem Lebenslauf weitere Abschnitte hinzu, die für Sie wichtig sind.",
  "text1755": "Titel nach Name",
  "text1756": "Wählen Sie aus der Liste die Branchenkategorien aus, für die Sie sich bewerben möchten",
  "text1757": "Unsere sozialen Netzwerke",
  "text1758": "Unsere Referenzen",
  "text1759": "Zusätzliche Referenzen",
  "text1760": "Unser Team",
  "text1761": "Aktuelles Angebot",
  "text1762": "Ungültiger Schlüssel",
  "text1763": "Unsere Referenzen",
  "text1764": "Umweltfreundliche Industriechemikalien",
  "text1765": "Wie stellen wir Produkte her?",
  "text1766": "Möglichkeit, von zu Hause aus zu arbeiten?",
  "text1767": "Starttag",
  "text1768": "Beschreibung des Stellenangebots",
  "text1769": "Kontaktdaten für die Beantwortung des Angebots",
  "text1770": "Fügen Sie die erforderliche Berufserfahrung und das vom Bewerber geforderte Maß an Erfahrung hinzu.",
  "text1771": "Fügen Sie die erforderliche Ausbildung des Bewerbers hinzu.",
  "text1772": "Fügen Sie die erforderlichen Sprachkenntnisse für diese Stelle hinzu",
  "text1773": "Fügen Sie dem Angebot weitere Teile hinzu, die vom Bieter benötigt werden.",
  "text1774": "Name der Berufserfahrung",
  "text1775": "Niveau der Berufserfahrung",
  "text1776": "Neu hinzufügen",
  "text1777": "Highschool-Ausbildung",
  "text1778": "Hochschulausbildung der Stufe I",
  "text1779": "Hochschulbildung II. Abschluss",
  "text1780": "Hochschulbildung III. Abschluss",
  "text1781": "Stufe",
  "text1782": "Wählen Sie beim Antragsteller die von Ihnen benötigten Führerscheinklassen aus.",
  "text1783": "Ihr Lebenslauf wurde erfolgreich aktualisiert",
  "text1784": "Lebenslauf beenden",
  "text1785": "Neue Antwort in der Konsultation",
  "text1786": "Sie haben eine neue Antwort im Beratungsraum",
  "text1787": "Frage erfolgreich hinzugefügt",
  "text1788": "Hinzugefügt",
  "text1789": "Reaktionen auf die Anzeige",
  "text1790": "Jahre",
  "text1791": "Lebenslauf herunterladen",
  "text1792": "Verpackung",
  "text1793": "Finden Sie Ihr lokales Geschäft",
  "text1794": "Katalognummer",
  "text1795": "Lieferung 7 - 10 Tage",
  "text1796": "Registrieren",
  "text1797": "Sie haben keine Stellenangebote",
  "text1798": "Gesuchte Lebensläufe",
  "text1799": "Das spielt keine Rolle",
  "text1800": "Suche nach Hersteller, Name, Serie, Produktcode...",
  "text1801": "Entscheiden Sie sich für Qualität und Schönheit – kaufen Sie bei uns ein!",
  "text1802": "Wir sind Direktimporteur dieser Hersteller",
  "text1803": "Regulärer Preis für",
  "text1804": "Unser Preis für",
  "text1805": "Preis für 1 Packung",
  "text1806": "Geben Sie die Fläche ein, um die Anzahl der Pakete zu berechnen",
  "text1807": "Geben Sie den Desktop-Inhalt ein",
  "text1808": "Verpackung",
  "text1809": "Wählen Sie einen Softskill",
  "text1810": "Wählen Sie eine Ebene aus",
  "text1811": "Video ansehen",
  "text1812": "Keine neuen Benachrichtigungen",
  "text1813": "Verkaufen Sie mit uns",
  "text1814": "Wir arbeiten mit diesen Spediteuren zusammen",
  "text1815": "Anzeige bearbeiten",
  "text1816": "Empfohlene Stellenangebote",
  "text1817": "Offene Position",
  "text1818": "Kontaktieren Sie uns",
  "text1819": "Ähnliche Positionen",
  "text1820": "Wir behalten uns das Recht vor, Bewerbern, die die genannten Anforderungen nicht erfüllen, nicht zu antworten.",
  "text1821": "Über das Unternehmen",
  "text1822": "Unternehmensportfolio",
  "text1823": "Alle ablehnen",
  "text1824": "Website",
  "text1825": "Wie viele Artikel haben Sie?",
  "text1826": "Wie viele Bestellungen haben Sie pro Monat?",
  "text1827": "Übereinstimmung",
  "text1828": "Akzeptiert",
  "text1829": "Ja, ich möchte gelegentlich Neuigkeiten und Tipps zu E-Commerce-Diensten erhalten.",
  "text1830": "Abgelehnt",
  "text1831": "Warten",
  "text1832": "Er antwortete",
  "text1833": "Soft Skills",
  "text1834": "Wählen Sie aus über 60 Marken in unserem Portfolio und finden Sie genau das, was Sie suchen! Alles ist vollständig anpassbar – von der Polsterung bis zu den Farben. Kontaktieren Sie uns und wir erstellen gemeinsam ein individuelles Design nach Ihren Wünschen.",
  "text1835": "Produkte anzeigen",
  "text1836": "Wohin wird es gehen?",
  "text1837": "Kind",
  "text1838": "Kinder",
  "text1839": "Kinder",
  "text1840": "Erwachsener",
  "text1841": "Erwachsene",
  "text1842": "Erwachsene",
  "text1843": "1 bis 3 Nächte",
  "text1844": "4 bis 6 Nächte",
  "text1845": "7 bis 15 Nächte",
  "text1846": "16+ Nächte",
  "text1847": "Wählen Sie die Anzahl der Nächte aus",
  "text1848": "Weitere Optionen",
  "text1849": "Neue Frage",
  "text1850": "Ort, Ort, Hotel",
  "text1851": "Datum von - bis",
  "text1852": "Anzahl der Passagiere",
  "text1853": "Aufenthaltsdauer",
  "text1854": "Essen",
  "text1855": "Schließen",
  "text1856": "Weitere Optionen anzeigen",
  "text1857": "Höchstpreis pro Person",
  "text1858": "Mehr",
  "text1859": "Qualifikationstyp",
  "text1860": "Keine Tour erfüllt die angegebenen Kriterien.",
  "text1861": "Erfahren Sie mehr",
  "text1862": "Weitere Artikel der letzten Woche",
  "text1863": "Verkäufer",
  "text1864": "Preisliste der Biografien",
  "text1865": "Neue Großhandelsregistrierung",
  "text1866": "Überhaupt",
  "text1867": "Nicht viel",
  "text1868": "Neutral",
  "text1869": "Ein bisschen mehr",
  "text1870": "Sehr",
  "text1871": "Finden Sie es interessant?",
  "text1872": "Sie haben den Test erfolgreich abgeschlossen",
  "text1873": "Erledigt",
  "text1874": "Sie sind am besten geeignet für",
  "text1875": "Freie Positionen anzeigen",
  "text1876": "Ich bin kein Mehrwertsteuerzahler",
  "text1877": "Alle Benachrichtigungen anzeigen",
  "text1878": "Benachrichtigungen",
  "text1879": "Ungelesen",
  "text1880": "Alle als gelesen markieren",
  "text1881": "Keine Benachrichtigungen",
  "text1882": "Anzahl der anzuzeigenden Datensätze",
  "text1883": "Sie haben",
  "text1884": "neue Nachricht",
  "text1885": "neue Nachrichten",
  "text1886": "neue Nachrichten",
  "text1887": "Antwort auf den Anzeigenantrag",
  "text1888": "Reaktion auf Werbung",
  "text1889": "Vervollständigen Sie Ihr Profil",
  "text1890": "Neues Stellenangebot",
  "text1891": "Das Angebot läuft bald ab",
  "text1892": "Das Unternehmen zeigte Interesse",
  "text1893": "Neuer Bewerber",
  "text1894": "Aktualisieren Sie Ihr Profil",
  "text1895": "Systembenachrichtigung",
  "text1896": "Sie haben einen neuen Kandidaten für ein Stellenangebot",
  "text1897": "hat ein neues Stellenangebot hinzugefügt",
  "text1898": "Sie hat Interesse an dir gezeigt",
  "text1899": "Rabatt",
  "text1900": "Neueste Blogs",
  "text1901": "Empfohlene Produkte",
  "text1902": "Neuigkeiten und Rabatte",
  "text1903": "Kategoriedetail",
  "text1904": "Füllen Sie alle Fragen aus, um fortzufahren",
  "text1905": "Test senden",
  "text1906": "Sonderaktion",
  "text1907": "Ich möchte über Loft.cz verkaufen",
  "text1908": "Geben Sie Ihre E-Mail-Adresse ein und verpassen Sie keine einzigartigen Angebote",
  "text1909": "Service",
  "text1910": "Infoline",
  "text1911": "Geeignete Arbeitsbereiche",
  "text1912": "Geeignete Arbeitsumgebung",
  "text1913": "Machen Sie mit",
  "text1914": "Erwartetes Gehalt",
  "text1915": "Lieblingsunternehmen",
  "text1916": "Gehen Sie zu allen Schulen",
  "text1917": "Abonnement",
  "text1918": "Zuletzt gesehen",
  "text1919": "Meine Veranstaltungen",
  "text1920": "Nächster Artikel",
  "text1921": "Vorheriger Artikel",
  "text1922": "Fahren Sie mit dem Kauf eines Abonnements fort.",
  "text1923": "Lieferland",
  "text1924": "Müssen Sie uns kontaktieren? Schreiben Sie uns an",
  "text1925": "GHP",
  "text1926": "EHP",
  "text1927": "Aktives Abonnement",
  "text1928": "Wenn Sie Ihr Abonnement kündigen, bleibt Ihr Abonnement bis zum Ende des Abonnementzeitraums aktiv.",
  "text1929": "Abonnementverlauf",
  "text1930": "Rechnung herunterladen",
  "text1931": "Abonnement aktiviert",
  "text1932": "Fähigkeiten",
  "text1933": "Haben Sie bereits ein Abonnement erworben?",
  "text1934": "Melden Sie sich bei Ihrem Konto an.",
  "text1935": "Das Abonnement beinhaltet den Zugang zu allen Tanzkursen, Workouts und anderen Informationen sowie 10 % Rabatt auf alle Danceana OZ-Veranstaltungen für registrierte Benutzer.",
  "text1936": "Erstellen Sie Ihre Anmeldeinformationen.",
  "text1937": "Anfang",
  "text1938": "Ende",
  "text1939": "Partner",
  "text1940": "Kaufen Sie ein Abonnement",
  "text1941": "Alle Ereignisse",
  "text1942": "Weniger",
  "text1943": "Alle Alben",
  "text1944": "Galerie ansehen",
  "text1945": "Was bekommen Sie?",
  "text1946": "Ich möchte Partner werden",
  "text1947": "Alle von ihnen",
  "text1948": "Dozenten",
  "text1949": "Andere Kurse, die Sie interessieren könnten",
  "text1950": "Geschäftsbedingungen",
  "text1951": "In dieser Kategorie sind keine Kurse verfügbar.",
  "text1952": "Datenänderung speichern",
  "text1953": "Bitte bestätigen Sie Ihre E-Mail-Adresse",
  "text1954": "Überprüfen",
  "text1955": "Über mich",
  "text1956": "Bisher",
  "text1957": "Werte",
  "text1958": "Um die Registrierung abzuschließen, ist eine Bestätigung der E-Mail-Adresse erforderlich",
  "text1959": "Bestätigungs-E-Mail erneut senden",
  "text1960": "Die Bestätigungs-E-Mail wurde erneut gesendet",
  "text1961": "Beim Senden der Bestätigungs-E-Mail ist ein Fehler aufgetreten",
  "text1962": "Die E-Mail-Adresse wurde erfolgreich bestätigt",
  "text1963": "Suche nach Schulen",
  "text1964": "Keine Schulen",
  "text1965": "Wählen Sie einen Ort aus",
  "text1966": "Abonnieren Sie den Newsletter und erhalten Sie immer die aktuellsten Informationen aus unserem Angebot",
  "text1967": "Was Kunden über uns gesagt haben",
  "text1968": "Keine Eigenschaften entsprechen dem ausgewählten Filter",
  "text1969": "Sie wären für die Positionen am besten geeignet",
  "text1970": "Passende Stellenangebote",
  "text1971": "Arbeitsleistungen",
  "text1972": "Qualifikationen",
  "text1973": "Die E-Mail-Adresse konnte nicht bestätigt werden",
  "text1974": "Test ausführen",
  "text1975": "Möchten Sie diese Anzeige wirklich löschen?",
  "text1976": "Tag",
  "text1977": "Tage",
  "text1978": "Tage",
  "text1979": "Lieferantenliste ausblenden",
  "text1980": "Liste der Lieferanten anzeigen",
  "text1981": "Überprüfen Sie die Verfügbarkeit beim Verkäufer",
  "text1982": "Händler auswählen",
  "text1983": "Wählen Sie einen Händler aus",
  "text1984": "Händlerliste ausblenden",
  "text1985": "Liste der Verkäufer anzeigen",
  "text1986": "Vielen Dank, wir haben Ihre Anfrage registriert und werden uns innerhalb weniger Stunden bei Ihnen melden",
  "text1987": "Lieblingsschulen",
  "text1988": "Wenn Sie noch kein Konto bei uns haben",
  "text1989": "Diese Schule hat noch kein verifiziertes Profil",
  "text1990": "Lebenslauf als PDF speichern",
  "text1991": "Interessenten kontaktieren",
  "text1992": "Führerscheine",
  "text1993": "Produkte anzeigen",
  "text1994": "Der Wert muss aus einem Intervall stammen",
  "text1995": "Eintreten",
  "text1996": "Grundstufe",
  "text1997": "Wählen Sie die Dauer Ihrer Mitgliedschaft aus",
  "text1998": "Preis für 1-Monats-Abonnement",
  "text1999": "Wählen Sie die Anzahl der Lebensläufe aus",
  "text2000": "Alle Artikel",
  "text2001": "Abonnieren Sie den Newsletter und erhalten Sie als Erster die aktuellsten Informationen zu Rabatten, Neuigkeiten und Veranstaltungen.",
  "text2002": "Mit dem Absenden eines Abonnements für den Newsletter erklären Sie sich damit einverstanden",
  "text2003": "Sie haben die Antwort nicht gefunden\nzur Frage?",
  "text2004": "Rufen Sie uns an und fragen Sie",
  "text2005": "Unser Laden mit Vermietung",
  "text2006": "Vermietungsbüro",
  "text2007": "Sie benötigen Beratung oder haben eine Frage zu einem Produkt? Kontaktieren Sie uns und wir werden uns bei Ihnen melden.",
  "text2008": "Schreiben Sie uns",
  "text2009": "Erforderliche Ausbildung/Erfahrung in diesem Bereich",
  "text2010": "Senden Sie Interesse an einem Stellenangebot",
  "text2011": "Interesse am Stellenangebot wurde gesendet",
  "text2012": "Unternehmen anzeigen",
  "text2013": "Brauchen Sie Rat? Nehmen Sie Kontakt mit uns auf",
  "text2014": "Alle anzeigen",
  "text2015": "Ich bin nicht damit einverstanden, im Rahmen des von Kunden bestätigten Heureka-Programms einen Zufriedenheitsfragebogen zu versenden.",
  "text2016": "Soziale Netzwerke hinzufügen",
  "text2017": "Preis inklusive 23 % Mehrwertsteuer",
  "text2018": "Mietbedingungen HIER",
  "text2019": "Melden Sie sich an",
  "text2020": "Haben Sie bereits Ihr Konto?",
  "text2021": "Wählen Sie ein Motorrad",
  "text2022": "Suche nach Motorradname...",
  "text2023": "Es wurden keine Produkte gefunden für",
  "text2024": "In dieser Kategorie sind keine Produkte verfügbar",
  "text2025": "Alles löschen",
  "text2026": "Darf nur Zahlen enthalten",
  "text2027": "Schulart",
  "text2028": "Zurück zur Motorradauswahl",
  "text2029": "Vielen Dank, Interesse am Testen\nDie Fahrt wurde verschickt.",
  "text2030": "Wir werden uns schnellstmöglich mit Ihnen in Verbindung setzen und den Termin Ihrer Probefahrt vereinbaren",
  "text2031": "Zurück zur Hauptseite",
  "text2032": "Spezialisierung",
  "text2033": "Höchste abgeschlossene Ausbildung",
  "text2034": "Adresse des Arbeitsortes",
  "text2035": "Ich habe mein eigenes Muster",
  "text2036": "Senden Sie uns über dieses Formular Ihr eigenes Design/Muster und wir nennen Ihnen einen Preis\n              Produktion.",
  "text2037": "Kursdaten",
  "text2038": "Softskill hinzufügen",
  "text2039": "Das Interesse wurde erfolgreich gesendet",
  "text2040": "Das Interesse an dem Stellenangebot hat sich bereits bemerkbar gemacht.",
  "text2041": "Sind Sie sicher, dass Sie Ihr Interesse an diesem Stellenangebot bekunden möchten?",
  "text2042": "Interesse bestätigen",
  "text2043": "Kauf bestätigen",
  "text2044": "Sind Sie sicher, dass Sie ein Abonnement erwerben möchten?",
  "text2045": "Zeitraum",
  "text2046": "Monate",
  "text2047": "Aktivieren Sie Benachrichtigungen",
  "text2048": "Neues Angebot des Arbeitgebers",
  "text2049": "Neue Antwort, um Interesse zu wecken",
  "text2050": "Benachrichtigung über den Ablauf beliebter Anzeigen",
  "text2051": "Neues Interesse des Unternehmens",
  "text2052": "Schulen",
  "text2053": "Wird angezeigt",
  "text2054": "Gewerkschaften",
  "text2055": "Ort der gesuchten Arbeit",
  "text2056": "Erwartetes Gehalt",
  "text2057": "Entfernung zur Arbeit",
  "text2058": "Arbeitsstunden",
  "text2059": "Profilerstellungsdatum",
  "text2060": "Empfohlene Auflösungen",
  "text2061": "Das Produkt kann nach der Bezahlung der Bestellung heruntergeladen werden",
  "text2062": "Sie haben kein vollständig ausgefülltes Profil",
  "text2063": "Vorname, Nachname und mindestens 1 Soft Skill sind erforderlich",
  "text2064": "Mindestens 1 Soft Skill",
  "text2065": "Das Erstellen eines Profils dient auch als Lebenslauf. Bitte führen Sie die einzelnen Schritte durch und beantworten Sie die folgenden Fragen.",
  "text2066": "Annahme des Bewerbers abbrechen",
  "text2067": "Sie möchten das Interesse des Bewerbers bestätigen",
  "text2068": "Akzeptieren Sie den Bewerber",
  "text2069": "Das Interesse des Antragstellers wird bestätigt",
  "text2070": "Bestätigen",
  "text2071": "Interesse akzeptieren",
  "text2072": "Interesse ablehnen",
  "text2073": "Der Kandidat erhält eine Nachricht, dass Sie ihn angenommen haben",
  "text2074": "Übung für Studenten",
  "text2075": "Keine Angebote",
  "text2076": "Ansicht",
  "text2077": "Angebot",
  "text2078": "Angebote",
  "text2079": "Alle akzeptieren",
  "text2080": "Bestätigen Sie alle Angebote",
  "text2081": "Diese Aktion bestätigt das Interesse an der Stelle aller Kandidaten, deren Bewerbung den Status „Ausstehend“ hat.",
  "text2082": "Kandidaten erhalten eine Nachricht, dass Sie sie angenommen haben",
  "text2083": "Alle Angebote werden bestätigt...",
  "text2084": "Konzept",
  "text2085": "Aktiv",
  "text2086": "Archiviert",
  "text2087": "Entwurf speichern",
  "text2088": "Fügen Sie einen Soft Skill hinzu",
  "text2089": "Das Konto wird gelöscht",
  "text2090": "Möchten Sie das Konto wirklich löschen?",
  "text2091": "Sehen Sie sich meinen Lebenslauf in der Lebenslaufdatenbank an",
  "text2092": "Rev-Freischaltung",
  "text2093": "Sie sind kein Jobiis-Partner",
  "text2094": "Wenn Sie Lebenslauf-Freischaltungen zu einem reduzierten Preis kaufen möchten, müssen Sie zunächst das „Jobiis Partner“-Abonnement aktivieren",
  "text2095": "Das Formular ist nicht ausgefüllt",
  "text2096": "Reaktionen anzeigen",
  "text2097": "Werbung entfernen",
  "text2098": "Archiv",
  "text2099": "Aktivieren",
  "text2100": "Archiviert",
  "text2101": "Aktiv",
  "text2102": "Formular falsch ausgefüllt",
  "text2103": "Das Formular ist nicht korrekt ausgefüllt. Überprüfen Sie das Formular und senden Sie es erneut.",
  "text2104": "Sie haben diese Biografie nicht freigeschaltet",
  "text2105": "Lebenslauf freischalten",
  "text2106": "Um auf die Informationen in diesem Lebenslauf zugreifen zu können, muss der Lebenslauf entsperrt werden.",
  "text2107": "Entsperren",
  "text2108": "Verbleibende kostenlose Freischaltungen",
  "text2109": "Schaltet die verbleibenden gekauften Artikel frei",
  "text2110": "Lebenslauf wurde freigeschaltet",
  "text2111": "Lebenslauf anzeigen",
  "text2112": "Unbezahlt",
  "text2113": "Bezahlen",
  "text2114": "Oben",
  "text2115": "Keine Produkte im Warenkorb",
  "text2116": "Sie haben nicht genügend Guthaben",
  "text2117": "Unternehmensvorteile",
  "text2118": "Angebot für Ausländer geeignet",
  "text2119": "Angebot geeignet für einen Absolventen",
  "text2120": "Bildungskurse",
  "text2121": "Stellen Sie eine Verbindung zu Ihrem zukünftigen Job her",
  "text2122": "Ich bin Arbeitgeber",
  "text2123": "Ich bin ein Kandidat",
  "text2124": "Gebot zahlen",
  "text2125": "Angebot kostenlos freischalten",
  "text2126": "Kostenlose Angebote",
  "text2127": "Entsperrmenü",
  "text2128": "Artikel",
  "text2129": "Partner",
  "text2130": "Kostenloses Angebot nutzen",
  "text2131": "bleibt",
  "text2132": "Verwenden Sie kostenlosen Belag",
  "text2133": "Meine Lebensläufe",
  "text2134": "Gekrönt",
  "text2135": "Gesamtbetrag für die Zahlung",
  "text2136": "Zusammenfassung der Bestellung",
  "text2137": "Weiter zur Zusammenfassung",
  "text2138": "Produkte zum Kauf",
  "text2139": "Lieferadresse",
  "text2140": "Zurück zu den Versand- und Rechnungsinformationen",
  "text2141": "für Auftragsabwicklungs- und Marketingzwecke.",
  "text2142": "Ich bin damit einverstanden, Informationen über Neuigkeiten, Rabatte und Preisaktionen zu senden.",
  "text2143": "maximal 600 Zeichen",
  "text2144": "Firmendaten entsprechend der ID-Nummer hinzufügen",
  "text2145": "Daten hinzufügen",
  "text2146": "Sie haben Ihre Daten nicht eingegeben",
  "text2147": "In Ihrem Profil sind die Rechnungsdaten nicht vollständig ausgefüllt.",
  "text2148": "Gültig bis",
  "text2149": "maximal 600 Zeichen",
  "text2150": "Pflichtig",
  "text2151": "Möchten Sie die vorgenommenen Änderungen speichern?",
  "text2152": "Nicht speichern",
  "text2153": "Gekrönt zu",
  "text2154": "Keine Reaktionen auf das Angebot",
  "text2155": "Lebensläufe kaufen",
  "text2156": "Suche nach Stadt",
  "text2157": "Monate",
  "text2158": "Berufliche Praxis für Studierende",
  "text2159": "Qualifikations-/Ausbildungstitel",
  "text2160": "Abgeschlossene Ausbildung",
  "text2161": "Organisation, die Bildung/Qualifikation anbietet",
  "text2162": "Die eingegebene E-Mail existiert bereits",
  "text2163": "Größe des Unternehmens",
  "text2164": "Wählen Sie die Größe des Unternehmens aus",
  "text2165": "Vorteile anzeigen",
  "text2166": "Grundlegend",
  "text2167": "Der Inhalt ist kein gültiges XML",
  "text2168": "Der Inhalt ist kein gültiges JSON",
  "text2169": "Kauf in Raten",
  "text2170": "Monat",
  "text2171": "Sie haben keine Ausbildung/Qualifikation hinzugefügt",
  "text2172": "Einen Fehler melden",
  "text2173": "Kurze Freischaltung",
  "text2174": "Angebote freischalten",
  "text2175": "Topping",
  "text2176": "Fehlerbeschreibung",
  "text2177": "Es wurde ein Fehler gemeldet",
  "text2178": "Einen weiteren Fehler melden",
  "text2179": "Es wird ein Fehler gesendet",
  "text2180": "Ein als Entwurf gespeichertes Menü muss einen Namen haben",
  "text2181": "Überprüfung der Warenverfügbarkeit",
  "text2182": "Adresse des Verkäufers",
  "text2183": "Hallo, im Eshop",
  "text2184": "Wir haben die Nachfrage des Kunden nach folgenden Waren registriert:",
  "text2185": "Bitte teilen Sie uns mit, ob Sie die gewünschte Ware im Geschäft haben, damit wir den Kunden informieren können.",
  "text2186": "Grüße, Vertriebsabteilung",
  "text2187": "Ihr Profil ist noch nicht ausgefüllt",
  "text2188": "Damit Unternehmen Ihr Profil sehen können, ist es notwendig, die folgenden Informationen auszufüllen",
  "text2189": "Profil ausfüllen",
  "text2190": "Wenn Sie möchten, dass Unternehmen Ihr Profil in der Lebenslaufdatenbank sehen, müssen Sie die folgenden Informationen ausfüllen:",
  "text2191": "Profil beenden",
  "text2192": "Administrator",
  "text2193": "Update",
  "text2194": "Interessenprofil",
  "text2195": "Wählen Sie einen Tutor",
  "text2196": "Andere Lehrveranstaltungen",
  "text2197": "Fortschritt des Lagers",
  "text2198": "Lehrteam",
  "text2199": "Einzelne Kurse",
  "text2200": "Anmeldungen",
  "text2201": "Alle Hallen",
  "text2202": "Vollständiger Zeitplan",
  "text2203": "Veranstaltungsgalerie",
  "text2204": "Medien",
  "text2205": "Haben Sie keine Antwort auf Ihre Frage gefunden? Kontaktieren Sie uns.",
  "text2206": "Lehrer",
  "text2207": "Über den Dozenten",
  "text2208": "Welche Tanzarten unterrichte ich?",
  "text2209": "Tanzerfahrungsstufen",
  "text2210": "Dozentengalerie",
  "text2211": "Tänzerin",
  "text2212": "Pädagoge",
  "text2213": "Klassifizierung (wählen Sie aus Optionen) *",
  "text2214": "Geben Sie den Namen der Tanzgruppe / ZUŠ und den Ort ein, an dem sie tätig ist",
  "text2215": "Wählen Sie eine Schule aus",
  "text2216": "Bei Problemen kontaktieren Sie uns bitte",
  "text2217": "Diese E-Mail wird als Anmeldename verwendet.",
  "text2218": "Nach der Registrierung erhalten Sie eine Bestätigungs-E-Mail.",
  "text2219": "Abonnementbedingungen",
  "text2220": "Abonnementbedingungen",
  "text2221": "Das Angebot ist nicht vollständig ausgeschöpft. Wenn Sie das Angebot veröffentlichen möchten, bearbeiten Sie das Angebot so, dass alle erforderlichen Felder ausgefüllt sind.",
  "text2222": "Wenn Sie das Angebot als Entwurf speichern möchten, müssen Sie den Namen des Angebots eingeben.",
  "text2223": "Gebotszahlung",
  "text2224": "Das Angebot wird erst nach Zahlungseingang veröffentlicht",
  "text2225": "Sie können das Angebot im Profil im Abschnitt bezahlen",
  "text2226": "Stellenangebot",
  "text2227": "Ich stimme wiederkehrenden Zahlungen zu",
  "text2228": "Preisliste",
  "text2229": "Das Erstellen eines Schulprofils dient als Visitenkarte Ihrer Schule.",
  "text2230": "Herzlichen Glückwunsch! Ihr Anzeigenantrag wurde genehmigt. Klicken Sie hier, um einen Chat mit dem Unternehmen zu öffnen.",
  "text2231": "Leider wurde Ihr Anzeigenantrag abgelehnt.",
  "text2232": "Der Kurs wurde erfolgreich zum Warenkorb hinzugefügt",
  "text2233": "Artikel im Warenkorb",
  "text2234": "Natürliche Person",
  "text2235": "Juristische Person (Firma)",
  "text2236": "Inklusion",
  "text2237": "Wählen Sie aus Optionen",
  "text2238": "E-Mail-Adresse eingeben",
  "text2239": "Geben Sie die Telefonnummer ein",
  "text2240": "Geben Sie einen Namen ein",
  "text2241": "Geben Sie den Nachnamen ein",
  "text2242": "Menü „Bearbeiten“.",
  "text2243": "Sie müssen angemeldet sein, bevor Sie ein Abonnement erwerben können",
  "text2244": "Sie haben noch kein Konto?",
  "text2245": "Erstellen Sie es hier",
  "text2246": "Galerie",
  "text2247": "Interessiert",
  "text2248": "mit Profi",
  "text2249": "Videobiografie",
  "text2250": "Rezept",
  "text2251": "Erstellen Sie einen professionellen Lebenslauf",
  "text2252": "Kartennummer",
  "text2253": "Gültigkeit der Karte",
  "text2254": "CVV",
  "text2255": "MM / JJ",
  "text2256": "Dozent",
  "text2257": "Greifen Sie über auf die Kursinhalte zu",
  "text2258": "Abonnement.",
  "text2259": "Wenn Sie ein Abonnement erworben haben,",
  "text2260": "anmelden.",
  "text2261": "Sie haben keine Lieblingskurse",
  "text2262": "Karte entfernen",
  "text2263": "Fahrradservice",
  "text2264": "Bezahlen und veröffentlichen",
  "text2265": "Später bezahlen",
  "text2266": "Link zur Reaktion auf das Angebot",
  "text2267": "Lassen Sie das Feld leer, wenn Sie Antworten auf das Angebot in unserem System verwalten möchten",
  "text2268": "Interesse direkt senden",
  "text2269": "Bezahlt",
  "text2270": "Abmelden",
  "text2271": "Wenn Sie keine E-Mails erhalten möchten, klicken Sie auf den Link",
  "text2272": "Unsere Adresse",
  "text2273": "Besuchen Sie uns",
  "text2274": "Name des Karteninhabers",
  "text2275": "Falsches Format des privaten Schlüssels",
  "text2276": "Wir empfehlen die Bestellung",
  "text2277": "Fügen Sie der Nachricht eine DXF-Datei hinzu. Wenn mehrere Dateien vorhanden sind, packen Sie diese in .rar oder .zip",
  "text2278": "Fragen Sie nach dem Preis.",
  "text2279": "Geben Sie die Menge ein",
  "text2280": "Ihre Preisanfrage wurde gesendet. Wir werden Sie über Ihre E-Mail-Adresse kontaktieren.",
  "text2281": "Ich bin nicht interessiert",
  "text2282": "Sie haben bei uns gekauft",
  "text2283": "Mehr als 2.789 zufriedene Kunden",
  "text2284": "Ausgewählte Kategorien",
  "text2285": "300m2 Laden",
  "text2286": "Mo-Fr: 8:30 - 17:00 Uhr",
  "text2287": "Bonusclub",
  "text2288": "Möchten Sie sich wirklich abmelden?",
  "text2289": "Ja, abmelden",
  "text2290": "Änderungen speichern",
  "text2291": "erstellen Sie es hier.",
  "text2292": "Wenn Sie noch kein Konto haben,",
  "text2293": "Nein, abbrechen",
  "text2294": "Zufriedener Kunde",
  "text2295": "Person",
  "text2296": "Unternehmen",
  "text2297": "Auf Lager",
  "text2298": "an Ihrer Adresse",
  "text2299": "Erkunden",
  "text2300": "Meistverkaufte Produkte",
  "text2301": "Mehr laden",
  "text2302": "Sortieren",
  "text2303": "Sofortiger Versand",
  "text2304": "Vergleichen",
  "text2305": "Technische Parameter",
  "text2306": "Fügen Sie eine Bewertung hinzu",
  "text2307": "Beim Aktualisieren Ihres Profils ist ein Fehler aufgetreten.",
  "text2308": "Allgemeine Bestimmungen",
  "text2309": "Das Hauptangebot",
  "text2310": "Informationen zu Ihrer Bestellung",
  "text2311": "Die Bestellung wurde bezahlt",
  "text2312": "Die Bestellung wurde noch nicht bezahlt",
  "text2313": "Weiter nach unten",
  "text2314": "TOP-Auswahl",
  "text2315": "Entdecken Sie die TOP-Auswahl für jeden Garten",
  "text2316": "Beliebt bei Hausbesitzern in der ganzen Slowakei",
  "text2317": "Die beliebtesten Holzkonstruktionen und Accessoires für Ihren Garten",
  "text2318": "Entdecken Sie unsere meistverkauften Kategorien an Holzpavillons, Häusern, Schuppen und Zubehör. Qualität und schnelle Lieferung in der gesamten Slowakei.",
  "text2319": "Alle Kategorien",
  "text2320": "Was macht unsere Produkte besonders?",
  "text2321": "Technische Details",
  "text2322": "Unsere neuesten Referenzen",
  "text2323": "Qualifikation",
  "text2324": "Warum sollten Sie sich für Pavillons und Häuser aus Holz entscheiden?",
  "text2325": "Möchten auch Sie Ihr Traum-Gartenhaus oder Ihren Traumpavillon?",
  "text2326": "Entdecken Sie das Angebot",
  "text2327": "Vorteile",
  "text2328": "Was bekommen Sie mit unseren Produkten?",
  "text2329": "Ich bin an einer Beratung interessiert.",
  "text2330": "Implementierungen",
  "text2331": "Zufriedene Kundengeschichten",
  "text2332": "Weitere Erkenntnisse",
  "text2333": "Interessante Artikel zum Lesen",
  "text2334": "Haben Sie die Antwort auf Ihre Frage nicht gefunden? Zögern Sie nicht, uns zu kontaktieren.",
  "text2335": "Video abspielen",
  "text2336": "Sind Sie bereit, Ihren Garten umzugestalten?",
  "text2337": "Benötigen Sie Beratung? Kontaktieren Sie uns gerne entweder über das Kontaktformular oder direkt über die unten stehenden Kontaktdaten.",
  "text2338": "Füllen Sie das Formular aus.",
  "text2339": "Was interessiert Sie?",
  "text2340": "Ihre Nachricht",
  "text2341": "Mit dem Absenden des Formulars erklären Sie sich einverstanden",
  "text2342": "Verarbeitung personenbezogener Daten.",
  "text2343": "Nachricht senden",
  "text2344": "Abonnieren Sie unseren Newsletter und erhalten Sie die aktuellsten Informationen zu unserem Angebot.",
  "text2345": "Sie haben Ihr Passwort vergessen?",
  "text2346": "Bitte geben Sie die Bestellnummer und die E-Mail-Adresse ein.",
  "text2347": "Die Bestellung für die angegebene Kombination aus Bestellnummer und E-Mail existiert nicht.",
  "text2348": "Sie sind angemeldet. Alle Ihre Bestellungen finden Sie in Ihrem Profil.",
  "text2349": "Das Passwort muss mindestens 6 bis 64 Zeichen, einen Großbuchstaben und eine Zahl enthalten.",
  "text2350": "Persönliche/Firmendaten",
  "text2351": "Inventarnummer",
  "text2352": "Ihre Registrierung war erfolgreich. Wir haben Ihnen einen Bestätigungslink zur Aktivierung Ihres Kontos in Ihrem E-Mail-Postfach gesendet.",
  "text2353": "Wählen Sie eine Kategorie entsprechend Ihrer Präferenz und finden Sie das Produkt, nach dem Sie suchen.",
  "text2354": "Weitere Kategorien anzeigen",
  "text2355": "Sortieren nach",
  "text2356": "Über die Kategorie",
  "text2357": "Kalkulator",
  "text2358": "Kontaktieren Sie uns, wir helfen Ihnen gerne weiter.",
  "text2359": "Zu diesem Produkt wurden noch keine Bewertungen abgegeben. Teilen Sie als Erster Ihre Erfahrungen mit!",
  "text2360": "Bewertungen",
  "text2361": "Bestellhistorie",
  "text2362": "Ich kaufe für ein Unternehmen.",
  "text2363": "Bestätigen Sie die Passwortänderung",
  "text2364": "Es ist ein Fehler aufgetreten.",
  "text2365": "Bezugsort",
  "text2366": "Über das Projekt",
  "text2367": "Galerie des Projekts",
  "text2368": "Kundenerfahrung",
  "text2369": "Ähnliche Erkenntnisse",
  "text2370": "Weiter zum Artikel",
  "text2371": "Inhalt des Artikels",
  "text2372": "Mo - Fr",
  "text2373": "Sa - So\n",
  "text2374": "Geschlossen",
  "text2375": "Navigieren Sie zu Verkehr",
  "text2376": "Wir haben keine Inhalte gefunden, die den Suchkriterien entsprechen.",
  "text2377": "Vielen Dank für Ihr Interesse.",
  "text2378": "Wir werden uns so schnell wie möglich bei Ihnen melden.",
  "text2379": "Homepage",
  "text2380": "Inspirationen",
  "text2381": "Inspirationen für Ihren Garten",
  "text2382": "Sehen Sie sich den Prozess der Herstellung eines Gartenhauses und eines Pavillons an",
  "text2383": "Wir gegen die Konkurrenz",
  "text2384": "Worin sind wir besser als die Konkurrenz?",
  "text2385": "Wettbewerb",
  "text2386": "Gartenpavillons und Häuser aus Holz für Ihren Garten",
  "text2387": "Qualität und günstige Preise mit Lieferung in der Slowakei",
  "text2388": "Schaffen Sie mit unseren Holzpavillons, Häusern, Pergolen und Carports den perfekten Raum zum Entspannen, Lagern oder zum Schutz Ihres Autos. Bestellen Sie noch heute!",
  "text2389": "Preis pro Stück",
  "text2390": "Zahlung und Versand",
  "text2391": "Pro API-Integration ist nur eine aktive Kategorie zulässig.",
  "text2392": "Wenn Sie ein Konto bei uns haben, melden Sie sich an und wir füllen die Details basierend auf Ihren Kontoinformationen aus.",
  "text2393": "Erfahren Sie, wovon unsere Kunden schwärmen. Diese erstklassigen Produkte vereinen Stil, Funktionalität und Erschwinglichkeit.",
  "text2394": "Entdecken Sie unsere beliebtesten Holzkonstruktionen aus hochwertigem Fichten- oder Kiefernholz für Langlebigkeit und Charme. Perfekt für jeden Außenbereich.",
  "text2395": "Anwendung",
  "text2396": "Nützliche Links",
  "text2397": "Mitglied werden",
  "text2398": "Mitgliederzone",
  "text2399": "Name Nachname / Firmenname",
  "text2400": "Arbeitsplatz (z. B. biochemisches Labor)",
  "text2401": "Institution (z. B. NsP Bratislava)",
  "text2402": "zu Marketing- und Kontaktzwecken",
  "text2403": "Verarbeitung personenbezogener Daten",
  "text2404": "Mehr erfahren",
  "text2405": "Willkommen im Mitgliederbereich",
  "text2406": "Dokumente",
  "text2407": "Statuten",
  "text2408": "Ethischer Kodex",
  "text2409": "Präsidium",
  "text2410": "Protokolle und Dokumente",
  "text2411": "Liste der Vertreter der Vereinsmitglieder",
  "text2412": "IVD-Marktstatistik",
  "text2413": "Forderungen",
  "text2414": "Ich bin damit einverstanden, im Rahmen des Heureka Verified by Customers-Programms einen Zufriedenheitsfragebogen zu versenden, der zur Verbesserung unserer Dienstleistungen beiträgt.",
  "text2415": "Treffen Sie Ihren Tutor",
  "text2416": "Suche nach Firmennamen oder ID-Nummer",
  "text2417": "Es wurden keine Unternehmen gefunden",
  "text2418": "Unbekanntes Zahlungsgateway",
  "text2419": "Sie haben keine aktiven Abonnements.",
  "text2420": "Hier kaufen.",
  "text2421": "Zahlertyp",
  "text2422": "Gl. Preis",
  "text2423": "Messwert",
  "text2424": "Kurse gekauft",
  "text2425": "Sie haben keine Kurse gekauft.",
  "text2426": "Übersicht der Kurse.",
  "text2427": "Treten Sie zurück",
  "text2428": "Sie können den Status Ihrer Bestellung jederzeit überprüfen, indem Sie auf die Schaltfläche unten klicken",
  "text2429": "Wir haben Ihre E-Rezept-Reservierung erhalten. Überprüfen Sie Ihren E-Mail-Posteingang.",
  "text2430": "Ungefüllt",
  "text2431": "Vielen Dank für die Zusendung der Reservierung!",
  "text2432": "Ihre Reservierung wurde erfolgreich gesendet.",
  "text2433": "Daten gesendet",
  "text2434": "Laden Sie ein Foto des Rezepts hoch",
  "text2435": "Ausgewählte Fotos",
  "text2436": "Machen Sie ein Foto",
  "text2437": "Bild des E-Rezepts",
  "text2438": "Als Bieter",
  "text2439": "Ich habe bereits ein Konto, ich möchte eines",
  "text2440": "Als Arbeitgeber",
  "text2441": "Identifikationsnummer (IČO)",
  "text2442": "Adresse und Sitz des Unternehmens",
  "text2443": "Lebenslauf bearbeiten",
  "text2444": "Profiländerungen wurden erfolgreich gespeichert",
  "text2445": "Fragen Sie unseren Experten",
  "text2446": "Bevorzugter Standort",
  "text2447": "Am Wochenende arbeiten",
  "text2448": "Arbeiten Sie nachts",
  "text2449": "Zusätzliche Informationen",
  "text2450": "Arbeitspräferenzen",
  "text2451": "Keine Lebensläufe entsprechen den ausgewählten Filtern",
  "text2452": "Um ein neues Stellenangebot hinzuzufügen, müssen alle Pflichtfelder ausgefüllt werden.",
  "text2453": "Grundlegende Informationen zur Stelle",
  "text2454": "Anforderungen an den Antragsteller",
  "text2455": "Timing-Typ",
  "text2456": "Wählen Sie den erforderlichen Führerscheintyp aus",
  "text2457": "Fügen Sie eine weitere Sprache hinzu",
  "text2458": "Geschätztes Startdatum",
  "text2459": "Geben Sie Informationen zum Arbeitsplatz ein.",
  "text2460": "Lohnbedingungen",
  "text2461": "Geben Sie die Zahlungsbedingungen für den Bieter an",
  "text2462": "Menü entfernen",
  "text2463": "Aktuelle Angebote",
  "text2464": "Dieses Unternehmen hat keine aktiven Angebote",
  "text2465": "Beschreiben Sie Ihr Unternehmen",
  "text2466": "Wir bieten Praktika für Studierende an",
  "text2467": "Wir kooperieren mit Schulen",
  "text2468": "Blog-Inhalte",
  "text2469": "Ähnliche Artikel",
  "text2470": "Lesen Sie nützliche Artikel.",
  "text2471": "Registrieren",
  "text2472": "In den Warenkorb legen",
  "text2473": "Erweiterte Suche",
  "text2474": "Suchen in",
  "text2475": "Bitte warten Sie auf E-Mail und SMS",
  "text2476": "Filter löschen",
  "text2477": "Teilweise Übereinstimmung mit dem Produktnamen",
  "text2478": "Kurze Produktbeschreibung",
  "text2479": "EAN-Produktcode",
  "text2480": "Externer Produktcode",
  "text2481": "Produktcode",
  "text2482": "Beginnen Sie mit dem Schreiben einer Adresse",
  "text2483": "Kandidaten",
  "text2484": "Die ältesten Kandidaten",
  "text2485": "Die jüngsten Kandidaten",
  "text2486": "Neueste Reaktionen",
  "text2487": "Älteste Reaktionen",
  "text2488": "Akzeptiert",
  "text2489": "Nicht akzeptiert",
  "text2490": "Datum folgt bald",
  "text2491": "Es wurden keine Kurse gefunden",
  "text2492": "Geschäft",
  "text2493": "Trainingsprozess",
  "text2494": "Fehlende E-Mail-Vorlageneinstellung im Bestellstatus",
  "text2495": "Balíkovo Selbstbedienungsboxen",
  "text2496": "Balíkovo Geschäftsbetrieb",
  "text2497": "Abgeben",
  "text2498": "Auswählen",
  "text2499": "Ausgewählter Ort",
  "text2500": "Nachnahme",
  "text2501": "Gesamtbestellwert",
  "text2502": "Kaufen",
  "text2503": "Verwenden Sie kostenlosen Belag",
  "text2504": "Kredit",
  "text2505": "Credits",
  "text2506": "Credits",
  "text2507": "Zahlung mit Credits",
  "text2508": "Die Lieferung für die Bestellung ist nicht bereit",
  "text2509": "Die Bestellung wurde bereits versendet",
  "text2510": "Der Spediteur bietet keinen automatisierten Versand an",
  "text2511": "Nächstes Mal nicht anzeigen",
  "text2512": "Anzahl der Personen",
  "text2513": "Ein erneuter Zahlungsversuch ist für die Zahlungsmethode nicht zulässig",
  "text2514": "Das Zahlungsgateway unterstützt derzeit keine API-Rückerstattungen",
  "text2515": "Erinnerung wird erstellt",
  "text2516": "Eine Erinnerung bearbeiten",
  "text2517": "Erinnerung wird gelöscht",
  "text2518": "Produkterstellung",
  "text2519": "Produktänderung",
  "text2520": "Das Produkt wird gelöscht",
  "text2521": "Preiserstellung",
  "text2522": "Preisanpassung",
  "text2523": "Löschen des Preises",
  "text2524": "Erstellen eines Eigenschaftstyps",
  "text2525": "Eigenschaftstyp bearbeiten",
  "text2526": "Löschen eines Eigenschaftstyps",
  "text2527": "Erstellen eines Immobilieneintragstyps",
  "text2528": "Bearbeiten des Immobilieneintragstyps",
  "text2529": "Typ der Immobilienauflistung wird gelöscht",
  "text2530": "Einen Raum erstellen",
  "text2531": "Raummodifikation",
  "text2532": "Der Raum wird gelöscht",
  "text2533": "Erstellen einer Eigenschaftsbezeichnung",
  "text2534": "Änderung der Eigenschaftsbezeichnung",
  "text2535": "Eigenschafts-Tag löschen",
  "text2536": "Erstellung zusätzlicher Eigenschaftsinformationen",
  "text2537": "Änderung zusätzlicher Eigenschaftsinformationen",
  "text2538": "Löschen zusätzlicher Eigenschaftsinformationen",
  "text2539": "Den Wert zusätzlicher Eigenschaftsinformationen schaffen",
  "text2540": "Bearbeiten des Werts zusätzlicher Eigenschaftsinformationen",
  "text2541": "Löschen des Werts zusätzlicher Eigenschaftsinformationen",
  "text2542": "Eine Stadt gründen",
  "text2543": "Stadtanpassung",
  "text2544": "Löschen Sie die Stadt",
  "text2545": "Gründung einer Gemeinde",
  "text2546": "Verordnung der Gemeinde",
  "text2547": "Das Dorf wird gelöscht",
  "text2548": "Erstellen eines Eigenschaftstextfelds",
  "text2549": "Änderung des Eigenschaftstextfelds",
  "text2550": "Das Eigenschaftstextfeld wird gelöscht",
  "text2551": "Eine Eigenschaftskategorie erstellen",
  "text2552": "Änderung der Eigenschaftskategorie",
  "text2553": "Eigenschaftskategorie wird gelöscht",
  "text2554": "Eine Eigenschaftsregel erstellen",
  "text2555": "Änderung der Immobilienregel",
  "text2556": "Löschen der Eigenschaftsregel",
  "text2557": "Erstellen einer Eigenschaftsregelantwort",
  "text2558": "Änderung der Eigenschaftsregelantwort",
  "text2559": "Eigenschaftsregelantwort wird gelöscht",
  "text2560": "Erstellen einer Immobilienreservierung",
  "text2561": "Änderung der Eigentumsreservierung",
  "text2562": "Löschen einer Immobilienreservierung",
  "text2563": "Erstellen eines Eigenschaftsziels",
  "text2564": "Änderung des Eigenschaftsziels",
  "text2565": "Löschen eines Eigenschaftsziels",
  "text2566": "Eine Eigenschaftsposition erstellen",
  "text2567": "Änderung der Immobilienposition",
  "text2568": "Eine Eigenschaftsposition löschen",
  "text2569": "Gründung einer Immobilienagentur",
  "text2570": "Änderung der Immobilienagentur",
  "text2571": "Löschung der Immobilienagentur",
  "text2572": "Erstellen eines Immobilienmaklers",
  "text2573": "Änderung des Immobilienmaklers",
  "text2574": "Löschen eines Immobilienmaklers",
  "text2575": "Gründung eines Immobilienentwicklers",
  "text2576": "Änderung des Immobilienentwicklers",
  "text2577": "Löschen des Immobilienentwicklers",
  "text2578": "Erstellung von Immobilien",
  "text2579": "Änderung von Immobilien",
  "text2580": "Immobilien löschen",
  "text2581": "Erstellung des Immobilienpreises",
  "text2582": "Anpassung des Immobilienpreises",
  "text2583": "Löschen des Immobilienpreises",
  "text2584": "Erstellen einer benutzerdefinierten Eigenschaftsregel",
  "text2585": "Änderung der eigenen Regel der Eigenschaft",
  "text2586": "Löschen einer benutzerdefinierten Eigenschaftsregel",
  "text2587": "Erstellen eines buchbaren Unterkunftstages",
  "text2588": "Änderung des buchbaren Tages der Immobilie",
  "text2589": "Löschen des buchbaren Tages der Unterkunft",
  "text2590": "Kurstyp wird erstellt",
  "text2591": "Änderung des Kurstyps",
  "text2592": "Kurstyp wird gelöscht",
  "text2593": "Kurskategorie erstellen",
  "text2594": "Kurskategorie ändern",
  "text2595": "Kurskategorie wird gelöscht",
  "text2596": "Kurstextfeld erstellen",
  "text2597": "Kurstextfeld bearbeiten",
  "text2598": "Kurstextfeld löschen",
  "text2599": "Einen Kurs erstellen",
  "text2600": "Kursanpassung",
  "text2601": "Kurslöschung",
  "text2602": "Erstellung der Kategorie Sprechzimmer",
  "text2603": "Anpassung der Sprechzimmerkategorie",
  "text2604": "Kategorie Beratungsbüro löschen",
  "text2605": "Kurspreis erstellen",
  "text2606": "Kurspreisanpassung",
  "text2607": "Kurspreis wird gelöscht",
  "text2608": "Erstellen eines Kurskapitels",
  "text2609": "Bearbeiten eines Kurskapitels",
  "text2610": "Löschen eines Kurskapitels",
  "text2611": "Kursleiter anlegen",
  "text2612": "Bearbeiten des Kursleiters",
  "text2613": "Kursleiter wird gelöscht",
  "text2614": "Erstellen einer Kursstufe",
  "text2615": "Anpassung des Kursniveaus",
  "text2616": "Kursniveau löschen",
  "text2617": "Lernraum erstellen",
  "text2618": "Kursraumänderung",
  "text2619": "Lernen eines Lernraums",
  "text2620": "Kursveranstaltung wird erstellt",
  "text2621": "Kursveranstaltung bearbeiten",
  "text2622": "Abschluss von Kursereignissen",
  "text2623": "Erstellen eines Kursplans",
  "text2624": "Änderung des Kursplans",
  "text2625": "Kursplan löschen",
  "text2626": "Anstellungsart erstellen",
  "text2627": "Änderung der Arbeitszeitart",
  "text2628": "Löschen des Arbeitszeittyps",
  "text2629": "Erstellen eines Jobportal-Labels",
  "text2630": "Jobportal-Label bearbeiten",
  "text2631": "Jobportal-Label wird gelöscht",
  "text2632": "Textfeld für Jobportal wird erstellt",
  "text2633": "Bearbeiten des Jobportal-Textfelds",
  "text2634": "Jobportal-Textfeld wird gelöscht",
  "text2635": "Jobportal-Kategorie wird erstellt",
  "text2636": "Kategorie des Jobportals bearbeiten",
  "text2637": "Kategorie des Jobportals wird gelöscht",
  "text2638": "Zahlungsart für das Jobportal wird erstellt",
  "text2639": "Änderung der Zahlungsart des Jobportals",
  "text2640": "Zahlungsart des Jobportals wird gelöscht",
  "text2641": "Unternehmensgröße für Jobportale erstellen",
  "text2642": "Jobportal-Unternehmensgrößenanpassung",
  "text2643": "Unternehmensgröße des Jobportals wird gelöscht",
  "text2644": "Gründung eines Jobportal-Unternehmens",
  "text2645": "Bearbeiten des Jobportals Unternehmen",
  "text2646": "Das Jobportal-Unternehmen wird gelöscht",
  "text2647": "Stellenportalstatus wird erstellt",
  "text2648": "Status des Jobportals ändern",
  "text2649": "Jobportal-Status löschen",
  "text2650": "Der Attributwert für das Jobportal wird erstellt",
  "text2651": "Änderung des Jobportal-Attributwerts",
  "text2652": "Der Attributwert des Jobportals wird gelöscht",
  "text2653": "Stellenportalattribut wird erstellt",
  "text2654": "Änderung des Jobportal-Attributs",
  "text2655": "Jobportal-Attribut wird gelöscht",
  "text2656": "Arbeitszeit im Arbeitsportal erstellen",
  "text2657": "Anpassung der Arbeitszeit des Jobportals",
  "text2658": "Arbeitszeit des Jobportals löschen",
  "text2659": "Erstellung eines Arbeitsportal-Arbeitsplatzes",
  "text2660": "Änderung des Erfüllungsortes des Jobportals",
  "text2661": "Löschung des Erfüllungsortes des Jobportals",
  "text2662": "Erstellen eines Jobportals für Altersgruppen",
  "text2663": "Anpassung der Altersspanne des Jobportals",
  "text2664": "Löschen der Altersgruppe des Jobportals",
  "text2665": "Ermittlung der erforderlichen Vorkenntnisse im Arbeitsportal",
  "text2666": "Anpassung der erforderlichen Vorkenntnisse im Arbeitsportal",
  "text2667": "Entfernung der erforderlichen Vorkenntnisse im Jobportal",
  "text2668": "Berechtigung für eine Stelle im Jobportal erstellen",
  "text2669": "Berechtigungsanpassung für die Stelle im Jobportal",
  "text2670": "Berechtigung für eine Stelle im Jobportal wird gelöscht",
  "text2671": "Erstellung eines Jobportals mit abgeschlossener Ausbildung",
  "text2672": "Bearbeiten des Jobportals für abgeschlossene Ausbildungen",
  "text2673": "Jobportal für abgeschlossene Ausbildung wird gelöscht",
  "text2674": "Erstellen eines Führerschein-Jobportals",
  "text2675": "Änderung des Führerscheins des Jobportals",
  "text2676": "Führerschein aus dem Jobportal löschen",
  "text2677": "Jobportal-Schultyp erstellen",
  "text2678": "Änderung der Schulart des Jobportals",
  "text2679": "Jobportal-Schultyp wird gelöscht",
  "text2680": "Aufbau der Schulabteilung des Jobportals",
  "text2681": "Änderung des Schulbereichs des Jobportals",
  "text2682": "Löschung der Schulabteilung des Jobportals",
  "text2683": "Erstellung eines Schuljobportals",
  "text2684": "Änderung des Schuljobportals",
  "text2685": "Löschung des Jobportals Schule",
  "text2686": "Erstellung des Schulprojekts des Jobportals",
  "text2687": "Änderung des Projekts Jobportal Schule",
  "text2688": "Das Jobportal-Schulprojekt wird gelöscht",
  "text2689": "Einrichtung eines Jobportals für Schulkooperationen",
  "text2690": "Anpassung der Schulkooperation des Jobportals",
  "text2691": "Löschung des Arbeitsportals Schulkooperation",
  "text2692": "Erstellen eines Stellenangebots auf dem Jobportal",
  "text2693": "Änderung des Stellenangebots des Jobportals",
  "text2694": "Löschen des Stellenangebots des Jobportals",
  "text2695": "Fähigkeit zur Erstellung von Stellenangeboten für ein Jobportal",
  "text2696": "Änderung der Fähigkeit zur Stellenanzeige im Jobportal",
  "text2697": "Der Jobportal-Skill „Stellenanzeige“ wird gelöscht",
  "text2698": "Erstellen eines Jobportals mit Gehaltsangeboten",
  "text2699": "Gehaltsanpassung des Jobportal-Stellenangebots",
  "text2700": "Löschen des Gehalts aus dem Stellenangebot des Jobportals",
  "text2701": "Erstellen Sie einen Lebenslauf für ein Jobportal",
  "text2702": "Bearbeitung des Lebenslaufs im Jobportal",
  "text2703": "Der Lebenslauf des Jobportals wird gelöscht",
  "text2704": "Erstellen einer Jobportal-Lebenslauffähigkeit",
  "text2705": "Änderung der Lebenslauffähigkeiten des Jobportals",
  "text2706": "Der Lebenslauf-Skill für das Jobportal wird gelöscht",
  "text2707": "Erstellung eines Jobportals für Lebensläufe mit Berufserfahrung",
  "text2708": "Arbeitserfahrung im Lebenslauf des Jobportals bearbeiten",
  "text2709": "Berufserfahrung aus dem Lebenslauf des Jobportals löschen",
  "text2710": "Erstellen eines Jobportals für die Lebenslaufausbildung",
  "text2711": "Änderung des Jobportals Lebenslaufausbildung",
  "text2712": "Der Lebenslauf des Jobportals wird gelöscht",
  "text2713": "Lebenslauf-Gehalt für ein Jobportal erstellen",
  "text2714": "Jobportal Lebenslauf Gehaltsanpassung",
  "text2715": "Löschen des Gehalts im Lebenslauf des Jobportals",
  "text2716": "Reisebürostatus wird erstellt",
  "text2717": "Anpassung des Reisebürostatus",
  "text2718": "Löschen des Status des Reisebüros",
  "text2719": "Erstellen eines Reisebüro-Labels",
  "text2720": "Änderung des Reisebüro-Labels",
  "text2721": "Das Reisebüro-Label wird gelöscht",
  "text2722": "Erstellen eines Reisebüro-Textfelds",
  "text2723": "Bearbeiten des Reisebüro-Textfelds",
  "text2724": "Löschen des Reisebüro-Textfelds",
  "text2725": "Es wird ein Attributwert für ein Reisebüro erstellt",
  "text2726": "Bearbeiten des Werts des Reisebüroattributs",
  "text2727": "Der Attributwert des Reisebüros wird gelöscht",
  "text2728": "Erstellung eines Reisebüroattributs",
  "text2729": "Bearbeiten des Reisebüroattributs",
  "text2730": "Das Reisebüroattribut wird gelöscht",
  "text2731": "Erstellung der Kategorie Reisebüro",
  "text2732": "Änderung der Reisebürokategorie",
  "text2733": "Löschen der Reisebürokategorie",
  "text2734": "Eine Reisebürotour erstellen",
  "text2735": "Änderung der Reisebürotour",
  "text2736": "Eine Reisebürotour löschen",
  "text2737": "Erstellung Reisebüro-Tourdatum",
  "text2738": "Änderung des Reisebüro-Tourdatums",
  "text2739": "Löschung des Reisebüro-Tourdatums",
  "text2740": "Erstellen einer Reisebüro-Tourreservierung",
  "text2741": "Anpassung der Reisebüro-Tourreservierung",
  "text2742": "Löschen einer Reisebüro-Tourreservierung",
  "text2743": "Erstellung eines Reisebüro-Reiseteilnehmers",
  "text2744": "Änderung des Reisebüro-Reiseteilnehmers",
  "text2745": "Löschen eines Reisebüro-Reiseteilnehmers",
  "text2746": "Kundentyp wird erstellt",
  "text2747": "Kundentyp ändern",
  "text2748": "Kundentyp wird gelöscht",
  "text2749": "Einen Kunden erstellen",
  "text2750": "Kundenmodifikation",
  "text2751": "Einen Kunden löschen",
  "text2752": "Anlegen eines Kunden in einer Kundengruppe",
  "text2753": "Bearbeiten eines Kunden in einer Kundengruppe",
  "text2754": "Einen Kunden aus einer Kundengruppe löschen",
  "text2755": "Anlegen einer Kundengruppe",
  "text2756": "Kundengruppe bearbeiten",
  "text2757": "Kundengruppe wird gelöscht",
  "text2758": "Benutzerrolle wird erstellt",
  "text2759": "Benutzerrolle bearbeiten",
  "text2760": "Benutzerrolle wird gelöscht",
  "text2761": "Benutzer wird erstellt",
  "text2762": "Bearbeitender Benutzer",
  "text2763": "Benutzer wird gelöscht",
  "text2764": "Erstellen eines Produktgutscheins",
  "text2765": "Änderung des Produktcoupons",
  "text2766": "Löschen des Produktgutscheins",
  "text2767": "Gutschein wird erstellt",
  "text2768": "Gutschein bearbeiten",
  "text2769": "Gutschein löschen",
  "text2770": "Rabattgutschein erstellen",
  "text2771": "Coupon-Rabattanpassung",
  "text2772": "Coupon-Rabatt wird gelöscht",
  "text2773": "Ein Produktgeschenk erstellen",
  "text2774": "Bearbeiten eines Produktgeschenks",
  "text2775": "Ein Produktgeschenk löschen",
  "text2776": "Produktzubehör erstellen",
  "text2777": "Änderung des Produktzubehörs",
  "text2778": "Produktzubehör wird gelöscht",
  "text2779": "Erstellen eines Produktpakets",
  "text2780": "Änderung des Produktpakets",
  "text2781": "Produktpaket wird gelöscht",
  "text2782": "Eine Produktfrage erstellen",
  "text2783": "Produktfrage wird bearbeitet",
  "text2784": "Produktfrage wird gelöscht",
  "text2785": "Erstellen eines virtuellen Produkts zu einem Produkt",
  "text2786": "Virtuelles Produkt in Produkt ändern",
  "text2787": "Virtuelles Produkt zu Produkt löschen",
  "text2788": "Dienstleistung für Produkt erstellen",
  "text2789": "Änderung der Dienstleistung am Produkt",
  "text2790": "Produktservice wird gelöscht",
  "text2791": "Erstellen einer Produktbewertung",
  "text2792": "Bearbeiten einer Produktbewertung",
  "text2793": "Produktbewertung wird gelöscht",
  "text2794": "Erstellen einer Produktvariante",
  "text2795": "Produktvariante bearbeiten",
  "text2796": "Produktvariante wird gelöscht",
  "text2797": "Produktvariantenpreis wird erstellt",
  "text2798": "Preisanpassung der Produktvariante",
  "text2799": "Löschen des Produktvariantenpreises",
  "text2800": "Kategorierand erstellen",
  "text2801": "Kategorie-Marge-Anpassung",
  "text2802": "Kategorierand löschen",
  "text2803": "Kategorierabatt erstellen",
  "text2804": "Änderung des Kategorierabatts",
  "text2805": "Kategorierabatt wird gelöscht",
  "text2806": "Kategorie erstellen",
  "text2807": "Kategorie bearbeiten",
  "text2808": "Löschung der Kategorie",
  "text2809": "Attributwert wird erstellt",
  "text2810": "Attributwert wird geändert",
  "text2811": "Attributwert wird gelöscht",
  "text2812": "Attribut wird erstellt",
  "text2813": "Bearbeiten eines Attributs",
  "text2814": "Attribut wird gelöscht",
  "text2815": "Lieferantenmarge erstellen",
  "text2816": "Anpassung der Lieferantenmarge",
  "text2817": "Lieferantenspanne wird gelöscht",
  "text2818": "Lieferantenrabatt erstellen",
  "text2819": "Lieferantenrabattanpassung",
  "text2820": "Lieferantenrabatt wird gelöscht",
  "text2821": "Lieferant wird erstellt",
  "text2822": "Anbieter ändern",
  "text2823": "Lieferant wird gelöscht",
  "text2824": "Hersteller wird erstellt",
  "text2825": "Herstelleränderung",
  "text2826": "Hersteller löschen",
  "text2827": "Erstellen eines Textfelds",
  "text2828": "Textfeldbearbeitung",
  "text2829": "Ein Textfeld löschen",
  "text2830": "Produktstatus wird erstellt",
  "text2831": "Produktstatus wird geändert",
  "text2832": "Produktstatus löschen",
  "text2833": "Produktetikett erstellen",
  "text2834": "Produktetikett bearbeiten",
  "text2835": "Produktetikett löschen",
  "text2836": "Ein Produktgeschenk erstellen",
  "text2837": "Bearbeiten eines Produktgeschenks",
  "text2838": "Löschen eines Produktgeschenks",
  "text2839": "Ein Geschenk erstellen",
  "text2840": "Ein Geschenk bearbeiten",
  "text2841": "Ein Geschenk löschen",
  "text2842": "Produkt für die Aktion erstellen",
  "text2843": "Produkt für die Aktion modifizieren",
  "text2844": "Das Produkt für die Aktion wird gelöscht",
  "text2845": "Aktion erstellen",
  "text2846": "Aktion bearbeiten",
  "text2847": "Aktion wird gelöscht",
  "text2848": "Erstellen eines Aktionspreises",
  "text2849": "Anpassung des Aktienkurses",
  "text2850": "Aktienkurs löschen",
  "text2851": "Erstellen einer Serviceoption",
  "text2852": "Dienstoption ändern",
  "text2853": "Dienstoption wird gelöscht",
  "text2854": "Serviceoptionspreis wird erstellt",
  "text2855": "Preisanpassung der Serviceoption",
  "text2856": "Serviceoptionspreis wird gelöscht",
  "text2857": "Zahlungsmethode wird erstellt",
  "text2858": "Änderung der Zahlungsmethode",
  "text2859": "Zahlungsmethode wird gelöscht",
  "text2860": "Preis für Zahlungsmethode wird erstellt",
  "text2861": "Änderung des Preises der Zahlungsmethode",
  "text2862": "Preis der Zahlungsmethode wird gelöscht",
  "text2863": "Zahlungsmethodenrabatt wird erstellt",
  "text2864": "Änderung des Rabatts für die Zahlungsmethode",
  "text2865": "Zahlungsmethodenrabatt wird gelöscht",
  "text2866": "Eine Transportmethode erstellen",
  "text2867": "Anpassung der Transportmethode",
  "text2868": "Löschen der Transportmethode",
  "text2869": "Versandartpreis wird erstellt",
  "text2870": "Änderung des Preises der Versandart",
  "text2871": "Löschen des Versandartpreises",
  "text2872": "Erstellen einer Abgabestelle",
  "text2873": "Änderung des Ausgabepunkts",
  "text2874": "Eine Abgabestelle löschen",
  "text2875": "Multiprojekt erstellen",
  "text2876": "Multiprojekt-Änderung",
  "text2877": "Multiprojekt löschen",
  "text2878": "Region wird erstellt",
  "text2879": "Region bearbeiten",
  "text2880": "Region löschen",
  "text2881": "Spracherstellung",
  "text2882": "Sprachänderung",
  "text2883": "Sprachlöschung",
  "text2884": "Schaffung einer Währung",
  "text2885": "Währungsanpassung",
  "text2886": "Währungslöschung",
  "text2887": "Landschaffung",
  "text2888": "Landschaftsänderung",
  "text2889": "Land löschen",
  "text2890": "Ein Menü erstellen",
  "text2891": "Menü „Bearbeiten“.",
  "text2892": "Menü löschen",
  "text2893": "Einen Menüpunkt erstellen",
  "text2894": "Menüpunkt bearbeiten",
  "text2895": "Menüpunkt löschen",
  "text2896": "Erstellen einer E-Mail-Vorlage",
  "text2897": "Änderung der E-Mail-Vorlage",
  "text2898": "E-Mail-Vorlage löschen",
  "text2899": "Erstellung der Mehrwertsteuer",
  "text2900": "Anpassung der Mehrwertsteuer",
  "text2901": "Löschung der Mehrwertsteuer",
  "text2902": "Erstellung eines Großhandelstyps",
  "text2903": "Änderung des Großhandelstyps",
  "text2904": "Großhandelstyp wird gelöscht",
  "text2905": "Großhandelskreation",
  "text2906": "Großhandelsanpassung",
  "text2907": "Großhandel wird gelöscht",
  "text2908": "Erstellung einer Großhandelsadresse",
  "text2909": "Großhandelsadresse bearbeiten",
  "text2910": "Großhandelsadresse wird gelöscht",
  "text2911": "Erstellen Sie eine Großhandelsdomäne",
  "text2912": "Bearbeiten der Großhandelsdomäne",
  "text2913": "Löschen der Großhandelsdomäne",
  "text2914": "Anspruch erstellen",
  "text2915": "Anpassung der Forderung",
  "text2916": "Der Anspruch wird gelöscht",
  "text2917": "Erstellung des Reklamationsgrundes",
  "text2918": "Änderung des Beschwerdegrundes",
  "text2919": "Löschen des Beschwerdegrundes",
  "text2920": "Anspruchsstatus wird erstellt",
  "text2921": "Anpassung des Anspruchsstatus",
  "text2922": "Anspruchsstatus wird gelöscht",
  "text2923": "Seite wird erstellt",
  "text2924": "Seite bearbeiten",
  "text2925": "Seite wird gelöscht",
  "text2926": "Bannererstellung",
  "text2927": "Banneränderung",
  "text2928": "Banner wird gelöscht",
  "text2929": "Geschlechtsschaffung",
  "text2930": "Geschlechtsmodifikation",
  "text2931": "Geschlechtslöschung",
  "text2932": "Erstellen eines Blogprodukts",
  "text2933": "Änderung des Produkts zum Blog",
  "text2934": "Produkt für Blog löschen",
  "text2935": "Erstellen Sie einen Blog",
  "text2936": "Blogbearbeitung",
  "text2937": "Blog-Löschung",
  "text2938": "Blog-Kategorie erstellen",
  "text2939": "Blog-Kategorie bearbeiten",
  "text2940": "Blogkategorie wird gelöscht",
  "text2941": "Erstellen eines Beitrags in einem sozialen Netzwerk",
  "text2942": "Bearbeiten eines Beitrags in einem sozialen Netzwerk",
  "text2943": "Löschen eines Beitrags in einem sozialen Netzwerk",
  "text2944": "Ein soziales Netzwerk erstellen",
  "text2945": "Bearbeiten eines sozialen Netzwerks",
  "text2946": "Löschen des sozialen Netzwerks",
  "text2947": "Newsletter-Erstellung",
  "text2948": "Änderung des Newsletters",
  "text2949": "Löschen des Newsletters",
  "text2950": "Massenmail erstellen",
  "text2951": "Änderung der Massenmail",
  "text2952": "Massenmail wird gelöscht",
  "text2953": "Erstellung eines Newsletter-Etiketts",
  "text2954": "Änderung des Newsletter-Labels",
  "text2955": "Newsletter-Label löschen",
  "text2956": "Erstellen eines E-Mail-Newsletters",
  "text2957": "Änderung der Newsletter-E-Mail",
  "text2958": "Löschen der Newsletter-E-Mail",
  "text2959": "Treuepunkte generieren",
  "text2960": "Änderung der Treuepunkte",
  "text2961": "Treuepunkte werden gelöscht",
  "text2962": "Erstellen einer Rückfrageantwort",
  "text2963": "Anpassung der Antwort des Beirats",
  "text2964": "Löschen der Antwort der Beratungsstelle",
  "text2965": "Einrichtung eines Beratungsraumes",
  "text2966": "Umbau des Sprechzimmers",
  "text2967": "Das Sprechzimmer wird gelöscht",
  "text2968": "Referenzkategorie erstellen",
  "text2969": "Änderung der Referenzkategorie",
  "text2970": "Referenzkategorie wird gelöscht",
  "text2971": "Referenz erstellen",
  "text2972": "Bearbeitungsreferenz",
  "text2973": "Referenz wird gelöscht",
  "text2974": "Dienst wird erstellt",
  "text2975": "Dienständerung",
  "text2976": "Dienst wird gelöscht",
  "text2977": "Servicepreis wird erstellt",
  "text2978": "Servicepreisanpassung",
  "text2979": "Servicepreis wird gelöscht",
  "text2980": "Eine Karriere aufbauen",
  "text2981": "Karriereänderung",
  "text2982": "Löschung der Karriere",
  "text2983": "Einführung einer Offenlegungspflicht",
  "text2984": "Regulierung der Offenlegungspflicht",
  "text2985": "Löschung der verpflichtenden Offenlegung",
  "text2986": "Galerieerstellung",
  "text2987": "Galeriebearbeitung",
  "text2988": "Galerie wird gelöscht",
  "text2989": "Erstellen eines Teammitglieds",
  "text2990": "Ein Teammitglied bearbeiten",
  "text2991": "Ein Teammitglied löschen",
  "text2992": "Kunde für Abonnement erstellen",
  "text2993": "Kunde zum Abonnement bearbeiten",
  "text2994": "Einen Abonnementkunden löschen",
  "text2995": "Abonnementkategorie wird erstellt",
  "text2996": "Abonnementkategorie bearbeiten",
  "text2997": "Abonnementkategorie wird gelöscht",
  "text2998": "Abonnementtyp wird erstellt",
  "text2999": "Abonnementtyp bearbeiten",
  "text3000": "Abonnementtyp wird gelöscht",
  "text3001": "Preis für Abonnementtyp wird erstellt",
  "text3002": "Preisanpassung für den Abonnementtyp",
  "text3003": "Preis für Abonnementtyp wird gelöscht",
  "text3004": "Abonnement wird erstellt",
  "text3005": "Abonnement bearbeiten",
  "text3006": "Abonnement wird gelöscht",
  "text3007": "Änderung der Konfigurations-API",
  "text3008": "Bestellstatus wird erstellt",
  "text3009": "Bestellstatus ändern",
  "text3010": "Bestellstatus wird gelöscht",
  "text3011": "Bestellstatuseinstellung wird erstellt",
  "text3012": "Änderung der Bestellstatuseinstellung",
  "text3013": "Löschen der Bestellstatuseinstellung",
  "text3014": "Eine Bestellung erstellen",
  "text3015": "Bestellung bearbeiten",
  "text3016": "Bestellung wird gelöscht",
  "text3017": "Bestellversand wird erstellt",
  "text3018": "Versandanpassung bestellen",
  "text3019": "Bestellversand wird gelöscht",
  "text3020": "Symbol wird erstellt",
  "text3021": "Symboländerung",
  "text3022": "Symbol wird gelöscht",
  "text3023": "Schutz schaffen",
  "text3024": "Anpassung des Tierheims",
  "text3025": "Räumung des Tierheims",
  "text3026": "Bewertungstyp wird erstellt",
  "text3027": "Änderung des Bewertungstyps",
  "text3028": "Bewertungstyp wird entfernt",
  "text3029": "Bewertung wird erstellt",
  "text3030": "Bearbeiten einer Rezension",
  "text3031": "Bewertung wird entfernt",
  "text3032": "Konfigurationen erstellen",
  "text3033": "Konfigurationen ändern",
  "text3034": "Konfigurationen werden gelöscht",
  "text3035": "SEO erstellen",
  "text3036": "SEO bearbeiten",
  "text3037": "SEO wird gelöscht",
  "text3038": "Weiterleitung wird erstellt",
  "text3039": "Weiterleitung bearbeiten",
  "text3040": "Weiterleitung wird gelöscht",
  "text3041": "Erstellen eines Rechnerdienstes",
  "text3042": "Änderung des Rechnerdienstes",
  "text3043": "Löschen des Rechnerdienstes",
  "text3044": "Rechner-Servicepreis erstellen",
  "text3045": "Preisanpassung für den Rechnerservice",
  "text3046": "Löschen des Preises des Rechnerdienstes",
  "text3047": "Erstellen zusätzlicher Rechnerinformationen",
  "text3048": "Änderung zusätzlicher Rechnerinformationen",
  "text3049": "Löschen zusätzlicher Rechnerinformationen",
  "text3050": "Wertschöpfung durch zusätzliche Rechnerinformationen",
  "text3051": "Ändern des Wertes der Zusatzinformationen des Rechners",
  "text3052": "Löschen des Zusatzinformationswerts des Rechners",
  "text3053": "Erstellen des Preises für den zusätzlichen Informationswert des Rechners",
  "text3054": "Änderung des Preises des Wertes der Zusatzinformationen des Rechners",
  "text3055": "Löschen des Preiswerts der Zusatzinformationen des Rechners",
  "text3056": "Erstellen eines Taschenrechnerprodukts",
  "text3057": "Änderung des Rechnerprodukts",
  "text3058": "Das Rechnerprodukt wird gelöscht",
  "text3059": "Erstellen eines Produktpreisrechners",
  "text3060": "Rechner-Produktpreisanpassung",
  "text3061": "Clearing-Rechner-Produktpreis",
  "text3062": "Erstellen einer Rechnerbestellung",
  "text3063": "Änderung der Rechnerreihenfolge",
  "text3064": "Rechnerauftrag wird gelöscht",
  "text3065": "Erstellen eines Rechnerbestellwerts",
  "text3066": "Rechnerauftragswertanpassung",
  "text3067": "Bestellwert des Rechners löschen",
  "text3068": "Erstellen eines Rechnerbestellservices",
  "text3069": "Bearbeiten des Rechnerbestellservices",
  "text3070": "Löschen des Rechnerbestelldienstes",
  "text3071": "Änderung der Reisebürokonfiguration",
  "text3072": "Änderung der Newsletter-Konfiguration",
  "text3073": "Änderung der Massen-Mail-Konfiguration",
  "text3074": "Änderung der Konfiguration des Treueprogramms",
  "text3075": "Konfiguration abgebrochener Warenkörbe",
  "text3076": "SEO-Konfiguration bearbeiten",
  "text3077": "Erstellung E-Rezept-Status",
  "text3078": "Änderung des E-Rezept-Status",
  "text3079": "Löschen des Status des E-Rezepts",
  "text3080": "Erstellung des E-Rezepts",
  "text3081": "Änderung des E-Rezepts",
  "text3082": "E-Rezept löschen",
  "text3083": "Medikamentenreservierungsstatus wird erstellt",
  "text3084": "Änderung des Medikamentenreservierungsstatus",
  "text3085": "Medikamentenreservierungsstatus wird gelöscht",
  "text3086": "Erstellung eines Arzneimittelreservierungsprodukts",
  "text3087": "Änderung des Arzneimittelreservierungsprodukts",
  "text3088": "Löschung des Arzneimittelreservierungsprodukts",
  "text3089": "Erstellen einer Medikamentenreservierung",
  "text3090": "Änderung der Medikamentenreservierung",
  "text3091": "Medikamentenreservierung wird gelöscht",
  "text3092": "Reservierungsdienst erstellen",
  "text3093": "Änderung des Reservierungsdienstes",
  "text3094": "Reservierungsservice wird gelöscht",
  "text3095": "Erstellung des Reservierungsservicepreises",
  "text3096": "Preisanpassung für den Reservierungsservice",
  "text3097": "Löschen des Reservierungsservicepreises",
  "text3098": "Erstellen eines automatischen Reservierungsplans",
  "text3099": "Änderung des automatischen Buchungsplans",
  "text3100": "Automatischer Buchungsplan wird gelöscht",
  "text3101": "Buchungszeit erstellen",
  "text3102": "Anpassung der Reservierungszeit",
  "text3103": "Reservierungszeit wird gelöscht",
  "text3104": "Reservierungsperson wird erstellt",
  "text3105": "Änderung der Reservierungsperson",
  "text3106": "Eine Reservierungsperson löschen",
  "text3107": "Reservierung wird erstellt",
  "text3108": "Reservierung bearbeiten",
  "text3109": "Reservierung wird gelöscht",
  "text3110": "Änderung der Konfiguration der allgemeinen Einstellungen",
  "text3111": "Die Anmeldung war erfolgreich",
  "text3112": "Ihr Konto wurde erfolgreich verknüpft.",
  "text3113": "Sie können dieses Fenster jetzt sicher schließen – das Ergebnis wurde an die Anwendung gesendet.",
  "text3114": "Fenster schließen",
  "text3115": "Schließen Sie dieses Fenster manuell.",
  "text3116": "Folgen Sie uns auf Instagram",
  "text3117": "Der Link wurde erfolgreich in die Zwischenablage kopiert",
  "text3118": "Das Abonnement läuft bald ab",
  "text3119": "Profiländerungen wurden erfolgreich gespeichert",
  "text3120": "Profil wurde erfolgreich erstellt",
  "text3121": "Wir bereiten uns vor",
  "text3122": "Sie haben kein aktives Abonnement",
  "text3123": "Kaufen Sie ein 1-Jahres-Abonnement und erhalten Sie uneingeschränkten Zugang zu allen Online-Kursen und 10 % Rabatt auf Veranstaltungen!",
  "text3124": "Kaufen Sie ein Abonnement",
  "text3125": "Meine Produkte",
  "text3126": "Präsidentschaft des SEDMA-Verbandes",
  "text3127": "Sie haben bereits ein Abonnement erworben.",
  "text3128": "Zu den Kursen gehen",
  "text3129": "Die Bestellunterlagen finden Sie in Ihrem Profil",
  "text3130": "Dieses Produkt ist in unserem E-Shop nicht verfügbar",
  "text3131": "Suchen Sie nach Produktinformationen...",
  "text3132": "Dieses Produkt ist in unserem E-Shop nicht verfügbar",
  "text3133": "Kategoriegeschenk erstellen",
  "text3134": "Kategorie Geschenk bearbeiten",
  "text3135": "Kategorie „Geschenk“ wird gelöscht",
  "text3136": "Das Geschenk wurde bereits zugewiesen",
  "text3137": "Geschenke sind für dieses Produkt nicht gestattet",
  "text3138": "Kaufen Sie Kurse für unsere Veranstaltungen.",
  "text3139": "Die Bestätigungs-E-Mail wurde erfolgreich gesendet",
  "text3140": "Der Link zum Zurücksetzen des Passworts ist ungültig",
  "text3141": "In Feldern suchen",
  "text3142": "Genaue Suche",
  "text3143": "Die Bestellung wurde storniert",
  "text3144": "Der Zahlungsauftrag wurde storniert und nicht ausgeführt.",
  "text3145": "Sie wurden abgemeldet",
  "text3146": "Jemand hat sich von einem anderen Gerät aus bei Ihrem Konto angemeldet.",
  "text3147": "Anpassung der Beratungsraumkonfiguration",
  "text3148": "Inventar erstellen",
  "text3149": "Speicheränderung",
  "text3150": "Inventar wird gelöscht",
  "text3151": "Inventarartikel wird erstellt",
  "text3152": "Inventarartikel bearbeiten",
  "text3153": "Inventarartikel wird gelöscht",
  "text3154": "Die Datei wurde bereits in der Vergangenheit verarbeitet",
  "text3155": "Der Kauf des Tages wird erstellt",
  "text3156": "Kauf des Tages bearbeiten",
  "text3157": "Einkauf des Tages löschen",
  "text3158": "Der Einkaufsartikel des Tages wird erstellt",
  "text3159": "Änderung des Kaufartikels des Tages",
  "text3160": "Der Einkaufsartikel des Tages wird gelöscht",
  "text3161": "Alle anzeigen",
  "text3162": "Erstellen eines Rabatts auf den Kauf des Tagesartikels",
  "text3163": "Anpassung des Rabatts beim Kauf des Tagesartikels",
  "text3164": "Löschen des Rabatts des Tageskaufartikels",
  "text3165": "Erstellen einer Produktgruppe",
  "text3166": "Produktgruppe ändern",
  "text3167": "Löschen einer Produktgruppe",
  "text3168": "Erstellen eines Produktgruppenrabatts",
  "text3169": "Produktgruppenrabatt ändern",
  "text3170": "Löschen eines Produktgruppenrabatts",
  "text3171": "Das Geschenk wurde der Bestellung hinzugefügt",
  "text3172": "Das Geschenk wurde bereits zur Bestellung hinzugefügt",
  "text3173": "Transportkategorie erstellen",
  "text3174": "Änderung der Transportkategorie",
  "text3175": "Transportkategorie wird gelöscht",
  "text3176": "Versandpreiskategorie erstellen",
  "text3177": "Änderung des Kategorieversandpreises",
  "text3178": "Löschen der Versandpreiskategorie",
  "text3179": "Name / Name des Unternehmens",
  "text3180": "Produktparameter",
  "text3181": "Bitte geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen des Passworts.",
  "text3182": "Ein Konto erstellen",
  "text3183": "Nochmals Passwort",
  "text3184": "Referenznummer",
  "text3185": "Zurück zum Anmelden",
  "text3186": "Produkte im Angebot",
  "text3187": "Vollverkauf",
  "text3188": "Kauf des Tages",
  "text3189": "Minuten",
  "text3190": "Stunde",
  "text3191": "Stunden",
  "text3192": "Stunden",
  "text3193": "Sekunde",
  "text3194": "Sekunden",
  "text3195": "Sekunden",
  "text3196": "Die Aktion läuft am ab",
  "text3197": "Minuten",
  "text3198": "Kaufen Sie dieses Produkt",
  "text3199": "Abonnieren Sie Neuigkeiten und Rabatte.",
  "text3200": "Sie haben erfolgreich mit dem Abonnieren des Newsletters begonnen",
  "text3201": "Sie sind angemeldet. Alle Ihre Bestellungen finden Sie in Ihrem Profil.",
  "text3202": "Preisliste herunterladen",
  "text3203": "Senden Sie uns ein Fax",
  "text3204": "Korrektur",
  "text3205": "Bankverbindung (EUR)",
  "text3206": "Unsere Vertriebspartner",
  "text3207": "zufriedene Kunden",
  "text3208": "Ihr Konto wurde erfolgreich erstellt!",
  "text3209": "Weitere Artikel laden",
  "text3210": "Brauchen Sie Rat? Zögern Sie nicht, uns entweder über das Kontaktformular oder direkt per Telefon und E-Mail zu kontaktieren.",
  "text3211": "Kontaktieren Sie uns, wir beraten Sie gerne",
  "text3212": "Rechnungs- und Lieferdaten",
  "text3213": "Produktversandpreis wird erstellt",
  "text3214": "Anpassung des Produktversandpreises",
  "text3215": "Der Produktversandpreis wird gelöscht",
  "text3216": "Der angegebene Coupon existiert nicht",
  "text3217": "Ich habe einen Rabattcoupon.",
  "text3218": "Vielen Dank für Ihre Bestellnummer",
  "text3219": "Wir haben Ihnen die Bestellbestätigung an die von Ihnen eingegebene E-Mail-Adresse gesendet.",
  "text3220": "Es wurden keine Produkte gefunden",
  "text3221": "Interessante Artikel",
  "text3222": "Entfernt",
  "text3223": "Abmelden",
  "text3224": "Möchten Sie den Newsletter wirklich abbestellen?",
  "text3225": "Das Newsletter-Abonnement wurde gekündigt",
  "text3226": "Newsletter abbestellen",
  "text3227": "Mit jeder Bestellung",
  "text3228": "Enthalten",
  "text3229": "Bestellen bei",
  "text3230": "Mit jeder Bestellung",
  "text3231": "Was sagen unsere zufriedenen Kunden?",
  "text3232": "Abgelaufen",
  "text3233": "Um den Mitgliederbereich zu betreten, müssen Sie angemeldet sein",
  "text3234": "angemeldet",
  "text3235": "Wenn Sie nicht registriert sind, klicken Sie auf den Link",
  "text3236": "Registrierung.",
  "text3237": "Passwort vergessen?",
  "text3238": "Kategorie durchsuchen",
  "text3239": "Werbeprodukte",
  "text3240": "Aktuelles Tourenangebot",
  "text3241": "Menü",
  "text3242": "Das Produkt wurde dem Warenkorb hinzugefügt",
  "text3243": "Variantenlieferant erstellen",
  "text3244": "Änderung des Variantenanbieters",
  "text3245": "Variantenanbieter wird gelöscht",
  "text3246": "Erstellen eines abweichenden Lieferantenpreises",
  "text3247": "Preisanpassung des Variantenlieferanten",
  "text3248": "Variantenlieferantenpreis wird gelöscht",
  "text3249": "Der Coupon ist ungültig",
  "text3250": "Informationen zu Rückgabemöglichkeiten und Produktreklamationen finden Sie auf der Website",
  "text3251": "Rücksendungen und Reklamationen",
  "text3252": "Betriebszeit der Kundenleitung",
  "text3253": "Mo-Fr: 8:30 - 17:00 Uhr",
  "text3254": "Mehr als",
  "text3255": "Alle Dienste anzeigen",
  "text3256": "Ausblenden",
  "text3257": "Geschenke für das Produkt",
  "text3258": "Geschenk beim Kauf",
  "text3259": "Berechnen Sie die Rückzahlungen",
  "text3260": "verifizierte Bewertungen",
  "text3261": "Grund der Kontaktaufnahme",
  "text3262": "Ungültige Authentifizierung. Bitte versuchen Sie es erneut",
  "text3263": "Telefonnummer ist obligatorisch",
  "text3264": "Mit dem Abonnieren erklären Sie sich damit einverstanden",
  "text3265": "Aktion",
  "text3266": "Schnelle Lieferung",
  "text3267": "Schnelle und sichere kostenlose Lieferung für Bestellungen über 100 €.",
  "text3268": "Lieferoptionen",
  "text3269": "30 Tage Rückgaberecht",
  "text3270": "Nicht zufrieden mit dem Produkt? Sie haben 30 Tage Zeit, den Artikel zurückzugeben und eine Rückerstattung zu erhalten.",
  "text3271": "Zahlungsoptionen",
  "text3272": "Kunde",
  "text3273": "Kundentarif",
  "text3274": "Es sind noch Stunden übrig",
  "text3275": "Abonnementstatus",
  "text3276": "Das Abonnement ist aktiviert",
  "text3277": "Das Abonnement ist nicht aktiviert",
  "text3278": "Läuft ab",
  "text3279": "Rechnungs-E-Mail",
  "text3280": "Verantwortlicher Manager (Führungskraft)",
  "text3281": "Zur Adresse navigieren",
  "text3282": "Bankverbindung",
  "text3283": "Beschwerde-Nr.:",
  "text3284": "Datum des Anspruchs",
  "text3285": "Kaufdatum",
  "text3286": "Unterschrift des Kunden",
  "text3287": "Unterschrift des Verkäufers",
  "text3288": "Tag",
  "text3289": "Detaillierte Beschreibung des Mangels und des Zustands der Ware",
  "text3290": "Mitgeliefertes Zubehör",
  "text3291": "Gegenstand der Beschwerde",
  "text3292": "Kaufbeleg",
  "text3293": "Originalverpackung",
  "text3294": "Bearbeitung der Reklamation Nr.:",
  "text3295": "Enddatum",
  "text3296": "Detaillierte Beschreibung der durchgeführten Reparatur",
  "text3297": "Erstellen einer Unfallakte",
  "text3298": "Unfallprotokoll bearbeiten",
  "text3299": "Löschen des Unfallprotokolls",
  "text3300": "Betriebszeit der Kundenleitung",
  "text3301": "Google-Bewertungen",
  "text3302": "Melden Sie sich für Neuigkeiten an",
  "text3303": "Seien Sie rechtzeitig über unsere Rabatte und Aktionen informiert.",
  "text3304": "Nach einer Tour suchen",
  "text3305": "Nach einer Tour suchen",
  "text3306": "Alle Touren anzeigen",
  "text3307": "Ich interessiere mich für eine maßgeschneiderte Tour",
  "text3308": "Was wir für Sie bieten können",
  "text3309": "Ziel",
  "text3310": "Wie viele von Ihnen würden gerne reisen?",
  "text3311": "Welcher Begriff passt am besten zu Ihnen?",
  "text3312": "Bevorzugter Begriff",
  "text3313": "Ihre Anfrage für eine maßgeschneiderte Tour wurde erfolgreich gesendet",
  "text3314": "Wir unterstützen die Funktionalität derzeit nicht",
  "text3315": "Dateien nicht gefunden",
  "text3316": "Produktkatalog",
  "text3317": "Bewertet",
  "text3318": "mehr als 1000 Kunden",
  "text3319": "Gehen Sie zum E-Shop",
  "text3320": "Laden Sie das E-Book kostenlos herunter",
  "text3321": "Änderung der Geschenkkonfiguration",
  "text3322": "Schreiben Sie uns eine E-Mail",
  "text3323": "Unsere interessanten Artikel",
  "text3324": "Noch nicht registriert?",
  "text3325": "Das verpassen Sie:",
  "text3326": "Melden Sie sich an",
  "text3327": "Dokumente KOSTENLOS",
  "text3328": "Bezahlte Dokumente",
  "text3329": "Haben Sie die Antwort auf die Frage nicht gefunden? Kontaktieren Sie uns direkt über Kontakt.",
  "text3330": "Aufzeichnung von Berufskrankheiten, gefährlichen Ereignissen und Arbeitsunfällen",
  "text3331": "Gesetze und Vorschriften zu Gesundheit und Sicherheit",
  "text3332": "Erste Hilfe bei lebensbedrohlichen Zuständen",
  "text3333": "Traumatologischer Plan",
  "text3334": "Protokolle, Kontrollen und Berichte",
  "text3335": "Richtlinien und Gesetze",
  "text3336": "Bedingungen zur technischen Ausstattung",
  "text3337": "Protokoll zur Mitarbeiterschulung",
  "text3338": "Beispiele von Dokumenten",
  "text3339": "Inspektion und Verfahren",
  "text3340": "Zertifikat",
  "text3341": "Änderung der Marketingkonfiguration",
  "text3342": "Erstellung einer Reservierungskategorie",
  "text3343": "Änderung der Buchungskategorie",
  "text3344": "Reservierungskategorie wird gelöscht",
  "text3345": "Haben Sie ein Konto? Melden Sie sich an und wir füllen die Daten für Sie aus.",
  "text3346": "Sie sind erfolgreich angemeldet",
  "text3347": "Im Rahmen der Mitgliedschaft erhalten Sie folgende Vorteile",
  "text3348": "Gutschein verwenden",
  "text3349": "Vollständiger Schutz",
  "text3350": "Was Ihnen am wichtigsten ist",
  "text3351": "Füllen Sie das Formular aus und wir werden uns bei Ihnen melden.",
  "text3352": "Ihre Nachricht / Ihr Interesse",
  "text3353": "Mit dem Absenden einer Nachricht erklären Sie sich damit einverstanden",
  "text3354": "zur Kontaktaufnahme.",
  "text3355": "Lesen Sie weiter",
  "text3356": "Beschwerde",
  "text3357": "Rücktritt vom Vertrag",
  "text3358": "Rücktritt vom Vertrag und Reklamation der Ware",
  "text3359": "Alle anzeigen",
  "text3360": "min. Messwert",
  "text3361": "Haben Sie die Antwort auf Ihre Frage nicht gefunden? Kontaktieren Sie uns telefonisch oder per E-Mail und wir antworten Ihnen gerne.",
  "text3362": "Erfahren Sie mehr über Sonicube",
  "text3363": "Partner werden",
  "text3364": "Erinnerungskonfiguration bearbeiten",
  "text3365": "Bearbeiten Sie die Konfiguration der Erinnerungsplanung",
  "text3366": "Erinnerung wird erstellt",
  "text3367": "Erinnerung bearbeiten",
  "text3368": "Erinnerung wird gelöscht",
  "text3369": "Mit der Anmeldung zum Newsletter erklären Sie sich damit einverstanden",
  "text3370": "zu Marketingzwecken und zum Versand von Nachrichten.",
  "text3371": "Füllen Sie das Formular aus und wir werden uns bei Ihnen melden\ninnerhalb von 24 Stunden.",
  "text3372": "Anzahl der Tage überfällig",
  "text3373": "Datum für die Wiederherstellung zugewiesen",
  "text3374": "Geschenk für das Produkt",
  "text3375": "Benötigen Sie Informationen zu Produkten oder Ihrer Bestellung?",
  "text3376": "Die Notiz wurde bereits an den Kunden gesendet",
  "text3377": "Suchen",
  "text3378": "Weitere Fotos",
  "text3379": "Der Vorgang ist fehlgeschlagen",
  "text3380": "Versandart",
  "text3381": "Beschreibung des Defekts",
  "text3382": "Ihr Konto wurde erfolgreich erstellt!",
  "text3383": "Wir haben Sie an die von Ihnen eingegebene E-Mail-Adresse gesendet",
  "text3384": "Filter zurücksetzen",
  "text3385": "Die Bestellung wurde erfolgreich gesendet",
  "text3386": "Wir haben Ihre Bestellung erfolgreich registriert. Sie erhalten eine Bestätigung an Ihre bei der Bestellung angegebene E-Mail-Adresse.",
  "text3387": "Abonnieren Sie unseren Newsletter und erhalten Sie Tipps, wie Sie Regeneration und Gesundheit unterstützen können.",
  "text3388": "Beschwerden",
  "text3389": "für Marketingzwecke.",
  "text3390": "Firmenkunde",
  "text3391": "Lesen Sie den Artikel",
  "text3392": "Ich habe eine Frage",
  "text3393": "Produkt-EAN",
  "text3394": "Produktgruppentyp erstellen",
  "text3395": "Bearbeiten der Art der Produktgruppen",
  "text3396": "Produktgruppentyp wird gelöscht",
  "text3397": "Fügen Sie eine Bewertung hinzu",
  "text3398": "Steuerpflicht",
  "text3399": "Produktbewertung",
  "text3400": "Bewerten Sie dieses Produkt",
  "text3401": "Die Registrierung war erfolgreich",
  "text3402": "Wir haben eine Bestätigungs-E-Mail an die von Ihnen angegebene E-Mail-Adresse gesendet.",
  "text3403": "Textbeschreibung",
  "text3404": "zum Zweck der Produktbewertung.",
  "text3405": "Ihr Code",
  "text3406": "Gegen Bezahlung",
  "text3407": "Zurück zu Versand und Zahlung",
  "text3408": "Bestellung mit Zahlungsverpflichtung",
  "text3409": "Super! Ihre Bestellung ist unterwegs!",
  "text3410": "Vielen Dank, dass Sie sich für uns entschieden haben.",
  "text3411": "Sie finden die Bestellbestätigung in Ihrer E-Mail und wir halten Sie über den Status Ihrer Bestellung auf dem Laufenden.",
  "text3412": "Haben Sie ein Konto bei uns?",
  "text3413": "Melden Sie sich an, und wir füllen die Details für Sie aus.",
  "text3414": "Befehl",
  "text3415": "Aktuelles Passwort",
  "text3416": "Wir haben Ihnen eine Bestätigung Ihrer Passwortänderung an die von Ihnen angegebene E-Mail-Adresse gesendet.",
  "text3417": "Suchen Sie nach einem Produkt",
  "text3418": "Zertifikate",
  "text3419": "Meine Projekte",
  "text3420": "Es ist keine SMS-Integration aktiv",
  "text3421": "Fehler beim Überprüfen der SMS-Limits",
  "text3422": "SMS-Guthabenstatus konnte nicht überprüft werden. Überprüfen Sie die Konfiguration",
  "text3423": "Unzureichendes SMS-Guthaben",
  "text3424": "Zusammenfassung der gesendeten Erinnerungen",
  "text3425": "Die folgenden Erinnerungen wurden an Kunden gesendet",
  "text3426": "Dokumentextraktion gestartet. Sie werden benachrichtigt, wenn der Vorgang abgeschlossen ist",
  "text3427": "Vereinbaren Sie einen Beratungstermin",
  "text3428": "Auch dabei können wir Ihnen helfen",
  "text3429": "Für Studierende",
  "text3430": "Angebot",
  "text3431": "Sie werden uns finden",
  "text3432": "Das Angebot wurde zu den Favoriten hinzugefügt",
  "text3433": "Änderung der Dokumentkonfiguration",
  "text3434": "Anzahl der Gebote",
  "text3435": "Weitere Angebote",
  "text3436": "Das Angebot wurde geändert",
  "text3437": "Das Angebot wurde erstellt",
  "text3438": "Hilfe bei der Bestellung",
  "text3439": "Alle anzeigen",
  "text3440": "offene Positionen",
  "text3441": "Positionen",
  "text3442": "Die Bestellung wurde bereits bezahlt",
  "text3443": "Eine Rechnung ist auch ein Lieferschein.",
  "text3444": "Produkte",
  "text3445": "Von KI generiert",
  "text3446": "monatlich",
  "text3447": "Vollständige Biografie anzeigen",
  "text3448": "Warum ein KI-Bild markieren?",
  "text3449": "Mit dem Ankreuzen bestätigen Sie, dass das Bild durch künstliche Intelligenz erstellt wurde.\n        Damit helfen Sie uns bei der Einhaltung des KI-Gesetzes und erhöhen die Transparenz für Bewerber.",
  "text3450": "Die Verantwortung für die ordnungsgemäße Kennzeichnung von KI-generierten Inhalten liegt beim Werbetreibenden.",
  "text3451": "Nicht markierte KI-Inhalte können nachträglich von einem Moderator bearbeitet oder entfernt werden.",
  "text3452": "Haben Sie keine Antwort auf Ihre Frage gefunden?",
  "text3453": "Nehmen Sie Kontakt mit uns auf, wir werden Ihnen so schnell wie möglich antworten.",
  "text3454": "Geburtsjahr",
  "text3455": "Das Geburtsdatum dient ausschließlich der Überprüfung der Volljährigkeit des Nutzers und der Einhaltung gesetzlicher Vorgaben. Eine Verwendung dieser Daten für andere Zwecke erfolgt nicht",
  "text3456": "Dateien auswählen",
  "text3457": "Die maximale Anzahl von Dateien beträgt",
  "text3458": "Die maximale Dateigröße beträgt 2 MB",
  "text3459": "Fehler beim Hochladen der Datei",
  "text3460": "Zahlungsarten",
  "text3461": "Lieferformen",
  "text3462": "Verpassen Sie keine Neuigkeiten und aktuellen Angebote!",
  "text3463": "Erhalten Sie Neuigkeiten, indem Sie unseren Newsletter abonnieren.",
  "text3464": "Ihre E-Mail",
  "text3465": "Anzahl der Bewertungen",
  "text3466": "Für dieses Produkt gibt es noch keine Bewertungen.",
  "text3467": "Lieferinformationen",
  "text3468": "Geben Sie Ihre E-Mail-Adresse ein, um einen Link zum Zurücksetzen Ihres Passworts zu erhalten.",
  "text3469": "Unsere Artikel",
  "text3470": "Verkauf",
  "text3471": "Sie haben keinen Zugriff auf Lebensläufe",
  "text3472": "Dieser Abschnitt ist für Geschäftskonten mit Prepaid-CV-Zugang verfügbar.",
  "text3473": "Preisliste anzeigen",
  "text3474": "Der Zugriff auf Lebensläufe ist nur für Geschäftskonten verfügbar.",
  "text3475": "Die ganze Kategorie",
  "text3476": "Telefon ausblenden",
  "text3477": "Liste der Positionen",
  "text3478": "Die ausgewählte Reihenfolge ist für den Dokumenttyp nicht anwendbar",
  "text3479": "Warenkorb öffnen",
  "text3480": "Mengenrabatte",
  "text3481": "Zugriff auf Lebensläufe erwerben",
  "text3482": "Zugriff auf Lebensläufe",
  "text3483": "Für Unternehmen",
  "text3484": "Veröffentlichung eines Stellenangebots",
  "text3485": "Die Krönung des Angebots",
  "text3486": "Zeitlich begrenztes Angebot",
  "text3487": "Gutschein läuft ab am",
  "text3488": "Abonnieren Sie den Newsletter und sichern Sie sich einen Rabatt!",
  "text3489": "Neuigkeiten, aktuelle Trends und Events direkt in Ihre E-Mail. Das Abonnement beinhaltet einen Rabattgutschein. Melden Sie sich jederzeit kostenlos ab.",
  "text3490": "Nein danke, ich möchte keinen Rabatt",
  "text3491": "Gutschein erhalten",
  "text3492": "Bei Bestellung oben",
  "text3493": "Für alle Bestellungen",
  "text3494": "Der Gutschein wurde an Ihre E-Mail-Adresse gesendet",
  "text3495": "Gutschein erhalten",
  "text3496": "Informieren Sie sich als Erster über neue Produkte und Rabatte.",
  "text3497": "Lieferung",
  "text3498": "Entdecken Sie das Konzept",
  "text3499": "Werden Sie Partner",
  "text3500": "Informieren Sie sich über Kooperationsmöglichkeiten.",
  "text3501": "Punkte",
  "text3502": "Anzahl der Punkte, die für einen Einkauf im Wert von 1 € gesammelt wurden",
  "text3503": "Ein Punktwert",
  "text3504": "Maximaler Rabatt in Prozent pro Bestellung",
  "text3505": "Wenn Sie das Treueprogramm nutzen möchten, melden Sie sich an",
  "text3506": "Alle Punkte einlösen",
  "text3507": "Treuepunkte wurden angewendet",
  "text3508": "Anwenden",
  "text3509": "Login-E-Mail",
  "text3510": "Keine Anhänge",
  "text3511": "Bewertung",
  "text3512": "Bewertungen",
  "text3513": "Bewertungen",
  "text3514": "Bewertung auswählen",
  "text3515": "Erfahren Sie hier mehr",
  "text3516": "Alle Parameter anzeigen",
  "text3517": "Verbleibende Freischaltungen",
  "text3518": "Alle Daten stehen nach der Freischaltung des Lebenslaufs zur Verfügung.",
  "text3519": "Gesperrtes Profil",
  "text3520": "Kandidatenprofil",
  "text3521": "Wählen Sie 1 bis 3 Kategorien/Positionen aus",
  "text3522": "Alle Blogs anzeigen",
  "text3523": "Unverbindliches Preisangebot ",
  "text3524": "Hauptbanner",
  "text3525": "Vorheriger Frame",
  "text3526": "Noch eine Folie",
  "text3527": "Popup öffnen",
  "text3528": "Referenz auf der Karte anzeigen",
  "text3529": "Vorherige Seite",
  "text3530": "Nächste Seite",
  "text3531": "Zur Seite gehen",
  "text3532": "Gehe zur Folie",
  "text3533": "Vorherige Vorschauen",
  "text3534": "Weitere Bilder anzeigen",
  "text3535": "Weitere Vorschauen",
  "text3536": "Fordern Sie eine Partnerberatung an",
  "text3537": "Unsere Partner können dieses Label verwenden.",
  "text3538": "FAQ-Erstellung",
  "text3539": "FAQ bearbeiten",
  "text3540": "FAQ-Löschung",
  "text3541": "Schema.org erstellen",
  "text3542": "Schema.org bearbeiten",
  "text3543": "Schema.org wird gelöscht",
  "text3544": "Füllen Sie das Formular aus und vereinbaren Sie ein erstes Beratungsgespräch zur Partnerschaft.",
  "text3545": "Erstellen eines Watchdogs",
  "text3546": "Modifikation des Wachhundes",
  "text3547": "Löschen des Watchdogs",
  "text3548": "HASQO-Paket",
  "text3549": "Weitere Informationen",
  "text3550": "Ein Paket",
  "text3551": "Das Paket enthält",
  "text3552": "Geeignet für",
  "text3553": "Beratung",
  "text3554": "Name der Einrichtung",
  "text3555": "Einsatzort",
  "text3556": "Art der Operation",
  "text3557": "Größe (m²)",
  "text3558": "Geplante Zeit",
  "text3559": "Tel. Nummer",
  "text3560": "Ihre Daten",
  "text3561": "CV ist gesperrt",
  "text3562": "Lebenslauf nur nach dem Kauf verfügbar. Nach der Freischaltung wird das vollständige Profil des Bewerbers angezeigt.",
  "text3563": "Wachhund",
  "text3564": "Watchdog erfolgreich erstellt",
  "text3565": "Wir informieren Sie, sobald dieses Produkt wieder verfügbar ist",
  "text3566": "Watchdog konnte nicht erstellt werden",
  "text3567": "Geben Sie Ihre E-Mail-Adresse ein, um benachrichtigt zu werden, wenn dieses Produkt wieder auf Lager ist",
  "text3568": "Wachhunde",
  "text3569": "Watchdog wurde entfernt",
  "text3570": "Watchdog konnte nicht entfernt werden",
  "text3571": "Sie haben keine Watchdogs eingestellt",
  "text3572": "Kostenlose Oberteile",
  "text3573": "Quatro-Rechner",
  "text3574": "Wählen Sie eine GLS-Steckdose aus",
  "text3575": "Projektbeschreibung",
  "text3576": "An welcher Umsetzung haben Sie Interesse?",
  "text3577": "Auswählen",
  "text3578": "Projektstandort",
  "text3579": "Adresse eingeben",
  "text3580": "Voraussichtlicher Termin der Umsetzung",
  "text3581": "Name / Firma\n",
  "text3582": "Name / Firmenname eingeben",
  "text3583": "E-Mail eingeben",
  "text3584": "Telefonnummer eingeben",
  "text3585": "Ihre Nachricht",
  "text3586": "Nachricht",
  "text3587": "Mit dem Absenden stimmen Sie Folgendem zu",
  "text3588": "Entdecken Sie unsere Leistungen",
  "text3589": "Weitere Realisierungen anzeigen",
  "text3590": "Haben Sie weitere Fragen?",
  "text3591": "Haben Sie noch eine andere Frage oder haben Sie keine Antwort gefunden?",
  "text3592": "Arbeitszeit",
  "text3593": "Maßanfertigung",
  "text3594": "Hochwertige Materialien",
  "text3595": "Detail der Ausführung",
  "text3596": "Umsetzungsprozess",
  "text3597": "Newsletter abonnieren",
  "text3598": "Holen Sie sich die aktuellsten Informationen von KAUFMANN.",
  "text3599": "Ihre E-Mail",
  "text3600": "Mit der Anmeldung zum Newsletter stimmen Sie Folgendem zu",
  "text3601": "Auf der Karte anzeigen",
  "text3602": "oder",
  "text3603": "Unsere Mitarbeiter stehen Ihnen zur Verfügung in",
  "text3604": "Werktags von 8:00 bis 16:00 Uhr",
  "text3605": "Lager",
  "text3606": "Laden Sie weitere Implementierungen",
  "text3607": "In dieser Kategorie wurden keine Ergebnisse gefunden.",
  "text3608": "Ein meistverkauftes Produkt schaffen",
  "text3609": "Modifikation des meistverkauften Produkts",
  "text3610": "Das meistverkaufte Produkt wird gelöscht",
  "text3611": "Bericht",
  "text3612": "Grund für die Meldung",
  "text3613": "Abschluss",
  "text3614": "Nächte",
  "text3615": "Datum der Reise",
  "text3616": "Länge der Tour",
  "text3617": "Preis ab",
  "text3618": "Auf Anfrage",
  "text3619": "Tourdetails anzeigen",
  "text3620": "Offene Stellen",
  "text3621": "Ich aktualisiere die Bedingungen",
  "text3622": "Alle Touren sind ausgeblendet",
  "text3623": "Für den ausgewählten Zeitraum sind keine Touren verfügbar",
  "text3624": "Reduzieren",
  "text3625": "Vollbild",
  "text3626": "Die Daten konnten nicht geladen werden",
  "text3627": "Unterkategorien",
  "text3628": "Auswahl entfernen",
  "text3629": "Ein Angebot melden",
  "text3630": "Berichterstattung des Unternehmens",
  "text3631": "Lebenslauf-Einreichung",
  "text3632": "Der Bericht konnte nicht gesendet werden",
  "text3633": "Bericht wurde gesendet",
  "text3634": "Biografien",
  "text3635": "Biografien",
  "text3636": "Bestellung in Bearbeitung",
  "text3637": "Startseite",
  "text3638": "Bestellzahlung wird erstellt",
  "text3639": "Anpassung der Bestellzahlung",
  "text3640": "Bestellzahlung wird gelöscht",
  "text3641": "Werden Sie unser exklusiver Partner.",
  "text3642": "Melden Sie sich an, um Neuigkeiten und Informationen zu erhalten\nneue Funktionen hinzugefügt.",
  "text3643": "Neue Eigenschaften",
  "text3644": "Immobilien zum Spitzenpreis",
  "text3645": "Referenzen zufriedener Kunden",
  "text3646": "Sehen Sie, was unsere Kunden über uns denken.",
  "text3647": "Lesen Sie Artikel über Sehenswürdigkeiten in Zypern",
  "text3648": "Alle Fotos",
  "text3649": "Teilen",
  "text3650": "Fertigstellungsdatum",
  "text3651": "Beschreibung der Immobilie",
  "text3652": "Rundgang durch das Resort",
  "text3653": "PDF generieren",
  "text3654": "Eine Tour reservieren",
  "text3655": "Wählen Sie einen Online-Beratungstermin",
  "text3656": "Immobilien in Nordzypern",
  "text3657": "Anzahl der Zimmer",
  "text3658": "Immobilienbüro",
  "text3659": "Immobilien",
  "text3660": "Weiterverkauf / Intercia bezahlt",
  "text3661": "Vereinbaren Sie einen Beratungstermin",
  "text3662": "Der Zoom-Call dauert maximal 1 Stunde und wir beantworten alle Ihre Fragen + Sie erhalten\n              Kostenlose Präsentation aller verfügbaren Projekte, die wir in Zypern haben.",
  "text3663": "Angebote",
  "text3664": "Haben Sie weitere Fragen? Gerne stellen wir Ihnen das HASQO-Konzept in der Praxis vor.",
  "text3665": "Fordern Sie eine Beratung an",
  "text3666": "Kundenzone",
  "text3667": "Versand",
  "text3668": "Liefererfolg",
  "text3669": "Kundenzeile",
  "text3670": "Ich möchte ein Angebot einholen",
  "text3671": "Mit der Anmeldung zum Newsletter erklären Sie sich damit einverstanden",
  "text3672": "Wählen Sie aus Nachrichten",
  "text3673": "Einkaufen nach Kategorie",
  "text3674": "TOP-Auswahl an Produkten",
  "text3675": "Abonnieren Sie den Newsletter und erhalten Sie immer aktuelle Informationen zu Aktionen und Neuigkeiten.",
  "text3676": "Ihre E-Mail-Adresse...",
  "text3677": "Sichere Kaufgarantie",
  "text3678": "Transportmittel",
  "text3679": "Unsere Erkenntnisse",
  "text3680": "Sammlungen",
  "text3681": "Alle Sammlungen anzeigen",
  "text3682": "Sie vertrauen uns",
  "text3683": "Verifiziert und erhalten von Google",
  "text3684": "Alle Rezensionen",
  "text3685": "Verifiziert",
  "text3686": "Alle Filter",
  "text3687": "Es wurden keine Produkte gefunden",
  "text3688": "Tiefe",
  "text3689": "Holen Sie sich ein Angebot für Ihre Sendung",
  "text3690": "Web erstellt",
  "text3691": "von 9:00 bis 17:00 Uhr",
  "text3692": "Über den Service",
  "text3693": "Was beinhaltet der Service?",
  "text3694": "Für welche Sendungen ist der Service geeignet?",
  "text3695": "Wie geht es?",
  "text3696": "Anderen Dienst anzeigen",
  "text3697": "Was unsere zufriedenen Kunden sagen",
  "text3698": "Registrierungs-E-Mail",
  "text3699": "Füllen Sie das Formular aus und erhalten Sie ein Angebot",
  "text3700": "Nach Sendung suchen",
  "text3701": "Schreiben Sie uns eine Nachricht",
  "text3702": "Holen Sie sich ein Angebot",
  "text3703": "Beenden",
  "text3704": "Treuesystem",
  "text3705": "Die Lieferadresse ist dieselbe wie die Rechnungsadresse",
  "text3706": "Name der Kontaktperson",
  "text3707": "Nachname der Kontaktperson",
  "text3708": "Die E-Mail-Adresse kann nicht geändert werden, bitte kontaktieren Sie unseren Support.",
  "text3709": "Ratschläge, Trends und praktische Artikel",
  "text3710": "Weitere Artikel, die Sie interessieren könnten",
  "text3711": "Operator",
  "text3712": "Brauchen Sie Rat?\nKontaktieren Sie uns und wir helfen Ihnen gerne weiter.",
  "text3713": "Kontaktieren Sie unseren Kundensupport oder schreiben Sie uns über das Kontaktformular und unsere Mitarbeiter beraten Sie gerne.",
  "text3714": "Ihr Anliegen",
  "text3715": "Anfrage zur Passwortänderung senden",
  "text3716": "Artikel in der richtigen Reihenfolge",
  "text3717": "Bestellbetrag",
  "text3718": "wurde aufgezeichnet. Wir warten auf die Zahlung und beginnen nach der Gutschrift auf unserem Konto mit der Umsetzung. Bitte überprüfen Sie Ihre E-Mails",
  "text3719": "Siehe verfügbare Positionen",
  "text3720": "Neuestes Angebot",
  "text3721": "Werden Sie Teil unseres Teams",
  "text3722": "Füllen Sie das Formular aus und senden Sie uns Ihren Lebenslauf. Wenn Ihr Profil uns interessiert und Ihren Anforderungen entspricht, werden wir uns mit Ihnen in Verbindung setzen.",
  "text3723": "Senden Sie uns Ihren Lebenslauf",
  "text3724": "Ladeort",
  "text3725": "Ziel Ziel",
  "text3726": "Art der Ware",
  "text3727": "Gewicht (ca.)",
  "text3728": "Volumen (m3)",
  "text3729": "Route anzeigen",
  "text3730": "Bestellung abschließen",
  "text3731": "Variante",
  "text3732": "Rabattcode eingeben",
  "text3733": "Punkte verwenden",
  "text3734": "Anzahl der Punkte (ganze Zahl einfügen)",
  "text3735": "Warnung: Eine zusätzliche Kundenänderung auf der Rechnung ist nicht möglich.",
  "text3736": "Ich möchte für ein Unternehmen kaufen",
  "text3737": "Die Lieferadresse weicht von der Rechnungsadresse ab",
  "text3738": "Rechnungs- und Lieferinformationen",
  "text3739": "Ihre Bestellung wurde versendet",
  "text3740": "Wir haben Ihre Bestellung unter der Nummer registriert",
  "text3741": "Wir versenden die Bestellbestätigung an die bei der Bestellung angegebene E-Mail-Adresse.",
  "text3742": "Zurück zur Hauptseite",
  "text3743": "Gesuchte Produkte",
  "text3744": "Artikel",
  "text3745": "Alle Suchanfragen anzeigen",
  "text3746": "Produktvergleich",
  "text3747": "Keine Produkte zum Vergleichen. Fügen Sie Produkte hinzu, indem Sie auf das Vergleichssymbol klicken.",
  "text3748": "Gewicht",
  "text3749": "Farbvarianten",
  "text3750": "Ihr Konto wurde erfolgreich erstellt",
  "text3751": "Registrieren Sie sich hier",
  "text3752": "1 Kurs = 5 Schulungen",
  "text3753": "Mit der Anmeldung zum Newsletter erklären Sie sich damit einverstanden",
  "text3754": "Lesen Sie unsere praktischen Artikel oder lassen Sie sich von Teakmöbel-Trends inspirieren.",
  "text3755": "Angebot ansehen",
  "text3756": "Aktionsprodukte",
  "text3757": "Frachttyp wird erstellt",
  "text3758": "Änderung des Ladungstyps",
  "text3759": "Ladungstyp löschen",
  "text3760": "Ladung erstellen",
  "text3761": "Anpassung laden",
  "text3762": "Ladung wird gelöscht",
  "text3763": "Reservierungszahlung wird erstellt",
  "text3764": "Anpassung der Reservierungszahlung",
  "text3765": "Löschen der Reservierungszahlung",
  "text3766": "Über die Unterkunft",
  "text3767": "Ihre Daten sind sicher",
  "text3768": "Mach mehr als",
  "text3769": "zufriedener Kunde",
  "text3770": "Verifiziert und erhalten von Google",
  "text3771": "Öffnungszeiten des Ausstellungsraums",
  "text3772": "Mit dem Kauf dieses Produkts erhalten Sie",
  "text3773": "Punkte",
  "text3774": "Sie haben auf Ihrem Konto",
  "text3775": "Beschreiben Sie das Produkt",
  "text3776": "(+) Positiv",
  "text3777": "(-) Negativ",
  "text3778": "Positiv hinzufügen",
  "text3779": "Negativ hinzufügen",
  "text3780": "Das übergeordnete Element kann nicht dieses Element oder sein untergeordnetes Element sein.",
  "text3781": "Die Umsatzsteuer-Identifikationsnummer ist ungültig",
  "text3782": "Die eingegebene Umsatzsteuer-Identifikationsnummer ist ungültig",
  "text3783": "Sie haben {{param}} Punkte",
  "text3784": "Reservierungssystem",
  "text3785": "Sie können max.",
  "text3786": "Punkte eingelöst",
  "text3787": "Studiovermietung",
  "text3788": "Anzahl der Punkte",
  "text3789": "Verkauf beendet",
  "text3790": "Wir bereiten dieses Produkt derzeit vor",
  "text3791": "Ich möchte ein Angebot",
  "text3792": "Preisangebot innerhalb von 24 Stunden",
  "text3793": "Benötigen Sie ein Angebot für Ihr Projekt? Wir antworten Ihnen innerhalb von 24 Stunden.",
  "text3794": "Fachgerechtes Schweißen und Metallbearbeitung auf professionellem Niveau",
  "text3795": "Unser Team steht bereit, Ihr Projekt sofort zu starten. Kontaktieren Sie uns noch heute.",
  "text3796": "oder rufen Sie uns an",
  "text3797": "Füllen Sie das Anfrageformular aus, und wir werden uns schnellstmöglich mit Ihnen in Verbindung setzen, um Ihr Projekt im Detail zu besprechen.",
  "text3798": "Unsere neuesten Erkenntnisse",
  "text3799": "Wir sind europaweit tätig",
  "text3800": "Was können wir unseren Partnern bieten?",
  "text3801": "Stellenangebote anzeigen",
  "text3802": "Für welchen Service sind Sie interessiert?",
  "text3803": "Wählen Sie einen Dienst aus der Liste aus.",
  "text3804": "Gewünschter Liefertermin",
  "text3805": "Projektdokumentation",
  "text3806": "Hängen Sie eine Datei an",
  "text3807": "Mit dem Absenden einer Nachricht stimmen Sie der Verarbeitung Ihrer personenbezogenen Daten zum Zweck der Kontaktaufnahme zu.",
  "text3808": "Wir haben momentan keine offenen Stellen.",
  "text3809": "In dieser Kategorie wurden keine Einträge gefunden.",
  "text3810": "Löschen Sie die Datei",
  "text3811": "Nach Eingang Ihres ausgefüllten Angebotsformulars werde ich mich schnellstmöglich mit einem Angebot bei Ihnen melden. Vielen Dank für Ihre Geduld.",
  "text3812": "Ich bin an einem Stellenangebot interessiert.",
  "text3813": "Verwendete Dienste",
  "text3814": "Schritt",
  "text3815": "Wir realisieren Projekte innerhalb der EU – hauptsächlich in Deutschland, Österreich, Tschechien und der Slowakei, aber auch in anderen Ländern je nach Bedarf des Kunden.",
  "text3816": "Fordern Sie noch heute ein Angebot für Ihr Projekt an!",
  "text3817": "Beginn der Arbeit",
  "text3818": "Beschäftigungsart",
  "text3819": "Gehalt (brutto)",
  "text3820": "Über die Umsetzung",
  "text3821": "Andere Erkenntnisse",
  "text3822": "Zurück zu allen Artikeln",
  "text3823": "Weitere Artikel",
  "text3824": "Inhalt",
  "text3825": "Weiter durch",
  "text3826": "oder",
  "text3827": "Anmeldung fehlgeschlagen",
  "text3828": "Für die Registrierung über ein soziales Konto ist eine Einwilligung zur Verarbeitung personenbezogener Daten erforderlich.",
  "text3829": "Die Anmeldung war erfolgreich",
  "text3830": "Die E-Mail-Adresse des sozialen Kontos ist nicht verifiziert.",
  "text3831": "Das Benutzerkonto kann nicht angemeldet werden.",
  "text3832": "Die Anmeldung über das soziale Konto ist abgelaufen.",
  "text3833": "Die Anmeldung über das soziale Konto ist fehlgeschlagen.",
  "text3834": "Suche nach Medikamenten, Vitaminen, Kosmetika...",
  "text3835": "Link in die Zwischenablage kopiert",
  "text3836": "Paketnummer / Sendungsverfolgungsnummer...",
  "text3837": "Hier abbrechen",
  "text3838": "Das könnte Sie auch interessieren.",
  "text3839": "Mehr über die Kategorie",
  "text3840": "Registriertes Konto",
  "text3841": "Warenrückgabe - Vertragsrücktritt",
  "text3842": "Reparatur der Ware",
  "text3843": "",
  "text3844": "Produkte filtern",
  "text3845": "Zusammenfassung der Einreichung",
  "text3846": "Eintritt",
  "text3847": "Beendigung",
  "text3848": "Neue Anspruchsnr.:",
  "text3849": "Sicher einkaufen",
  "text3850": "Zurücksetzen",
  "text3851": "Vollständige Beschreibung lesen",
  "text3852": "Verpackungsinhalt",
  "text3853": "Wenn Sie sich jetzt registrieren, erhalten Sie:",
  "text3854": "Kostenlose Angebote",
  "text3855": "Kostenlose Toppings",
  "text3856": "Kostenlose Kurse",
  "text3857": "Die Quoten umsonst übertreffen",
  "text3858": "Kostenloser Zugang zu Biografien",
  "text3859": "für Ihr Abonnement",
  "text3860": "Der Flottenzugangscode wurde erstellt:",
  "text3861": "Sie können diesen Code mit Benutzern teilen, um Ihrem Abonnement beizutreten.",
  "text3862": "Maximale Mitgliederzahl:",
  "text3863": "Flottenabonnementcode",
  "text3864": "Für die Einreichung einer weiteren Unfallmeldung ist ein aktives Abonnement erforderlich.",
  "text3865": "Rücktritt vom Vertrag bestätigen",
  "text3866": "Rücktritt vom Vertrag Nr.:",
  "text3867": "Warenaustausch-Nr.:",
  "text3868": "Beschwerde-Nr.:",
  "text3869": "Warenaustausch",
  "text3870": "Rücktritt vom Vertrag",
  "text3871": "Behauptung",
  "text3872": "Über 1750 Originalteile auf Lager",
  "text3873": "Welches Teil suchen Sie?",
  "text3874": "Finden Sie das nächstgelegene Geschäft",
  "text3875": "Katalog öffnen",
  "text3876": "Alle anzeigen",
  "text3877": "Ersatzteile",
  "text3878": "Kundenrezensionen",
  "text3879": "Um eine Produktbewertung hinzuzufügen, ist eine Anmeldung erforderlich",
  "text3880": "Rabattcode",
  "text3881": "Geben Sie den Code ein",
  "text3882": "Zusammenfassung der Bestellung",
  "text3883": "Fahren Sie mit Versand und Zahlung fort",
  "text3884": "Weiter zu den Lieferdetails",
  "text3885": "Weiter zur Bestellübersicht",
  "text3886": "Hinweis zur Bestellung",
  "text3887": "Bestellung bestätigt!",
  "text3888": "Vielen Dank für Ihren Einkauf",
  "text3889": "Wir haben eine Bestätigung an gesendet",
  "text3890": "Was kommt als nächstes?",
  "text3891": "Bestellung bearbeitet",
  "text3892": "Ihre Zahlung war erfolgreich.",
  "text3893": "Vorbereitung des Pakets",
  "text3894": "Das Lager bereitet Ihre Bestellung vor",
  "text3895": "Übergabe an den Spediteur",
  "text3896": "Der Spediteur übernimmt das Paket zur Lieferung.",
  "text3897": "Lieferung",
  "text3898": "Sie werden kontaktiert",
  "text3899": "Öffnungszeiten",
  "text3900": "Expedition und Lager",
  "text3901": "Träger",
  "text3902": "Produkte in der Sammlung",
  "text3903": "Diese Sammlung enthält keine Produkte",
  "text3904": "Weitere Artikel anzeigen",
  "text3905": "Preisrechner",
  "text3906": "Ich interessiere mich für eine Besichtigung.",
  "text3907": "Ich interessiere mich für das Angebot.",
  "text3908": "Vereinbaren Sie ein kostenloses Beratungsgespräch.",
  "text3909": "Eine Angebotsanfrage einreichen",
  "text3910": "Details anzeigen",
  "text3911": "5 weitere Fragen anzeigen",
  "text3912": "Starten Sie noch heute",
  "text3913": "Fordern Sie ein unverbindliches Angebot für eine Abwasserbehandlungsanlage an.",
  "text3914": "Würden Sie lieber anrufen?",
  "text3915": "Mo–Fr, 8:00–17:00 Uhr",
  "text3916": "Ich bin in der Nähe des Bachs.",
  "text3917": "Wie viele Personen werden die Kläranlage nutzen?",
  "text3918": "Ich habe ein Grundstück in Hanglage.",
  "text3919": "Kostenvergleich",
  "text3920": "Warum eine Pflanzenkläranlage eine bessere Wahl ist als eine Sickergrube oder eine Belebtschlammanlage",
  "text3921": "Jährliche Betriebskosten",
  "text3922": "Gesamtkosten über 10 Jahre",
  "text3923": "Problemloser Betrieb",
  "text3924": "Von der Bestellung bis zum Start",
  "text3925": "Ablauf der Installation einer Abwasserreinigungsanlage",
  "text3926": "Mechanische Vorreinigung in der Klärgrube",
  "text3927": "Biologische Behandlung mittels Bakterien",
  "text3928": "Wurzelraumfiltration unter Einsatz von Pflanzen",
  "text3929": "Ein natürlicher 4-Schritte-Prozess",
  "text3930": "Funktionsweise einer Pflanzenkläranlage",
  "text3931": "Detaillierte Anleitung",
  "text3932": "Abwasserkläranlagen für Einfamilienhäuser in der Slowakei",
  "text3933": "Warum ECOPLANET SLOVAKIA?",
  "text3934": "Umfassender Leitfaden",
  "text3935": "Abwasserreinigungsanlage ECOKOCKA",
  "text3936": "auf Anfrage",
  "text3937": "individuelle Berechnung",
  "text3938": "Antworten auf Ihre Fragen",
  "text3939": "Häufig gestellte Fragen zu Abwasserbehandlungsanlagen",
  "text3940": "Ihre Garantie",
  "text3941": "Warum Sie ECOPLANET SLOVAKIA vertrauen sollten",
  "text3942": "Praktische Informationen",
  "text3943": "Was Sie vor dem Kauf einer Abwasserreinigungsanlage wissen sollten",
  "text3944": "Praxiserfahrungen",
  "text3945": "Was unsere Kunden sagen",
  "text3946": "Google-Rezension",
  "text3947": "Verwenden Sie die Pfeile, um zu weiteren Bewertungen zu scrollen.",
  "text3948": "Die gesamte Slowakei",
  "text3949": "Wir installieren Abwasserreinigungsanlagen in der gesamten Slowakei.",
  "text3950": "Haushalte",
  "text3951": "quer durch die Slowakei",
  "text3952": "Gemeinden und Gästehäuser",
  "text3953": "Häufig gestellte Fragen zu Abwasserbehandlungsanlagen",
  "text3954": "Seitentitel",
  "text3955": "Ansprechpartner",
  "text3956": "Kontaktadresse",
  "text3957": "Termine und Preise",
  "text3958": "Tourbeschreibung",
  "text3959": "Videos",
  "text3960": "Turnus",
  "text3961": "Anzahl der Tage / Nächte",
  "text3962": "Reserviert",
  "text3963": "Unbekannter Status",
  "text3964": "Im Preis inbegriffen",
  "text3965": "Der Preis beinhaltet nicht",
  "text3966": "Alle Touren",
  "text3967": "Termin vereinbaren",
  "text3968": "Einen Termin vereinbaren",
  "text3969": "Melden Sie sich für den Newsletter an",
  "text3970": "Seien Sie der Erste, der von Kot, Terminen und Rabatten erfährt.",
  "text3971": "Mit dem Absenden stimmen Sie der Verarbeitung personenbezogener Daten zu.",
  "text3972": "Begriffsübersicht",
  "text3973": "Sehen Sie sich das Programm an",
  "text3974": "Ähnliche Touren",
  "text3975": "Erfüllt",
  "text3976": "Alle Termine haben bereits stattgefunden",
  "text3977": "Lesen Sie Artikel über Madeira!",
  "text3978": "Unverbindliche Reservierung",
  "text3979": "Unverbindliche Tourreservierung",
  "text3980": "Unverbindliche Reservierung",
  "text3981": "Geben Sie Ihre Telefonnummer ein. Nummer",
  "text3982": "Fügen Sie einen weiteren Teilnehmer hinzu",
  "text3983": "Teilnehmer löschen",
  "text3984": "Besprechungstyp",
  "text3985": "Begegnungsstadt",
  "text3986": "Datum und Uhrzeit",
  "text3987": "Weiter",
  "text3988": "Wird gesendet...",
  "text3989": "Reservierung bestätigen",
  "text3990": "Wählen Sie einen Treffpunkt",
  "text3991": "Treffpunkt",
  "text3992": "Abonnieren Sie den Newsletter und erhalten Sie immer die aktuellsten Informationen aus unserem Angebot.",
  "text3993": "Wo finden Sie uns?",
  "text3994": "Was macht unser Reisebüro DISCOVER THE WORLD besonders?",
  "text3995": "Büro (Betrieb)",
  "text3996": "INFORMATIKA-Gebäude im 2. Stock",
  "text3997": "Vielen Dank für Ihre Reservierung!...",
  "text3998": "Nächste Touren",
  "text3999": "Geben Sie die Kontaktdaten und das ungefähre Budget ein.",
  "text4000": "Ich frage wie",
  "text4001": "6.000 und mehr",
  "text4002": "Was sollen wir für Sie vorbereiten?",
  "text4003": "Die Anfrage wurde gesendet",
  "text4004": "Vielen Dank. Nach der Bearbeitung senden wir Ihnen per E-Mail ein Angebot zu.",
  "text4005": "Bewerbungsnr",
  "text4006": "Senden Sie eine weitere Anfrage",
  "text4007": "Das maximale Budget muss höher sein als das minimale.",
  "text4008": "Aktivieren Sie die markierten Kästchen.",
  "text4009": "Sie haben zu viele Anfragen eingereicht. Bitte versuchen Sie es gleich noch einmal.",
  "text4010": "",
  "text4011": "",
  "text4012": "",
  "text4013": "",
  "text4014": "",
  "text4015": "",
  "text4016": "",
  "text4017": "",
  "text4018": "",
  "text4019": "",
  "text4020": "",
  "text4021": "",
  "text4022": "",
  "text4023": "",
  "text4024": "",
  "text4025": "",
  "text4026": "",
  "text4027": "",
  "text4028": "",
  "text4029": "",
  "text4030": "",
  "text4031": "",
  "text4032": "",
  "text4033": "",
  "text4034": "",
  "text4035": "",
  "text4036": "",
  "text4037": "",
  "text4038": "",
  "text4039": "",
  "text4040": "",
  "text4041": "",
  "text4042": "",
  "text4043": "",
  "text4044": "",
  "text4045": "",
  "text4046": "",
  "text4047": "",
  "text4048": "",
  "text4049": "",
  "text4050": "",
  "text4051": "",
  "text4052": "Sind dies Ihre Unternehmensdaten?",
  "text4053": "Einzelpreis inkl. MwSt.",
  "text4054": "Gutschein entfernen",
  "text4055": "Inaktiv",
  "text4056": "Versichert",
  "text4057": "Nicht versichert",
  "text4058": "Fahrzeug hinzufügen",
  "text4059": "Fahrzeug bearbeiten",
  "text4060": "Fahrzeug löschen?",
  "text4061": "Meine Garage",
  "text4062": "Datum der Haupt- und Abgasuntersuchung",
  "text4063": "Der Export ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "text4064": "Video pausieren",
  "text4065": "Material",
  "text4066": "Neue Konfiguration",
  "text4067": "Konfigurationsschritte",
  "text4068": "Datei hochladen",
  "text4069": "Termin vereinbaren",
  "text4070": "Link konnte nicht kopiert werden",
  "text4071": "Daten wurden erfolgreich aktualisiert",
  "text4072": "Zum Vergleich hinzufügen",
  "text4073": "Aus dem Vergleich entfernen",
  "text4074": "Zurück zur Liste",
  "text4075": "Region",
  "text4076": "Kataloge",
  "text4077": "Mein Fuhrpark",
  "text4078": "Schadenübersicht",
  "text4079": "Kennzeichen",
  "text4080": "Abflugdatum und -zeit",
  "text4081": "Ankunftsdatum und -zeit",
  "text4082": "Ticketnummer",
  "text4083": "Reisepassnummer",
  "text4084": "Zurück zu den Parametern",
  "text4085": "Zusammenfassung & Kontakt",
  "text4086": "Konfiguration wurde gesendet",
  "text4087": "Niedrigstes Gehalt",
  "text4088": "Höchstes Gehalt",
  "text4089": "Konfigurationsübersicht",
  "text4090": "Aktualisiert:",
  "text4091": "Kontakt-E-Mail *",
  "text4092": "Konfigurationen werden geladen...",
  "text4093": "Code anwenden",
  "text4094": "Notiz (optional)...",
  "text4095": "Entwurfskonfigurationen",
  "text4096": "Hier sind noch keine Produkte vorhanden",
  "text4097": "Konfiguration konnte nicht geladen werden",
  "text4098": "Konfiguration konnte nicht gesendet werden",
  "text4099": "Konfiguration konnte nicht geöffnet werden",
  "text4100": "Konfiguration konnte nicht gespeichert werden",
  "text4101": "Aus dem Register laden",
  "text4102": "Geschätzter Preis",
  "text4103": "Gesendet",
  "text4104": "Gesendete Preisangebote",
  "text4105": "Wir senden das Preisangebot per E-Mail",
  "text4106": "zum Zweck der Erstellung eines Preisangebots gemäß DSGVO.",
  "text4107": "Frage zum Produkt hinzufügen",
  "text4108": "",
  "text4109": "",
  "text4110": "",
  "text4111": "",
  "text4112": "",
  "text4113": "",
  "text4114": "",
  "text4115": "",
  "text4116": "",
  "text4117": "",
  "text4118": "",
  "text4119": "",
  "text4120": "",
  "text4121": "",
  "text4122": "",
  "text4123": "",
  "text4124": "",
  "text4125": "",
  "text4126": "",
  "text4127": "",
  "text4128": "",
  "text4129": "",
  "text4130": "",
  "text4131": "",
  "text4132": "",
  "text4133": "",
  "text4134": "",
  "text4135": "",
  "text4136": "",
  "text4137": "",
  "text4138": "",
  "text4139": "",
  "text4140": "",
  "text4141": "",
  "text4142": "",
  "text4143": "",
  "text4144": "",
  "text4145": "",
  "text4146": "",
  "text4147": "",
  "text4148": "",
  "text4149": "",
  "text4150": ""
}) satisfies TranslationDictionary;
